msgid ""
msgstr ""
"POT-Creation-Date: 2026-09-10 11:57-0400\n"
"MIME-Version: 1.0\n"
"Content-Type: text/plain; charset=utf-8\n"
"Content-Transfer-Encoding: 8bit\n"
"X-Generator: @lingui/cli\n"
"Language: en-US\n"
"Project-Id-Version: \n"
"Report-Msgid-Bugs-To: \n"
"PO-Revision-Date: \n"
"Last-Translator: \n"
"Language-Team: \n"
"Plural-Forms: \n"

#: src/pages/DashboardPage.tsx:382
msgid "(Admin)"
msgstr "(Admin)"

#: src/pages/SubscriptionPage.tsx:886
msgid "(Canceling)"
msgstr "(Canceling)"

#: src/pages/AgentsPage.tsx:1086
msgid "(default)"
msgstr "(default)"

#: src/pages/UserManagementPage.tsx:241
msgid "(Personal Account)"
msgstr "(Personal Account)"

#: src/components/Layout.tsx:302
msgid "(Personal)"
msgstr "(Personal)"

#. placeholder {0}: agents.length
#: src/pages/AgentsPage.tsx:430
msgid "{0, plural, one {# agent} other {# agents}}"
msgstr "{0, plural, one {# agent} other {# agents}}"

#. placeholder {0}: log.agentExecutions.length
#: src/pages/UserDetailAuditPage.tsx:869
msgid "{0, plural, one {# AGENT} other {# AGENTS}}"
msgstr "{0, plural, one {# AGENT} other {# AGENTS}}"

#. placeholder {0}: entity.factCount
#: src/pages/MemoryPage.tsx:1290
msgid "{0, plural, one {# memory} other {# memories}}"
msgstr "{0, plural, one {# memory} other {# memories}}"

#. placeholder {0}: allSessionPrompts.length
#: src/pages/UserDetailAuditPage.tsx:405
msgid "{0, plural, one {# prompt in this conversation} other {# prompts in this conversation}}"
msgstr "{0, plural, one {# prompt in this conversation} other {# prompts in this conversation}}"

#. placeholder {0}: log.sessionPrompts?.length ?? 0
#. placeholder {0}: selectedAudit.metadata.promptCount
#: src/pages/UserDetailAuditPage.tsx:860
#: src/pages/UserDetailAuditPage.tsx:955
msgid "{0, plural, one {# prompt} other {# prompts}}"
msgstr "{0, plural, one {# prompt} other {# prompts}}"

#. placeholder {0}: log.agentExecutions.length
#: src/pages/UserDetailAuditPage.tsx:867
msgid "{0, plural, one {Agent: {agentNames}} other {Agents: {agentNames}}}"
msgstr "{0, plural, one {Agent: {agentNames}} other {Agents: {agentNames}}}"

#. placeholder {0}: appliedPromo.code
#. placeholder {1}: pricing.perSeatLabel
#: src/components/UpgradeModal.tsx:230
msgid "{0} applied: {1}/seat for your first month"
msgstr "{0} applied: {1}/seat for your first month"

#. placeholder {0}: appliedPromo.code
#. placeholder {1}: pricing.perSeatLabel
#: src/components/UpgradeModal.tsx:234
msgid "{0} applied: {1}/seat/mo"
msgstr "{0} applied: {1}/seat/mo"

#. placeholder {0}: appliedPromo.code
#. placeholder {1}: pricing.perSeatLabel
#: src/components/UpgradeModal.tsx:232
msgid "{0} applied: {1}/seat/mo for as long as you stay"
msgstr "{0} applied: {1}/seat/mo for as long as you stay"

#. placeholder {0}: appliedPromo.code
#. placeholder {1}: pricing.perSeatLabel
#. placeholder {2}: duration.months
#: src/components/UpgradeModal.tsx:228
msgid "{0} applied: {1}/seat/mo for your first {2} months"
msgstr "{0} applied: {1}/seat/mo for your first {2} months"

#: src/components/UpgradeModal.tsx:164
#~ msgid "{0} applied: {1}% off your first {2} months"
#~ msgstr "{0} applied: {1}% off your first {2} months"

#: src/components/UpgradeModal.tsx:166
#~ msgid "{0} applied: {1}% off your first year"
#~ msgstr "{0} applied: {1}% off your first year"

#. placeholder {0}: agentPrompt.length
#: src/pages/AgentsPage.tsx:870
msgid "{0} chars"
msgstr "{0} chars"

#. placeholder {0}: dict.deny_list_count
#: src/pages/AgentsPage.tsx:714
#: src/pages/DictionaryManagementPage.tsx:264
msgid "{0} deny list"
msgstr "{0} deny list"

#. placeholder {0}: conn.serviceName
#: src/pages/ConnectionsPage.tsx:392
msgid "{0} disconnected"
msgstr "{0} disconnected"

#. placeholder {0}: totalTokensIn.toLocaleString()
#. placeholder {1}: totalTokensOut.toLocaleString()
#: src/pages/DashboardPage.tsx:366
msgid "{0} in · {1} out"
msgstr "{0} in · {1} out"

#. placeholder {0}: valid.code
#. placeholder {1}: valid.trialDays
#. placeholder {2}: valid.maxSeats
#: src/components/UpgradeModal.tsx:405
msgid "{0} is good for {1} days of Max across up to {2} seats. When it ends your company drops back to Pro, with nothing to cancel."
msgstr "{0} is good for {1} days of Max across up to {2} seats. When it ends your company drops back to Pro, with nothing to cancel."

#. placeholder {0}: valid.code
#. placeholder {1}: valid.trialDays
#: src/components/UpgradeModal.tsx:409
msgid "{0} is good for {1} days of Max company-wide. When it ends your company drops back to Pro, with nothing to cancel."
msgstr "{0} is good for {1} days of Max company-wide. When it ends your company drops back to Pro, with nothing to cancel."

#. placeholder {0}: valid.code
#: src/components/UpgradeModal.tsx:434
msgid "{0} needs a card"
msgstr "{0} needs a card"

#. placeholder {0}: dict.term_count
#: src/pages/AgentsPage.tsx:713
#: src/pages/DictionaryManagementPage.tsx:263
msgid "{0} terms"
msgstr "{0} terms"

#. placeholder {0}: detail.tokens
#. placeholder {0}: tokens.toLocaleString()
#: src/pages/DashboardPage.tsx:603
#: src/pages/MemoryPage.tsx:1353
msgid "{0} tokens"
msgstr "{0} tokens"

#. placeholder {0}: moneyLabel(monthly)
#: src/pages/SubscriptionPage.tsx:106
msgid "{0}/mo"
msgstr "{0}/mo"

#. placeholder {0}: maxPricing.perSeatLabel
#: src/pages/SignupPage.tsx:634
msgid "{0}/seat/mo"
msgstr "{0}/seat/mo"

#. placeholder {0}: optionSlot.perSeatAmount
#: src/components/UpgradeModal.tsx:205
msgid "{0}/seat/mo billed yearly"
msgstr "{0}/seat/mo billed yearly"

#: src/pages/SignupPage.tsx:656
#~ msgid "{0}% off"
#~ msgstr "{0}% off"

#. placeholder {0}: subscriptionDetails.discount.coupon.percent_off
#: src/pages/SubscriptionPage.tsx:938
msgid "{0}% OFF"
msgstr "{0}% OFF"

#. placeholder {0}: (executionModal.elapsedMs / 1000).toFixed(1)
#: src/pages/AgentsPage.tsx:1056
msgid "{0}s elapsed"
msgstr "{0}s elapsed"

#: src/pages/ConnectionsPage.tsx:684
msgid "{activeCount} Active"
msgstr "{activeCount} Active"

#: src/pages/SubscriptionPage.tsx:84
msgid "{amountStr}/mo"
msgstr "{amountStr}/mo"

#: src/pages/SubscriptionPage.tsx:83
msgid "{amountStr}/mo billed annually"
msgstr "{amountStr}/mo billed annually"

#: src/pages/ConnectionsPage.tsx:743
msgid "{catalogCount} items indexed"
msgstr "{catalogCount} items indexed"

#: src/pages/ConnectionsPage.tsx:742
msgid "{catalogCount} items indexed · Last sync {lastSyncDate}"
msgstr "{catalogCount} items indexed · Last sync {lastSyncDate}"

#: src/utils/licenses.ts:159
msgid "{claimed, plural, one {# {tierLabel} seat is in use past the licensed block.} other {# {tierLabel} seats are in use past the licensed block.}}"
msgstr "{claimed, plural, one {# {tierLabel} seat is in use past the licensed block.} other {# {tierLabel} seats are in use past the licensed block.}}"

#: src/pages/UserDetailAuditPage.tsx:669
msgid "{d}d"
msgstr "{d}d"

#: src/utils/relativeTime.ts:17
msgid "{day}d ago"
msgstr "{day}d ago"

#: src/pages/DashboardPage.tsx:389
msgid "{daysRemaining, plural, one {# day remaining} other {# days remaining}}"
msgstr "{daysRemaining, plural, one {# day remaining} other {# days remaining}}"

#: src/pages/UserDetailAuditPage.tsx:432
msgid "{diffDays}d ago"
msgstr "{diffDays}d ago"

#: src/pages/UserDetailAuditPage.tsx:430
msgid "{diffHours}h ago"
msgstr "{diffHours}h ago"

#: src/pages/UserDetailAuditPage.tsx:429
msgid "{diffMins}m ago"
msgstr "{diffMins}m ago"

#: src/utils/relativeTime.ts:15
msgid "{hr}h ago"
msgstr "{hr}h ago"

#: src/pages/SubscriptionPage.tsx:490
#~ msgid "{maxFeatureLine}. $0 today; first charge after your {trialDays}-day trial."
#~ msgstr "{maxFeatureLine}. $0 today; first charge after your {trialDays}-day trial."

#: src/pages/SubscriptionPage.tsx:406
msgid "{maxFeatureLine}. Billed today, then every renewal until canceled."
msgstr "{maxFeatureLine}. Billed today, then every renewal until canceled."

#: src/utils/relativeTime.ts:14
msgid "{min}m ago"
msgstr "{min}m ago"

#: src/utils/relativeTime.ts:19
msgid "{mon}mo ago"
msgstr "{mon}mo ago"

#: src/pages/DashboardPage.tsx:350
msgid "{monthName}, month to date"
msgstr "{monthName}, month to date"

#: src/pages/OnboardingPage.tsx:481
msgid "{palDisplayName} runs 24 hours a day, seven days a week: silently intercepting, masking, and protecting. You focus on building. Leave the risk management to us."
msgstr "{palDisplayName} runs 24 hours a day, seven days a week: silently intercepting, masking, and protecting. You focus on building. Leave the risk management to us."

#: src/pages/UserDetailAuditPage.tsx:556
msgid "{platformCount, plural, one {# platform} other {# platforms}}"
msgstr "{platformCount, plural, one {# platform} other {# platforms}}"

#: src/components/ProviderDetailModal.tsx:228
#: src/components/ProviderDetailModal.tsx:250
msgid "{providerName} activity report"
msgstr "{providerName} activity report"

#: src/components/ProviderDetailModal.tsx:253
msgid "{providerVendor} · last {days} days · {scopeLabel}"
msgstr "{providerVendor} · last {days} days · {scopeLabel}"

#: src/pages/SubscriptionPage.tsx:106
msgid "{range} seats"
msgstr "{range} seats"

#: src/pages/DashboardPage.tsx:354
msgid "{scopeUserCount, plural, one {# team member} other {# team members}}"
msgstr "{scopeUserCount, plural, one {# team member} other {# team members}}"

#: src/pages/SalesforceOAuthCallbackPage.tsx:55
msgid "{serviceName} authentication completed."
msgstr "{serviceName} authentication completed."

#: src/pages/ConnectionsPage.tsx:183
msgid "{serviceName} authentication failed"
msgstr "{serviceName} authentication failed"

#: src/pages/SalesforceOAuthCallbackPage.tsx:63
msgid "{serviceName} authentication failed."
msgstr "{serviceName} authentication failed."

#: src/pages/ConnectionsPage.tsx:535
msgid "{serviceName} authentication was cancelled."
msgstr "{serviceName} authentication was cancelled."

#: src/pages/ConnectionsPage.tsx:180
msgid "{serviceName} connected successfully"
msgstr "{serviceName} connected successfully"

#: src/pages/ConnectionsPage.tsx:489
msgid "{serviceName} connection could not be verified"
msgstr "{serviceName} connection could not be verified"

#: src/pages/ConnectionsPage.tsx:513
msgid "{serviceName} OAuth start did not return an authorization URL"
msgstr "{serviceName} OAuth start did not return an authorization URL"

#: src/utils/licenses.ts:123
msgid "{tierLabel} seats: {claimed} in use, {licensed} licensed ({over} over)"
msgstr "{tierLabel} seats: {claimed} in use, {licensed} licensed ({over} over)"

#: src/utils/licenses.ts:128
msgid "{tierLabel} seats: {claimed} of {licensed} used"
msgstr "{tierLabel} seats: {claimed} of {licensed} used"

#: src/utils/licenses.ts:126
msgid "{tierLabel} seats: none purchased"
msgstr "{tierLabel} seats: none purchased"

#: src/components/ProviderDetailModal.tsx:206
#: src/components/ProviderDetailModal.tsx:430
msgid "{tokensInLabel} in · {tokensOutLabel} out"
msgstr "{tokensInLabel} in · {tokensOutLabel} out"

#: src/pages/SignupPage.tsx:129
#~ msgid "{trialDays}-day free trial • First charge: {trialEndFormatted}"
#~ msgstr "{trialDays}-day free trial • First charge: {trialEndFormatted}"

#: src/pages/SubscriptionPage.tsx:408
#~ msgid "{trialDays}-day free trial. We'll save your card today and only charge after the trial ends."
#~ msgstr "{trialDays}-day free trial. We'll save your card today and only charge after the trial ends."

#: src/pages/SignupPage.tsx:631
#~ msgid "{trialDays}-day no-cost trial"
#~ msgstr "{trialDays}-day no-cost trial"

#: src/utils/relativeTime.ts:21
msgid "{yr}y ago"
msgstr "{yr}y ago"

#: src/pages/InvitePage.tsx:759
#: src/pages/SignupPage.tsx:697
msgid "© 2026 WEB3 REX INC. All Rights Reserved."
msgstr "© 2026 WEB3 REX INC. All Rights Reserved."

#: src/pages/InvitePage.tsx:612
#: src/pages/LoginPage.tsx:232
#: src/pages/SignupPage.tsx:566
msgid "← Use a different email"
msgstr "← Use a different email"

#: src/pages/DictionaryManagementPage.tsx:182
msgid "+ Create New Catalog"
msgstr "+ Create New Catalog"

#. placeholder {0}: quarantined.length
#. placeholder {1}: sensitive.length
#: src/pages/MemoryPage.tsx:987
msgid "<0>Memory Guard</0> held back: {0, plural, one {# looked like an instruction} other {# looked like instructions}}, {1, plural, one {# touches a sensitive topic} other {# touch sensitive topics}}. Instructions are never used in prompts; sensitive notes are recalled only in conversations on the same topic."
msgstr "<0>Memory Guard</0> held back: {0, plural, one {# looked like an instruction} other {# looked like instructions}}, {1, plural, one {# touches a sensitive topic} other {# touch sensitive topics}}. Instructions are never used in prompts; sensitive notes are recalled only in conversations on the same topic."

#: src/pages/MemoryPage.tsx:424
#~ msgid "<0>Memory Guard</0> quarantined {0, plural, one {# entry} other {# entries}} that looked like instructions rather than facts. They are never used in prompts."
#~ msgstr "<0>Memory Guard</0> quarantined {0, plural, one {# entry} other {# entries}} that looked like instructions rather than facts. They are never used in prompts."

#: src/pages/OnboardingPage.tsx:705
#~ msgid "<0>Nothing due today.</0> Your card is saved but not charged until your trial ends on day five. Cancel any time before then with one click."
#~ msgstr "<0>Nothing due today.</0> Your card is saved but not charged until your trial ends on day five. Cancel any time before then with one click."

#: src/pages/SignupPage.tsx:126
#~ msgid "${0}/month"
#~ msgstr "${0}/month"

#: src/pages/OnboardingPage.tsx:167
#~ msgid "$0 today"
#~ msgstr "$0 today"

#: src/pages/UserDetailAuditPage.tsx:669
msgid "1 year"
msgstr "1 year"

#: src/pages/DashboardPage.tsx:451
#: src/pages/DashboardPage.tsx:457
msgid "1y"
msgstr "1y"

#: src/pages/OnboardingPage.tsx:484
msgid "24/7 protection"
msgstr "24/7 protection"

#: src/pages/DashboardPage.tsx:454
msgid "24h"
msgstr "24h"

#: src/components/connections/ConnectionHealthPanel.tsx:71
msgid "3:00 AM ET"
msgstr "3:00 AM ET"

#: src/pages/DashboardPage.tsx:449
#: src/pages/DashboardPage.tsx:455
msgid "30d"
msgstr "30d"

#: src/pages/DashboardPage.tsx:450
#: src/pages/DashboardPage.tsx:456
msgid "90d"
msgstr "90d"

#: src/App.tsx:209
#~ msgid "A hosted MCP endpoint that lets your AI assistant use Salesforce and Microsoft 365 while it only ever sees Privacy Twins."
#~ msgstr "A hosted MCP endpoint that lets your AI assistant use Salesforce and Microsoft 365 while it only ever sees Privacy Twins."

#: src/App.tsx:209
#~ msgid "A hosted MCP endpoint that lets your AI assistant use Salesforce while it only ever sees Privacy Twins."
#~ msgstr "A hosted MCP endpoint that lets your AI assistant use Salesforce while it only ever sees Privacy Twins."

#: src/App.tsx:209
msgid "A hosted MCP endpoint that lets your AI assistant use Salesforce, HubSpot, Microsoft 365 and Google Workspace while it only ever sees Privacy Twins."
msgstr "A hosted MCP endpoint that lets your AI assistant use Salesforce, HubSpot, Microsoft 365 and Google Workspace while it only ever sees Privacy Twins."

#: src/pages/ResetPasswordPage.tsx:112
#: src/pages/SignupPage.tsx:359
msgid "A lowercase letter"
msgstr "A lowercase letter"

#: src/pages/OnboardingPage.tsx:317
msgid "A new discipline: Privacy Engineering."
msgstr "A new discipline: Privacy Engineering."

#: src/pages/ResetPasswordPage.tsx:113
#: src/pages/SignupPage.tsx:360
msgid "A number"
msgstr "A number"

#: src/pages/UserManagementPage.tsx:219
msgid "Access Denied"
msgstr "Access Denied"

#: src/pages/ConnectionsPage.tsx:945
#: src/pages/ConnectionsPage.tsx:1002
msgid "Access token"
msgstr "Access token"

#. placeholder {0}: new Date(account.subscriptionEndDate).toLocaleDateString()
#: src/pages/DashboardPage.tsx:397
msgid "Access until {0}"
msgstr "Access until {0}"

#: src/components/Layout.tsx:296
msgid "Account"
msgstr "Account"

#: src/pages/InvitePage.tsx:514
msgid "ACCURACY"
msgstr "ACCURACY"

#: src/pages/DashboardPage.tsx:433
msgid "across all {scopeUserCount} team members"
msgstr "across all {scopeUserCount} team members"

#: src/pages/AgentsPage.tsx:674
#: src/pages/ApiKeysPage.tsx:139
#: src/pages/DictionaryManagementPage.tsx:210
#: src/pages/UserManagementPage.tsx:287
msgid "Actions"
msgstr "Actions"

#: src/pages/OnboardingPage.tsx:724
#~ msgid "Activate"
#~ msgstr "Activate"

#. placeholder {0}: valid.code
#: src/components/UpgradeModal.tsx:426
msgid "Activate {0} on a call"
msgstr "Activate {0} on a call"

#: src/pages/OnboardingPage.tsx:518
msgid "Activate PrivacyPal"
msgstr "Activate PrivacyPal"

#: src/components/connections/ConnectionStatusBadge.tsx:40
#: src/pages/AgentsPage.tsx:481
#: src/pages/DashboardPage.tsx:678
#: src/pages/MemoryPage.tsx:130
msgid "Active"
msgstr "Active"

#: src/pages/SubscriptionPage.tsx:975
msgid "Active Discount: {couponName}"
msgstr "Active Discount: {couponName}"

#. placeholder {0}: activeKeys.length
#: src/pages/ApiKeysPage.tsx:113
msgid "Active Keys ({0})"
msgstr "Active Keys ({0})"

#: src/pages/SubscriptionPage.tsx:1133
msgid "Active Subscription"
msgstr "Active Subscription"

#: src/components/ProviderDetailModal.tsx:213
msgid "Active users"
msgstr "Active users"

#: src/pages/UserDetailAuditPage.tsx:650
msgid "Active window"
msgstr "Active window"

#: src/pages/MemoryPage.tsx:644
msgid "Activity"
msgstr "Activity"

#: src/components/Layout.tsx:167
msgid "Activity Dashboard"
msgstr "Activity Dashboard"

#: src/pages/DashboardPage.tsx:284
msgid "Activity Stream"
msgstr "Activity Stream"

#: src/pages/DashboardPage.tsx:442
msgid "Activity stream range"
msgstr "Activity stream range"

#: src/pages/AgentsPage.tsx:1417
#: src/pages/AgentsPage.tsx:1432
#: src/pages/DictionaryManagementPage.tsx:486
#: src/pages/DictionaryManagementPage.tsx:512
msgid "Add"
msgstr "Add"

#: src/pages/AgentsPage.tsx:1431
#: src/pages/DictionaryManagementPage.tsx:509
msgid "Add a deny list term..."
msgstr "Add a deny list term..."

#: src/pages/AgentsPage.tsx:1416
#: src/pages/DictionaryManagementPage.tsx:483
msgid "Add a term..."
msgstr "Add a term..."

#: src/pages/UserManagementPage.tsx:352
#: src/pages/UserManagementPage.tsx:435
#: src/pages/UserManagementPage.tsx:471
msgid "Add license"
msgstr "Add license"

#: src/pages/UserManagementPage.tsx:471
msgid "Add License"
msgstr "Add License"

#: src/pages/PrivateMcpPage.tsx:1270
msgid "Add new Private MCP"
msgstr "Add new Private MCP"

#: src/pages/MemoryPage.tsx:837
msgid "Adds relevant memories to what you send, in twin-space."
msgstr "Adds relevant memories to what you send, in twin-space."

#: src/pages/UserManagementPage.tsx:421
msgid "Admin"
msgstr "Admin"

#: src/components/Layout.tsx:306
#: src/pages/UserManagementPage.tsx:316
msgid "Administrator"
msgstr "Administrator"

#: src/pages/OnboardingPage.tsx:171
#~ msgid "After trial: ${discountedPrice}/mo (promo applied)"
#~ msgstr "After trial: ${discountedPrice}/mo (promo applied)"

#: src/pages/AgentsPage.tsx:881
msgid "Agent Created"
msgstr "Agent Created"

#: src/pages/AgentsPage.tsx:224
msgid "Agent created!"
msgstr "Agent created!"

#: src/pages/AgentsPage.tsx:244
msgid "Agent deleted"
msgstr "Agent deleted"

#: src/pages/AgentsPage.tsx:831
msgid "Agent Name"
msgstr "Agent Name"

#: src/pages/AgentsPage.tsx:207
msgid "Agent name is required"
msgstr "Agent name is required"

#: src/pages/AgentsPage.tsx:1102
msgid "Agent Output"
msgstr "Agent Output"

#: src/pages/AgentsPage.tsx:208
msgid "Agent prompt is required"
msgstr "Agent prompt is required"

#: src/pages/AgentsPage.tsx:881
msgid "Agent Updated"
msgstr "Agent Updated"

#: src/pages/AgentsPage.tsx:224
msgid "Agent updated!"
msgstr "Agent updated!"

#: src/components/Layout.tsx:195
msgid "Agents"
msgstr "Agents"

#: src/components/ProviderDetailModal.tsx:491
msgid "Aggregate statistics only. Individual conversations are available to administrators in User Management."
msgstr "Aggregate statistics only. Individual conversations are available to administrators in User Management."

#: src/pages/DashboardPage.tsx:632
msgid "AI App"
msgstr "AI App"

#: src/pages/OnboardingPage.tsx:326
msgid "AI Services"
msgstr "AI Services"

#: src/pages/OnboardingPage.tsx:484
msgid "AI-native privacy"
msgstr "AI-native privacy"

#: src/pages/MemoryPage.tsx:134
#: src/pages/MemoryPage.tsx:1147
msgid "All"
msgstr "All"

#: src/utils/licenses.ts:167
msgid "All {licensed} prepaid {tierLabel} seats are in use. {noSeatLine}"
msgstr "All {licensed} prepaid {tierLabel} seats are in use. {noSeatLine}"

#: src/pages/DashboardPage.tsx:619
msgid "all {scopeUserCount} team members"
msgstr "all {scopeUserCount} team members"

#: src/components/ProviderDetailModal.tsx:105
msgid "all {userCount} team members"
msgstr "all {userCount} team members"

#: src/pages/ConnectionsPage.tsx:864
msgid "All credentials are encrypted at rest and transmitted over TLS. Only domain administrators can manage connections."
msgstr "All credentials are encrypted at rest and transmitted over TLS. Only domain administrators can manage connections."

#: src/pages/LoginPage.tsx:388
msgid "Already have an account? Sign in"
msgstr "Already have an account? Sign in"

#: src/pages/AgentsPage.tsx:821
msgid "AN"
msgstr "AN"

#: src/pages/LoginPage.tsx:91
msgid "An error occurred"
msgstr "An error occurred"

#: src/pages/LoginPage.tsx:52
msgid "An error occurred during authentication."
msgstr "An error occurred during authentication."

#: src/pages/SignupPage.tsx:626
#~ msgid "An individual account: one seat, one person. Your login, your devices. Unlimited prompts and all features."
#~ msgstr "An individual account: one seat, one person. Your login, your devices. Unlimited prompts and all features."

#: src/pages/ResetPasswordPage.tsx:111
#: src/pages/SignupPage.tsx:358
msgid "An uppercase letter"
msgstr "An uppercase letter"

#: src/pages/OnboardingPage.tsx:174
msgid "Analysis failed"
msgstr "Analysis failed"

#: src/pages/AgentsPage.tsx:476
#: src/pages/AgentsPage.tsx:847
#: src/pages/AgentsPage.tsx:894
msgid "Analyst"
msgstr "Analyst"

#: src/pages/AgentsPage.tsx:950
#: src/pages/AgentsPage.tsx:1017
msgid "Analyst Agent"
msgstr "Analyst Agent"

#: src/pages/AgentsPage.tsx:856
msgid "Analyst agents run against audit data after pipeline processing completes."
msgstr "Analyst agents run against audit data after pipeline processing completes."

#: src/pages/UserDetailAuditPage.tsx:695
msgid "ANALYTIC AGENT"
msgstr "ANALYTIC AGENT"

#: src/pages/AgentsPage.tsx:1054
msgid "Analyzing audit data..."
msgstr "Analyzing audit data..."

#: src/pages/SubscriptionPage.tsx:835
msgid "annual"
msgstr "annual"

#: src/components/UpgradeModal.tsx:198
#: src/pages/SubscriptionPage.tsx:183
#: src/pages/SubscriptionPage.tsx:323
#: src/pages/SubscriptionPage.tsx:402
#: src/pages/SubscriptionPage.tsx:882
msgid "Annual"
msgstr "Annual"

#: src/pages/SubscriptionPage.tsx:831
msgid "Annual Bill"
msgstr "Annual Bill"

#: src/pages/PrivateMcpPage.tsx:1021
#: src/pages/PrivateMcpPage.tsx:1216
msgid "any"
msgstr "any"

#: src/App.tsx:182
msgid "API Access"
msgstr "API Access"

#: src/pages/ConnectionsPage.tsx:1029
#: src/pages/ConnectionsPage.tsx:1216
msgid "API Key"
msgstr "API Key"

#: src/pages/ApiKeysPage.tsx:258
msgid "API Key Created"
msgstr "API Key Created"

#: src/pages/ApiKeysPage.tsx:59
msgid "API key revoked"
msgstr "API key revoked"

#: src/components/Layout.tsx:274
msgid "API Keys"
msgstr "API Keys"

#: src/pages/PrivateMcpPage.tsx:583
#: src/pages/PrivateMcpPage.tsx:760
msgid "App registration"
msgstr "App registration"

#: src/components/Layout.tsx:662
msgid "Apple Silicon only (M1 and later). Apple menu → About This Mac to check."
msgstr "Apple Silicon only (M1 and later). Apple menu → About This Mac to check."

#: src/pages/PrivateMcpPage.tsx:790
#: src/pages/PrivateMcpPage.tsx:837
msgid "Application (client) ID"
msgstr "Application (client) ID"

#: src/pages/OnboardingPage.tsx:199
#~ msgid "Applied: {percentOff}% off"
#~ msgstr "Applied: {percentOff}% off"

#: src/pages/OnboardingPage.tsx:200
#~ msgid "Applied: discount active"
#~ msgstr "Applied: discount active"

#: src/pages/OnboardingPage.tsx:193
#: src/pages/SignupPage.tsx:651
#~ msgid "Apply"
#~ msgstr "Apply"

#: src/pages/MemoryPage.tsx:745
msgid "Archive"
msgstr "Archive"

#: src/pages/MemoryPage.tsx:132
msgid "Archived"
msgstr "Archived"

#: src/pages/SubscriptionPage.tsx:1047
msgid "Are you sure you want to cancel your subscription? You will have access until the end of your current billing period."
msgstr "Are you sure you want to cancel your subscription? You will have access until the end of your current billing period."

#. placeholder {0}: deleteAgentConfirm.name
#: src/pages/AgentsPage.tsx:1168
msgid "Are you sure you want to delete agent \"{0}\"? This action cannot be undone."
msgstr "Are you sure you want to delete agent \"{0}\"? This action cannot be undone."

#. placeholder {0}: deleteConfirm.dictionaryName
#. placeholder {0}: deleteDictConfirm.dictionaryName
#: src/pages/AgentsPage.tsx:1178
#: src/pages/DictionaryManagementPage.tsx:350
msgid "Are you sure you want to delete catalog \"{0}\"? This action cannot be undone."
msgstr "Are you sure you want to delete catalog \"{0}\"? This action cannot be undone."

#: src/pages/UserDetailAuditPage.tsx:697
msgid "Ask about this user's data patterns or security footprint."
msgstr "Ask about this user's data patterns or security footprint."

#: src/components/MaxUpsell.tsx:99
msgid "Ask your admin about PrivacyPal Max"
msgstr "Ask your admin about PrivacyPal Max"

#: src/pages/UserDetailAuditPage.tsx:1063
msgid "Associated Files ({associatedFileCount})"
msgstr "Associated Files ({associatedFileCount})"

#: src/pages/ResetPasswordPage.tsx:110
#: src/pages/SignupPage.tsx:357
msgid "At least 8 characters"
msgstr "At least 8 characters"

#: src/pages/InvitePage.tsx:706
#: src/pages/LoginPage.tsx:31
msgid "At least 8 characters, including an uppercase letter, a lowercase letter, and a number."
msgstr "At least 8 characters, including an uppercase letter, a lowercase letter, and a number."

#: src/pages/AgentsPage.tsx:1386
#: src/pages/DictionaryManagementPage.tsx:420
msgid "At least one term or one deny list entry is required"
msgstr "At least one term or one deny list entry is required"

#: src/pages/UserDetailAuditPage.tsx:1116
msgid "Attached Files"
msgstr "Attached Files"

#: src/pages/AgentsPage.tsx:959
msgid "Audit Data to Analyze"
msgstr "Audit Data to Analyze"

#: src/components/connections/ConnectionStatusBadge.tsx:20
msgid "Auth failed"
msgstr "Auth failed"

#: src/pages/ConnectionsPage.tsx:1216
msgid "Auth Method"
msgstr "Auth Method"

#: src/pages/ConnectionsPage.tsx:549
msgid "Authenticate"
msgstr "Authenticate"

#: src/pages/ConnectionsPage.tsx:890
msgid "Authenticate your connection"
msgstr "Authenticate your connection"

#: src/components/connections/ConnectionAuthError.tsx:23
msgid "Authentication failed — reconnect to update credentials."
msgstr "Authentication failed — reconnect to update credentials."

#: src/pages/LoginPage.tsx:49
msgid "Authentication failed. Please try again."
msgstr "Authentication failed. Please try again."

#: src/pages/ConnectionsPage.tsx:1140
msgid "Automatically exclude messages from recognized bot accounts"
msgstr "Automatically exclude messages from recognized bot accounts"

#: src/pages/AgentsPage.tsx:406
msgid "Autonomous agents that augment the platform with intelligent detection, analysis, and decision-making."
msgstr "Autonomous agents that augment the platform with intelligent detection, analysis, and decision-making."

#: src/pages/ConnectionsPage.tsx:1085
#: src/pages/ConnectionsPage.tsx:1192
#: src/pages/OnboardingPage.tsx:303
#: src/pages/OnboardingPage.tsx:336
#: src/pages/OnboardingPage.tsx:409
#: src/pages/OnboardingPage.tsx:465
#: src/pages/OnboardingPage.tsx:489
#: src/pages/OnboardingPage.tsx:524
msgid "Back"
msgstr "Back"

#: src/pages/SubscriptionPage.tsx:736
msgid "Back to Dashboard"
msgstr "Back to Dashboard"

#: src/pages/AuthCallbackPage.tsx:159
#: src/pages/ForgotPasswordPage.tsx:107
#: src/pages/ForgotPasswordPage.tsx:152
#: src/pages/ResetPasswordPage.tsx:172
#: src/pages/VerifyEmailPage.tsx:127
#: src/pages/VerifyEmailPage.tsx:143
msgid "Back to sign in"
msgstr "Back to sign in"

#: src/pages/UserDetailAuditPage.tsx:574
#: src/pages/UserDetailAuditPage.tsx:596
msgid "Back to User Management"
msgstr "Back to User Management"

#: src/pages/UserDetailAuditPage.tsx:557
msgid "Based on the user's activity patterns, {subject} shows {totalPrompts} total prompts with activity across {platformsLabel}."
msgstr "Based on the user's activity patterns, {subject} shows {totalPrompts} total prompts with activity across {platformsLabel}."

#: src/components/Layout.tsx:736
msgid "Before you install"
msgstr "Before you install"

#: src/pages/SubscriptionPage.tsx:185
msgid "Best value"
msgstr "Best value"

#: src/components/UpgradeModal.tsx:592
msgid "Billing is not available right now. Please try again later."
msgstr "Billing is not available right now. Please try again later."

#: src/components/UpgradeModal.tsx:469
msgid "Book a trial call"
msgstr "Book a trial call"

#: src/pages/ConnectionsPage.tsx:615
msgid "Bot API access with read permissions on target groups. Create a bot via @BotFather and add it to your groups."
msgstr "Bot API access with read permissions on target groups. Create a bot via @BotFather and add it to your groups."

#: src/pages/MemoryPage.tsx:1191
msgid "Bring memory from another AI"
msgstr "Bring memory from another AI"

#: src/pages/OnboardingPage.tsx:505
msgid "Bringing PrivacyPal online..."
msgstr "Bringing PrivacyPal online..."

#: src/pages/UserDetailAuditPage.tsx:446
msgid "Browser Extension"
msgstr "Browser Extension"

#: src/pages/ConnectionsPage.tsx:738
msgid "Business Data Catalog"
msgstr "Business Data Catalog"

#: src/pages/ConnectionsPage.tsx:484
msgid "BusinessDataConnection verification failed"
msgstr "BusinessDataConnection verification failed"

#: src/pages/InvitePage.tsx:726
msgid "By clicking initialize, you agree to our <0>Terms of Service</0>. <1/>PrivacyPal does not have access to your LLM prompt history."
msgstr "By clicking initialize, you agree to our <0>Terms of Service</0>. <1/>PrivacyPal does not have access to your LLM prompt history."

#: src/pages/SignupPage.tsx:512
msgid "By continuing, you agree to our <0>Terms of Service</0>."
msgstr "By continuing, you agree to our <0>Terms of Service</0>."

#: src/pages/ConnectionsPage.tsx:904
#: src/pages/ConnectionsPage.tsx:959
msgid "Callback URL copied"
msgstr "Callback URL copied"

#: src/pages/ConnectionsPage.tsx:901
msgid "Callback URL to register"
msgstr "Callback URL to register"

#: src/components/ConfirmationModal.tsx:49
#: src/pages/AgentsPage.tsx:923
#: src/pages/AgentsPage.tsx:980
#: src/pages/AgentsPage.tsx:1170
#: src/pages/AgentsPage.tsx:1180
#: src/pages/AgentsPage.tsx:1454
#: src/pages/ApiKeysPage.tsx:236
#: src/pages/DictionaryManagementPage.tsx:352
#: src/pages/DictionaryManagementPage.tsx:561
#: src/pages/MemoryPage.tsx:1502
#: src/pages/SubscriptionPage.tsx:384
#: src/pages/SubscriptionPage.tsx:532
#: src/pages/UserManagementPage.tsx:471
#: src/pages/UserManagementPage.tsx:472
#: src/pages/UserManagementPage.tsx:473
#: src/pages/UserManagementPage.tsx:479
msgid "Cancel"
msgstr "Cancel"

#: src/pages/SubscriptionPage.tsx:1190
msgid "Cancel before your trial ends and you won't be charged."
msgstr "Cancel before your trial ends and you won't be charged."

#: src/pages/SubscriptionPage.tsx:896
#: src/pages/SubscriptionPage.tsx:1046
#: src/pages/SubscriptionPage.tsx:1048
msgid "Cancel Subscription"
msgstr "Cancel Subscription"

#: src/pages/SubscriptionPage.tsx:1198
#: src/pages/SubscriptionPage.tsx:1216
#: src/pages/SubscriptionPage.tsx:1218
msgid "Cancel Trial"
msgstr "Cancel Trial"

#: src/pages/SubscriptionPage.tsx:1217
msgid "Cancel your free trial now? You'll keep access until your trial ends, and your card won't be charged."
msgstr "Cancel your free trial now? You'll keep access until your trial ends, and your card won't be charged."

#: src/pages/SubscriptionPage.tsx:896
#: src/pages/SubscriptionPage.tsx:1198
msgid "Cancelling..."
msgstr "Cancelling..."

#: src/pages/SubscriptionPage.tsx:497
msgid "Card"
msgstr "Card"

#: src/components/UpgradeModal.tsx:259
#: src/pages/SubscriptionPage.tsx:347
msgid "Card Details"
msgstr "Card Details"

#: src/components/UpgradeModal.tsx:139
#: src/pages/SubscriptionPage.tsx:258
#: src/pages/SubscriptionPage.tsx:453
msgid "Card element not found"
msgstr "Card element not found"

#: src/pages/OnboardingPage.tsx:172
#~ msgid "Card verified today. First charge {firstChargeDate} unless cancelled."
#~ msgstr "Card verified today. First charge {firstChargeDate} unless cancelled."

#: src/pages/AgentsPage.tsx:1450
#: src/pages/DictionaryManagementPage.tsx:543
msgid "Case Sensitive"
msgstr "Case Sensitive"

#: src/pages/AgentsPage.tsx:376
#: src/pages/DictionaryManagementPage.tsx:128
msgid "Catalog deleted successfully!"
msgstr "Catalog deleted successfully!"

#: src/pages/AgentsPage.tsx:619
#: src/pages/AgentsPage.tsx:628
#: src/pages/DictionaryManagementPage.tsx:173
msgid "Catalog Management"
msgstr "Catalog Management"

#: src/pages/AgentsPage.tsx:1397
#: src/pages/DictionaryManagementPage.tsx:440
msgid "Catalog Name *"
msgstr "Catalog Name *"

#: src/pages/AgentsPage.tsx:1385
#: src/pages/DictionaryManagementPage.tsx:416
msgid "Catalog name is required"
msgstr "Catalog name is required"

#: src/pages/AgentsPage.tsx:364
#: src/pages/DictionaryManagementPage.tsx:106
msgid "Catalog saved successfully!"
msgstr "Catalog saved successfully!"

#: src/pages/SubscriptionPage.tsx:515
msgid "Change"
msgstr "Change"

#: src/pages/ConnectionsPage.tsx:614
msgid "ChannelMessage.Read.All, Chat.Read.All via Microsoft Graph. Requires Azure AD app with application permissions."
msgstr "ChannelMessage.Read.All, Chat.Read.All via Microsoft Graph. Requires Azure AD app with application permissions."

#: src/pages/ConnectionsPage.tsx:613
msgid "channels:history, groups:history, im:history, users:read scopes. Create a Slack app with Bot Token permissions."
msgstr "channels:history, groups:history, im:history, users:read scopes. Create a Slack app with Bot Token permissions."

#: src/components/UpgradeModal.tsx:292
msgid "Charged today. No trial period. Cancel anytime; you keep the free plan."
msgstr "Charged today. No trial period. Cancel anytime; you keep the free plan."

#: src/pages/SubscriptionPage.tsx:331
msgid "Charged today. No trial period. The free plan stays yours if you ever cancel."
msgstr "Charged today. No trial period. The free plan stays yours if you ever cancel."

#: src/pages/DashboardPage.tsx:321
msgid "ChatGPT, Claude, Gemini, Grok and Perplexity chats are protected. Cowork, Claude Code, Codex, Copilot, agents and API traffic pass through unprotected."
msgstr "ChatGPT, Claude, Gemini, Grok and Perplexity chats are protected. Cowork, Claude Code, Codex, Copilot, agents and API traffic pass through unprotected."

#: src/components/UpgradeModal.tsx:388
msgid "Check code"
msgstr "Check code"

#: src/pages/ForgotPasswordPage.tsx:78
msgid "Check your email"
msgstr "Check your email"

#: src/pages/OnboardingPage.tsx:734
#~ msgid "Checking subscription status..."
#~ msgstr "Checking subscription status..."

#: src/pages/ResetPasswordPage.tsx:142
msgid "Checking your reset link…"
msgstr "Checking your reset link…"

#: src/components/UpgradeModal.tsx:388
msgid "Checking..."
msgstr "Checking..."

#: src/pages/ResetPasswordPage.tsx:180
msgid "Choose a new password"
msgstr "Choose a new password"

#: src/pages/SubscriptionPage.tsx:406
#~ msgid "Choose your plan"
#~ msgstr "Choose your plan"

#: src/pages/SignupPage.tsx:615
#~ msgid "Choose Your Plan"
#~ msgstr "Choose Your Plan"

#: src/pages/SubscriptionPage.tsx:1180
msgid "Choose your plan for unlimited access"
msgstr "Choose your plan for unlimited access"

#: src/pages/InvitePage.tsx:617
msgid "Claim Your Invite"
msgstr "Claim Your Invite"

#: src/components/connections/ConnectionCard.tsx:47
msgid "Click to connect"
msgstr "Click to connect"

#: src/pages/ConnectionsPage.tsx:968
#: src/pages/PrivateMcpPage.tsx:1133
#: src/pages/PrivateMcpPage.tsx:1210
msgid "Client ID"
msgstr "Client ID"

#: src/pages/ConnectionsPage.tsx:972
#: src/pages/PrivateMcpPage.tsx:1025
#: src/pages/PrivateMcpPage.tsx:1146
#: src/pages/PrivateMcpPage.tsx:1220
msgid "Client secret"
msgstr "Client secret"

#: src/components/Layout.tsx:526
#: src/components/Layout.tsx:546
#: src/components/Layout.tsx:760
#: src/pages/AgentsPage.tsx:731
#: src/pages/DictionaryManagementPage.tsx:286
msgid "Close"
msgstr "Close"

#: src/components/Layout.tsx:437
msgid "Close menu"
msgstr "Close menu"

#: src/components/Layout.tsx:739
msgid "Close other AI apps if the installer prompts you. PrivacyPal hooks in at the system edge for full coverage."
msgstr "Close other AI apps if the installer prompts you. PrivacyPal hooks in at the system edge for full coverage."

#: src/components/ProviderDetailModal.tsx:261
msgid "Close report"
msgstr "Close report"

#: src/pages/SalesforceOAuthCallbackPage.tsx:72
msgid "Close window"
msgstr "Close window"

#. placeholder {0}: maxPromo.code
#: src/pages/SignupPage.tsx:650
msgid "Code {0} applied for as long as you stay."
msgstr "Code {0} applied for as long as you stay."

#. placeholder {0}: maxPromo.code
#. placeholder {1}: maxPromoDuration.months
#: src/pages/SignupPage.tsx:646
msgid "Code {0} applied for your first {1} months."
msgstr "Code {0} applied for your first {1} months."

#. placeholder {0}: maxPromo.code
#: src/pages/SignupPage.tsx:648
msgid "Code {0} applied to your first month."
msgstr "Code {0} applied to your first month."

#. placeholder {0}: maxPromo.code
#: src/pages/SignupPage.tsx:652
msgid "Code {0} applied."
msgstr "Code {0} applied."

#. placeholder {0}: maxPromo.code
#. placeholder {1}: maxPricing.perSeatLabel
#. placeholder {2}: maxPricing.listLabel
#: src/pages/SignupPage.tsx:435
msgid "Code <0>{0}</0> is live: PrivacyPal Max at {1}/seat/mo instead of {2}. Create your account and it carries through to checkout."
msgstr "Code <0>{0}</0> is live: PrivacyPal Max at {1}/seat/mo instead of {2}. Create your account and it carries through to checkout."

#. placeholder {0}: registerTrial.code
#. placeholder {1}: registerTrial.trialDays
#: src/pages/SignupPage.tsx:576
msgid "Code <0>{0}</0> switched PrivacyPal Max on for your whole company for {1} days. No card was taken and there is nothing to cancel: when the trial ends your team moves to Pro."
msgstr "Code <0>{0}</0> switched PrivacyPal Max on for your whole company for {1} days. No card was taken and there is nothing to cancel: when the trial ends your team moves to Pro."

#. placeholder {0}: registerTrial?.code
#: src/pages/SignupPage.tsx:580
msgid "Code <0>{0}</0> switched PrivacyPal Max on for your whole company. No card was taken and there is nothing to cancel: when the trial ends your team moves to Pro."
msgstr "Code <0>{0}</0> switched PrivacyPal Max on for your whole company. No card was taken and there is nothing to cancel: when the trial ends your team moves to Pro."

#: src/pages/MemoryPage.tsx:113
msgid "Coding"
msgstr "Coding"

#: src/pages/ConnectionsPage.tsx:610
msgid "Collaboration Tools"
msgstr "Collaboration Tools"

#: src/pages/ConnectionsPage.tsx:764
msgid "Collapse"
msgstr "Collapse"

#: src/components/Layout.tsx:306
msgid "Company Member"
msgstr "Company Member"

#: src/pages/SubscriptionPage.tsx:1123
msgid "Company Subscription"
msgstr "Company Subscription"

#: src/components/UpgradeModal.tsx:650
msgid "Company-wide trial"
msgstr "Company-wide trial"

#: src/pages/ConnectionsPage.tsx:549
msgid "Complete"
msgstr "Complete"

#: src/pages/ConnectionsPage.tsx:424
msgid "Complete {serviceName} authentication before saving configuration."
msgstr "Complete {serviceName} authentication before saving configuration."

#: src/pages/ConnectionsPage.tsx:392
#~ msgid "Complete Salesforce authentication before saving configuration."
#~ msgstr "Complete Salesforce authentication before saving configuration."

#: src/pages/SignupPage.tsx:178
#~ msgid "Complete Signup"
#~ msgstr "Complete Signup"

#: src/pages/AuthCallbackPage.tsx:172
msgid "Completing authentication..."
msgstr "Completing authentication..."

#: src/pages/OnboardingPage.tsx:319
msgid "Compliance checklists are reactive. Privacy Engineering is proactive: automated agents embedded across your stack that intercept sensitive data before it ever reaches an AI."
msgstr "Compliance checklists are reactive. Privacy Engineering is proactive: automated agents embedded across your stack that intercept sensitive data before it ever reaches an AI."

#: src/pages/ConnectionsPage.tsx:549
msgid "Configure"
msgstr "Configure"

#: src/pages/OnboardingPage.tsx:508
msgid "Configuring your protection layer. This takes just a moment."
msgstr "Configuring your protection layer. This takes just a moment."

#: src/components/ConfirmationModal.tsx:55
msgid "Confirm"
msgstr "Confirm"

#: src/pages/ResetPasswordPage.tsx:231
msgid "Confirm new password"
msgstr "Confirm new password"

#: src/pages/InvitePage.tsx:710
#: src/pages/SignupPage.tsx:505
msgid "Confirm Password"
msgstr "Confirm Password"

#: src/components/connections/ConnectionCard.tsx:52
msgid "Connect"
msgstr "Connect"

#: src/App.tsx:196
msgid "Connect Salesforce, HubSpot, Notion, and other business systems so your AI works on Privacy Twins, never the real records."
msgstr "Connect Salesforce, HubSpot, Notion, and other business systems so your AI works on Privacy Twins, never the real records."

#: src/App.tsx:196
#~ msgid "Connect Salesforce, Notion, and other business systems so your AI works on Privacy Twins, never the real records."
#~ msgstr "Connect Salesforce, Notion, and other business systems so your AI works on Privacy Twins, never the real records."

#: src/pages/ConnectionsPage.tsx:678
msgid "Connect third-party services to enable PrivacyPal to scan and protect sensitive data across your organization."
msgstr "Connect third-party services to enable PrivacyPal to scan and protect sensitive data across your organization."

#: src/pages/ConnectionsPage.tsx:604
msgid "Connect to Dropbox Business to monitor shared files, Paper documents, and team folders."
msgstr "Connect to Dropbox Business to monitor shared files, Paper documents, and team folders."

#: src/pages/ConnectionsPage.tsx:600
msgid "Connect to Google Drive to scan documents, spreadsheets, and presentations stored in your organization's workspace."
msgstr "Connect to Google Drive to scan documents, spreadsheets, and presentations stored in your organization's workspace."

#: src/pages/ConnectionsPage.tsx:649
msgid "Connect to Microsoft SQL Server instances to catalog and scan database content for PII."
msgstr "Connect to Microsoft SQL Server instances to catalog and scan database content for PII."

#: src/pages/ConnectionsPage.tsx:651
msgid "Connect to MySQL or MariaDB instances to identify and catalog sensitive data across tables."
msgstr "Connect to MySQL or MariaDB instances to identify and catalog sensitive data across tables."

#: src/pages/ConnectionsPage.tsx:602
msgid "Connect to Notion workspaces to scan pages, databases, and embedded content for sensitive data."
msgstr "Connect to Notion workspaces to scan pages, databases, and embedded content for sensitive data."

#: src/pages/ConnectionsPage.tsx:615
msgid "Connect to Telegram groups and channels used by your organization to detect sensitive data sharing."
msgstr "Connect to Telegram groups and channels used by your organization to detect sensitive data sharing."

#: src/pages/ConnectionsPage.tsx:1092
msgid "Connect with HubSpot"
msgstr "Connect with HubSpot"

#: src/pages/ConnectionsPage.tsx:1088
msgid "Connect with Salesforce"
msgstr "Connect with Salesforce"

#: src/pages/PrivateMcpPage.tsx:895
msgid "Connect your assistant to Gmail and Google Drive through Privacy Twins"
msgstr "Connect your assistant to Gmail and Google Drive through Privacy Twins"

#: src/pages/PrivateMcpPage.tsx:1087
msgid "Connect your assistant to HubSpot's MCP server through Privacy Twins"
msgstr "Connect your assistant to HubSpot's MCP server through Privacy Twins"

#: src/pages/PrivateMcpPage.tsx:733
msgid "Connect your assistant to Outlook mail and OneDrive files through Privacy Twins"
msgstr "Connect your assistant to Outlook mail and OneDrive files through Privacy Twins"

#: src/pages/PrivateMcpPage.tsx:556
msgid "Connect your assistant to Salesforce through Privacy Twins"
msgstr "Connect your assistant to Salesforce through Privacy Twins"

#: src/components/connections/ConnectionHealthPanel.tsx:64
msgid "Connected"
msgstr "Connected"

#: src/pages/ConnectionsPage.tsx:916
msgid "Connected App Consumer Key"
msgstr "Connected App Consumer Key"

#: src/pages/ConnectionsPage.tsx:925
msgid "Connected App Consumer Secret"
msgstr "Connected App Consumer Secret"

#: src/pages/PrivateMcpPage.tsx:1292
msgid "Connected users"
msgstr "Connected users"

#: src/pages/PrivateMcpPage.tsx:1371
msgid "Connected users are visible to administrators only."
msgstr "Connected users are visible to administrators only."

#: src/pages/ConnectionsPage.tsx:1227
msgid "Connection Failed"
msgstr "Connection Failed"

#. placeholder {0}: revokeTarget.email || revokeTarget.userId
#: src/pages/PrivateMcpPage.tsx:498
msgid "Connection revoked for {0}"
msgstr "Connection revoked for {0}"

#: src/pages/ConnectionsPage.tsx:1212
msgid "Connection Verified"
msgstr "Connection Verified"

#: src/components/Layout.tsx:223
#: src/pages/ConnectionsPage.tsx:676
msgid "Connections"
msgstr "Connections"

#: src/pages/SubscriptionPage.tsx:789
msgid "Connections, Private MCP and API access"
msgstr "Connections, Private MCP and API access"

#: src/pages/PrivateMcpPage.tsx:1329
msgid "Connector"
msgstr "Connector"

#: src/pages/PrivateMcpPage.tsx:569
#: src/pages/PrivateMcpPage.tsx:746
#: src/pages/PrivateMcpPage.tsx:908
#: src/pages/PrivateMcpPage.tsx:1100
msgid "Connector URL"
msgstr "Connector URL"

#: src/pages/PrivateMcpPage.tsx:321
msgid "Connector URL copied to clipboard"
msgstr "Connector URL copied to clipboard"

#: src/pages/ConnectionsPage.tsx:915
#: src/pages/PrivateMcpPage.tsx:613
#: src/pages/PrivateMcpPage.tsx:673
msgid "Consumer Key"
msgstr "Consumer Key"

#: src/pages/ConnectionsPage.tsx:919
msgid "Consumer Secret"
msgstr "Consumer Secret"

#: src/pages/AgentsPage.tsx:1445
#: src/pages/DictionaryManagementPage.tsx:527
msgid "Context Words (Optional)"
msgstr "Context Words (Optional)"

#: src/pages/InvitePage.tsx:523
msgid "Context-aware masking"
msgstr "Context-aware masking"

#: src/pages/ConnectionsPage.tsx:1095
#: src/pages/ConnectionsPage.tsx:1097
#: src/pages/OnboardingPage.tsx:306
#: src/pages/OnboardingPage.tsx:416
#: src/pages/OnboardingPage.tsx:467
#: src/pages/SignupPage.tsx:509
#: src/pages/UserManagementPage.tsx:472
#: src/pages/UserManagementPage.tsx:473
msgid "Continue"
msgstr "Continue"

#: src/pages/SignupPage.tsx:665
#~ msgid "Continue to Payment"
#~ msgstr "Continue to Payment"

#: src/components/UpgradeModal.tsx:449
msgid "Continue with a card"
msgstr "Continue with a card"

#: src/pages/LoginPage.tsx:355
msgid "Continue with Google"
msgstr "Continue with Google"

#: src/pages/LoginPage.tsx:369
msgid "Continue with Microsoft"
msgstr "Continue with Microsoft"

#: src/pages/UserDetailAuditPage.tsx:951
msgid "Conversation Details"
msgstr "Conversation Details"

#: src/pages/UserDetailAuditPage.tsx:963
msgid "Conversation History ({detailPromptCount} prompts)"
msgstr "Conversation History ({detailPromptCount} prompts)"

#: src/components/Layout.tsx:150
msgid "Copied to clipboard"
msgstr "Copied to clipboard"

#: src/components/Layout.tsx:622
#: src/components/Layout.tsx:726
#: src/pages/ConnectionsPage.tsx:904
#: src/pages/ConnectionsPage.tsx:959
msgid "Copy"
msgstr "Copy"

#: src/pages/PrivateMcpPage.tsx:63
msgid "Copy connector URL to clipboard"
msgstr "Copy connector URL to clipboard"

#: src/pages/ApiKeysPage.tsx:262
msgid "Copy this key now. For security, it will not be displayed again."
msgstr "Copy this key now. For security, it will not be displayed again."

#: src/components/Layout.tsx:508
msgid "Copy to clipboard"
msgstr "Copy to clipboard"

#: src/pages/MemoryPage.tsx:753
msgid "Correct"
msgstr "Correct"

#: src/pages/MemoryPage.tsx:1485
msgid "Correct this memory"
msgstr "Correct this memory"

#: src/pages/InvitePage.tsx:116
#: src/pages/LoginPage.tsx:87
#: src/pages/SignupPage.tsx:222
msgid "Could not send a verification code"
msgstr "Could not send a verification code"

#: src/pages/OnboardingPage.tsx:122
#~ msgid "Could not validate promo code"
#~ msgstr "Could not validate promo code"

#: src/pages/ConnectionsPage.tsx:953
msgid "Create a HubSpot app with OAuth authentication (a project app with private distribution is enough for your own account), add the exact callback URL below as a redirect URL, and set the required and optional scopes shown. Then paste the app's Client ID and Client secret. You install the app into your HubSpot account in a popup; tokens are exchanged server-side and stored encrypted."
msgstr "Create a HubSpot app with OAuth authentication (a project app with private distribution is enough for your own account), add the exact callback URL below as a redirect URL, and set the required and optional scopes shown. Then paste the app's Client ID and Client secret. You install the app into your HubSpot account in a popup; tokens are exchanged server-side and stored encrypted."

#: src/pages/ConnectionsPage.tsx:998
msgid "Create a service key (Development, then Keys) or a legacy private app in your HubSpot account with the read scopes crm.objects.contacts.read, crm.objects.companies.read and crm.objects.deals.read. Paste its access token here. The token is verified with one read before the connection is saved."
msgstr "Create a service key (Development, then Keys) or a legacy private app in your HubSpot account with the read scopes crm.objects.contacts.read, crm.objects.companies.read and crm.objects.deals.read. Paste its access token here. The token is verified with one read before the connection is saved."

#: src/pages/LoginPage.tsx:166
#: src/pages/LoginPage.tsx:331
msgid "Create Account"
msgstr "Create Account"

#: src/pages/AgentsPage.tsx:929
msgid "Create Agent"
msgstr "Create Agent"

#: src/pages/ConnectionsPage.tsx:953
#~ msgid "Create an app in HubSpot with OAuth authentication, add the exact callback URL below as a redirect URL, and set the required and optional scopes shown. Then paste the app's Client ID and Client secret. You install the app into your HubSpot account in a popup; tokens are exchanged server-side and stored encrypted."
#~ msgstr "Create an app in HubSpot with OAuth authentication, add the exact callback URL below as a redirect URL, and set the required and optional scopes shown. Then paste the app's Client ID and Client secret. You install the app into your HubSpot account in a popup; tokens are exchanged server-side and stored encrypted."

#: src/pages/ConnectionsPage.tsx:998
#~ msgid "Create an app in your HubSpot account with static access-token authentication (a private app) and the read scopes crm.objects.contacts.read, crm.objects.companies.read and crm.objects.deals.read. Paste its access token here. The token is verified with one read before the connection is saved."
#~ msgstr "Create an app in your HubSpot account with static access-token authentication (a private app) and the read scopes crm.objects.contacts.read, crm.objects.companies.read and crm.objects.deals.read. Paste its access token here. The token is verified with one read before the connection is saved."

#: src/pages/AgentsPage.tsx:1394
#: src/pages/DictionaryManagementPage.tsx:435
msgid "Create New Catalog"
msgstr "Create New Catalog"

#: src/pages/SignupPage.tsx:426
msgid "Create Your Account"
msgstr "Create Your Account"

#: src/pages/ApiKeysPage.tsx:138
msgid "Created"
msgstr "Created"

#: src/pages/MemoryPage.tsx:120
msgid "Creative"
msgstr "Creative"

#: src/pages/ConnectionsPage.tsx:621
msgid "CRM & Business Systems"
msgstr "CRM & Business Systems"

#: src/pages/UserDetailAuditPage.tsx:538
msgid "CSV report downloaded ({days} days)"
msgstr "CSV report downloaded ({days} days)"

#: src/pages/MemoryPage.tsx:127
msgid "Current focus"
msgstr "Current focus"

#: src/pages/DashboardPage.tsx:374
#: src/pages/SubscriptionPage.tsx:766
msgid "Current Plan"
msgstr "Current Plan"

#: src/pages/SubscriptionPage.tsx:876
msgid "Current Subscription"
msgstr "Current Subscription"

#: src/pages/AgentsPage.tsx:1405
#: src/pages/DictionaryManagementPage.tsx:463
msgid "Custom Company Term"
msgstr "Custom Company Term"

#: src/pages/AgentsPage.tsx:1406
#: src/pages/DictionaryManagementPage.tsx:464
msgid "Custom PII"
msgstr "Custom PII"

#: src/pages/AgentsPage.tsx:1404
#: src/pages/DictionaryManagementPage.tsx:462
msgid "Custom Term"
msgstr "Custom Term"

#: src/pages/ConnectionsPage.tsx:1107
msgid "Customize how PrivacyPal scans and processes data from this connection."
msgstr "Customize how PrivacyPal scans and processes data from this connection."

#: src/components/ProviderDetailModal.tsx:302
msgid "Daily prompts by tool"
msgstr "Daily prompts by tool"

#: src/pages/ConnectionsPage.tsx:1064
msgid "Database"
msgstr "Database"

#: src/pages/ConnectionsPage.tsx:1074
msgid "Database password"
msgstr "Database password"

#: src/pages/ConnectionsPage.tsx:1070
msgid "Database username"
msgstr "Database username"

#: src/pages/ConnectionsPage.tsx:646
msgid "Databases"
msgstr "Databases"

#: src/pages/AgentsPage.tsx:606
#: src/pages/AgentsPage.tsx:692
#: src/pages/AgentsPage.tsx:718
#: src/pages/AgentsPage.tsx:1169
#: src/pages/AgentsPage.tsx:1179
#: src/pages/DictionaryManagementPage.tsx:235
#: src/pages/DictionaryManagementPage.tsx:271
#: src/pages/DictionaryManagementPage.tsx:351
msgid "Delete"
msgstr "Delete"

#: src/pages/AgentsPage.tsx:1167
msgid "Delete Agent"
msgstr "Delete Agent"

#: src/pages/AgentsPage.tsx:1177
#: src/pages/DictionaryManagementPage.tsx:349
msgid "Delete Catalog"
msgstr "Delete Catalog"

#: src/pages/UserManagementPage.tsx:462
msgid "Demote"
msgstr "Demote"

#: src/pages/UserManagementPage.tsx:375
msgid "Demote to Member"
msgstr "Demote to Member"

#: src/pages/UserManagementPage.tsx:473
msgid "Demote User to Member"
msgstr "Demote User to Member"

#: src/pages/AgentsPage.tsx:673
#: src/pages/DictionaryManagementPage.tsx:209
msgid "Deny List"
msgstr "Deny List"

#. placeholder {0}: selectedDictionary.deny_list.length
#: src/pages/AgentsPage.tsx:753
#: src/pages/DictionaryManagementPage.tsx:317
msgid "Deny List ({0})"
msgstr "Deny List ({0})"

#: src/pages/AgentsPage.tsx:1429
#: src/pages/DictionaryManagementPage.tsx:500
msgid "Deny List (Terms to exclude from detection)"
msgstr "Deny List (Terms to exclude from detection)"

#: src/pages/AgentsPage.tsx:862
msgid "Describe what this agent should do..."
msgstr "Describe what this agent should do..."

#: src/pages/DashboardPage.tsx:638
#: src/pages/DashboardPage.tsx:700
msgid "Details"
msgstr "Details"

#: src/pages/UserDetailAuditPage.tsx:1103
msgid "Detected Entity Types"
msgstr "Detected Entity Types"

#: src/pages/OnboardingPage.tsx:433
msgid "Developer"
msgstr "Developer"

#: src/pages/ApiKeysPage.tsx:92
msgid "Developer API Keys"
msgstr "Developer API Keys"

#: src/App.tsx:183
msgid "Developer keys for the PrivacyPal API and SDK: encode, decode and batch protection inside your own tools and pipelines."
msgstr "Developer keys for the PrivacyPal API and SDK: encode, decode and batch protection inside your own tools and pipelines."

#: src/pages/AgentsPage.tsx:1446
#: src/pages/DictionaryManagementPage.tsx:537
msgid "diagnosis, condition, disease (comma-separated)"
msgstr "diagnosis, condition, disease (comma-separated)"

#: src/pages/ForgotPasswordPage.tsx:88
msgid "Didn't get it? Check your spam folder, or resend below."
msgstr "Didn't get it? Check your spam folder, or resend below."

#: src/pages/ConnectionsPage.tsx:1216
msgid "Direct Connection"
msgstr "Direct Connection"

#: src/pages/PrivateMcpPage.tsx:777
#: src/pages/PrivateMcpPage.tsx:833
msgid "Directory (tenant) ID"
msgstr "Directory (tenant) ID"

#: src/pages/AgentsPage.tsx:684
#: src/pages/AgentsPage.tsx:709
#: src/pages/DictionaryManagementPage.tsx:224
#: src/pages/DictionaryManagementPage.tsx:259
msgid "Disabled"
msgstr "Disabled"

#: src/components/connections/ConnectionActions.tsx:39
#: src/components/connections/ConnectionActions.tsx:61
msgid "Disconnect"
msgstr "Disconnect"

#: src/pages/SignupPage.tsx:656
#~ msgid "Discount applied"
#~ msgstr "Discount applied"

#: src/pages/SubscriptionPage.tsx:982
msgid "Discount applied to your subscription"
msgstr "Discount applied to your subscription"

#. placeholder {0}: new Date(subscriptionDetails.discount.end).toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' })
#: src/pages/SubscriptionPage.tsx:954
msgid "Discount expires {0}"
msgstr "Discount expires {0}"

#: src/pages/ConnectionsPage.tsx:597
msgid "Document Repositories"
msgstr "Document Repositories"

#: src/pages/LoginPage.tsx:386
msgid "Don't have an account? Sign up"
msgstr "Don't have an account? Sign up"

#: src/pages/AgentsPage.tsx:935
#: src/pages/ApiKeysPage.tsx:293
#: src/pages/ConnectionsPage.tsx:1219
msgid "Done"
msgstr "Done"

#: src/pages/UserManagementPage.tsx:359
#: src/pages/UserManagementPage.tsx:442
#: src/pages/UserManagementPage.tsx:478
msgid "Downgrade to Pro"
msgstr "Downgrade to Pro"

#: src/pages/UserManagementPage.tsx:476
msgid "Downgrade User to Pro"
msgstr "Downgrade User to Pro"

#: src/pages/UserDetailAuditPage.tsx:783
msgid "Download audit data as CSV"
msgstr "Download audit data as CSV"

#: src/components/Layout.tsx:656
msgid "Download for Apple Silicon"
msgstr "Download for Apple Silicon"

#: src/components/Layout.tsx:710
msgid "Download for ARM64"
msgstr "Download for ARM64"

#: src/components/Layout.tsx:601
msgid "Download for Windows"
msgstr "Download for Windows"

#: src/components/Layout.tsx:701
msgid "Download for x86_64"
msgstr "Download for x86_64"

#: src/components/Layout.tsx:362
#: src/components/Layout.tsx:471
msgid "Download Now"
msgstr "Download Now"

#: src/components/Layout.tsx:540
msgid "Download PrivacyPal"
msgstr "Download PrivacyPal"

#: src/components/Layout.tsx:349
msgid "Download PrivacyPal for desktop"
msgstr "Download PrivacyPal for desktop"

#: src/pages/AgentsPage.tsx:1094
msgid "Duration:"
msgstr "Duration:"

#: src/pages/UserDetailAuditPage.tsx:702
msgid "e.g. 'Summarize data exfiltration risks'"
msgstr "e.g. 'Summarize data exfiltration risks'"

#: src/pages/ConnectionsPage.tsx:1061
msgid "e.g. 5432"
msgstr "e.g. 5432"

#: src/pages/ConnectionsPage.tsx:1056
msgid "e.g. db.example.com"
msgstr "e.g. db.example.com"

#: src/pages/MemoryPage.tsx:1099
msgid "e.g. I prefer short answers with a summary first"
msgstr "e.g. I prefer short answers with a summary first"

#: src/pages/AgentsPage.tsx:834
msgid "e.g. Location Sharing Guard"
msgstr "e.g. Location Sharing Guard"

#: src/pages/ConnectionsPage.tsx:1065
msgid "e.g. mydb"
msgstr "e.g. mydb"

#: src/pages/ApiKeysPage.tsx:223
msgid "e.g. Production Backend, Staging App"
msgstr "e.g. Production Backend, Staging App"

#: src/pages/InvitePage.tsx:494
msgid "Early Beta Release"
msgstr "Early Beta Release"

#: src/pages/AgentsPage.tsx:600
#: src/pages/AgentsPage.tsx:691
#: src/pages/AgentsPage.tsx:717
#: src/pages/AgentsPage.tsx:732
#: src/pages/DictionaryManagementPage.tsx:232
#: src/pages/DictionaryManagementPage.tsx:268
#: src/pages/DictionaryManagementPage.tsx:289
msgid "Edit"
msgstr "Edit"

#. placeholder {0}: dictionary.name
#: src/pages/AgentsPage.tsx:1394
#: src/pages/DictionaryManagementPage.tsx:435
msgid "Edit: {0}"
msgstr "Edit: {0}"

#: src/pages/AgentsPage.tsx:790
msgid "Edit: {editingAgentOriginalName}"
msgstr "Edit: {editingAgentOriginalName}"

#: src/pages/MemoryPage.tsx:118
msgid "Education"
msgstr "Education"

#: src/pages/ApiKeysPage.tsx:136
msgid "Elements Protected"
msgstr "Elements Protected"

#: src/pages/ForgotPasswordPage.tsx:126
#: src/pages/LoginPage.tsx:288
msgid "Email"
msgstr "Email"

#: src/pages/SignupPage.tsx:196
msgid "Email is required"
msgstr "Email is required"

#: src/pages/VerifyEmailPage.tsx:97
msgid "Email verified"
msgstr "Email verified"

#: src/pages/ConnectionsPage.tsx:1187
msgid "Enable deep content scanning (adds some additional latency)"
msgstr "Enable deep content scanning (adds some additional latency)"

#: src/pages/AgentsPage.tsx:485
#: src/pages/AgentsPage.tsx:684
#: src/pages/AgentsPage.tsx:709
#: src/pages/AgentsPage.tsx:741
#: src/pages/AgentsPage.tsx:896
#: src/pages/AgentsPage.tsx:1411
#: src/pages/DictionaryManagementPage.tsx:224
#: src/pages/DictionaryManagementPage.tsx:259
#: src/pages/DictionaryManagementPage.tsx:300
#: src/pages/DictionaryManagementPage.tsx:470
msgid "Enabled"
msgstr "Enabled"

#: src/pages/ResetPasswordPage.tsx:182
msgid "Enter and confirm your new password below."
msgstr "Enter and confirm your new password below."

#: src/pages/OnboardingPage.tsx:182
#~ msgid "Enter code"
#~ msgstr "Enter code"

#: src/pages/SignupPage.tsx:638
#~ msgid "Enter code (optional)"
#~ msgstr "Enter code (optional)"

#: src/pages/SubscriptionPage.tsx:374
msgid "Enter promo code"
msgstr "Enter promo code"

#: src/pages/ConnectionsPage.tsx:1182
msgid ""
"Enter table names to exclude, separated by commas\n"
"e.g. _migrations, sessions, cache"
msgstr ""
"Enter table names to exclude, separated by commas\n"
"e.g. _migrations, sessions, cache"

#: src/pages/AuthCallbackPage.tsx:90
#: src/pages/InvitePage.tsx:123
#: src/pages/LoginPage.tsx:100
#: src/pages/SignupPage.tsx:230
msgid "Enter the 6-digit code from the email."
msgstr "Enter the 6-digit code from the email."

#: src/pages/ConnectionsPage.tsx:1035
msgid "Enter your API key"
msgstr "Enter your API key"

#: src/pages/ConnectionsPage.tsx:601
#: src/pages/ConnectionsPage.tsx:614
msgid "Enter your Azure AD application client secret"
msgstr "Enter your Azure AD application client secret"

#: src/pages/InvitePage.tsx:618
msgid "Enter your details to activate your private instance of PrivacyPal."
msgstr "Enter your details to activate your private instance of PrivacyPal."

#: src/pages/SignupPage.tsx:427
msgid "Enter your details to get started with PrivacyPal."
msgstr "Enter your details to get started with PrivacyPal."

#: src/pages/ForgotPasswordPage.tsx:115
msgid "Enter your email address and we'll send you a link to reset it."
msgstr "Enter your email address and we'll send you a link to reset it."

#: src/pages/PrivateMcpPage.tsx:129
msgid "Enter your Google Workspace domain on its own, such as example.com."
msgstr "Enter your Google Workspace domain on its own, such as example.com."

#: src/pages/PrivateMcpPage.tsx:144
msgid "Enter your HubSpot account ID as digits only, as shown in the account menu in HubSpot."
msgstr "Enter your HubSpot account ID as digits only, as shown in the account menu in HubSpot."

#: src/pages/ConnectionsPage.tsx:616
msgid "Enter your Mattermost personal access token"
msgstr "Enter your Mattermost personal access token"

#: src/pages/ConnectionsPage.tsx:605
msgid "Enter your NetDocuments client ID and secret separated by a colon"
msgstr "Enter your NetDocuments client ID and secret separated by a colon"

#: src/pages/MemoryPage.tsx:951
msgid "Entities linked"
msgstr "Entities linked"

#: src/pages/AgentsPage.tsx:670
#: src/pages/AgentsPage.tsx:737
#: src/pages/DictionaryManagementPage.tsx:206
#: src/pages/DictionaryManagementPage.tsx:296
msgid "Entity Type"
msgstr "Entity Type"

#: src/pages/AgentsPage.tsx:1401
#: src/pages/DictionaryManagementPage.tsx:453
msgid "Entity Type *"
msgstr "Entity Type *"

#: src/pages/MemoryPage.tsx:1517
msgid "Erase all memory?"
msgstr "Erase all memory?"

#: src/pages/MemoryPage.tsx:1471
#: src/pages/MemoryPage.tsx:1519
msgid "Erase everything"
msgstr "Erase everything"

#: src/pages/MemoryPage.tsx:1447
msgid "Erasing destroys the encryption keys that make your memory readable: every copy, including exports and synced devices, becomes meaningless. It cannot be undone."
msgstr "Erasing destroys the encryption keys that make your memory readable: every copy, including exports and synced devices, becomes meaningless. It cannot be undone."

#: src/pages/ConnectionsPage.tsx:1204
msgid "Establishing connection..."
msgstr "Establishing connection..."

#: src/pages/SignupPage.tsx:675
msgid "Evaluating Max for a team? <0>Book a trial call</0> and we will issue a code."
msgstr "Evaluating Max for a team? <0>Book a trial call</0> and we will issue a code."

#: src/pages/MemoryPage.tsx:103
msgid "Event"
msgstr "Event"

#: src/pages/UserDetailAuditPage.tsx:949
msgid "Event Details #{eventIdSuffix}"
msgstr "Event Details #{eventIdSuffix}"

#: src/pages/MemoryPage.tsx:1538
msgid "Every memory filed under this topic is deleted. This cannot be undone."
msgstr "Every memory filed under this topic is deleted. This cannot be undone."

#: src/pages/MemoryPage.tsx:1528
msgid "Every memory that mentions them is deleted, along with the entity itself. This cannot be undone."
msgstr "Every memory that mentions them is deleted, along with the entity itself. This cannot be undone."

#: src/pages/OnboardingPage.tsx:275
msgid "Every time your team uses an LLM (ChatGPT, Copilot, Claude), a piece of your IP, your client data, your trade secrets quietly walks out the door."
msgstr "Every time your team uses an LLM (ChatGPT, Copilot, Claude), a piece of your IP, your client data, your trade secrets quietly walks out the door."

#. placeholder {0}: entity.displayValue
#: src/pages/MemoryPage.tsx:498
msgid "Everything about {0} was forgotten"
msgstr "Everything about {0} was forgotten"

#: src/pages/MemoryPage.tsx:365
msgid "Everything about this topic was forgotten"
msgstr "Everything about this topic was forgotten"

#: src/pages/MemoryPage.tsx:1179
msgid "Everything else"
msgstr "Everything else"

#: src/pages/SignupPage.tsx:658
msgid "Everything in Pro, plus protection for Cowork, Claude Code, Codex, Copilot, agents and the APIs, with Connections, Private MCP, API access, team seats and full usage history."
msgstr "Everything in Pro, plus protection for Cowork, Claude Code, Codex, Copilot, agents and the APIs, with Connections, Private MCP, API access, team seats and full usage history."

#: src/pages/SignupPage.tsx:587
msgid "Everything is unlocked: Cowork, Claude Code, Codex, Copilot, agents and the APIs, plus Connections, Private MCP, API access, team seats and full usage history."
msgstr "Everything is unlocked: Cowork, Claude Code, Codex, Copilot, agents and the APIs, plus Connections, Private MCP, API access, team seats and full usage history."

#: src/pages/MemoryPage.tsx:732
msgid "Evidence"
msgstr "Evidence"

#: src/pages/ConnectionsPage.tsx:1146
msgid "Excluded HubSpot properties"
msgstr "Excluded HubSpot properties"

#: src/pages/ConnectionsPage.tsx:1161
msgid "Excluded Salesforce fields"
msgstr "Excluded Salesforce fields"

#: src/pages/ConnectionsPage.tsx:1177
msgid "Excluded Table Names"
msgstr "Excluded Table Names"

#: src/pages/AgentsPage.tsx:990
msgid "Execute Agent"
msgstr "Execute Agent"

#: src/pages/AgentsPage.tsx:1064
msgid "Execution Complete"
msgstr "Execution Complete"

#: src/pages/AgentsPage.tsx:294
msgid "Execution failed"
msgstr "Execution failed"

#: src/pages/AgentsPage.tsx:1073
msgid "Execution Failed"
msgstr "Execution Failed"

#: src/pages/AgentsPage.tsx:1134
msgid "Execution History"
msgstr "Execution History"

#: src/pages/ConnectionsPage.tsx:764
msgid "Expand"
msgstr "Expand"

#. placeholder {0}: subscriptionDetails.paymentMethod.expMonth
#. placeholder {1}: subscriptionDetails.paymentMethod.expYear
#: src/pages/SubscriptionPage.tsx:501
msgid "Expires {0}/{1}"
msgstr "Expires {0}/{1}"

#: src/pages/MemoryPage.tsx:1458
msgid "Export memory"
msgstr "Export memory"

#: src/pages/PrivateMcpPage.tsx:619
msgid "External Client App consumer key"
msgstr "External Client App consumer key"

#: src/pages/MemoryPage.tsx:100
msgid "Fact"
msgstr "Fact"

#: src/pages/UserManagementPage.tsx:109
msgid "Failed to add a license for this user"
msgstr "Failed to add a license for this user"

#: src/pages/MemoryPage.tsx:401
msgid "Failed to archive memory"
msgstr "Failed to archive memory"

#: src/pages/SubscriptionPage.tsx:706
msgid "Failed to cancel subscription. Please try again."
msgstr "Failed to cancel subscription. Please try again."

#: src/pages/SignupPage.tsx:104
#~ msgid "Failed to complete signup"
#~ msgstr "Failed to complete signup"

#: src/components/UpgradeModal.tsx:152
#: src/components/UpgradeModal.tsx:499
msgid "Failed to complete the upgrade"
msgstr "Failed to complete the upgrade"

#: src/pages/MemoryPage.tsx:459
msgid "Failed to correct memory"
msgstr "Failed to correct memory"

#: src/pages/ApiKeysPage.tsx:49
msgid "Failed to create API key"
msgstr "Failed to create API key"

#: src/pages/ConnectionsPage.tsx:494
msgid "Failed to create connection"
msgstr "Failed to create connection"

#: src/components/UpgradeModal.tsx:144
#: src/pages/SubscriptionPage.tsx:267
#: src/pages/SubscriptionPage.tsx:462
msgid "Failed to create payment method"
msgstr "Failed to create payment method"

#: src/pages/SubscriptionPage.tsx:283
msgid "Failed to create subscription"
msgstr "Failed to create subscription"

#: src/pages/AgentsPage.tsx:248
msgid "Failed to delete agent"
msgstr "Failed to delete agent"

#: src/pages/AgentsPage.tsx:377
#: src/pages/DictionaryManagementPage.tsx:131
msgid "Failed to delete catalog"
msgstr "Failed to delete catalog"

#: src/pages/MemoryPage.tsx:380
msgid "Failed to delete memory"
msgstr "Failed to delete memory"

#: src/pages/UserManagementPage.tsx:195
msgid "Failed to demote user to member"
msgstr "Failed to demote user to member"

#: src/pages/ConnectionsPage.tsx:395
msgid "Failed to disconnect"
msgstr "Failed to disconnect"

#: src/pages/UserDetailAuditPage.tsx:541
msgid "Failed to download CSV report"
msgstr "Failed to download CSV report"

#: src/pages/MemoryPage.tsx:549
msgid "Failed to erase memory"
msgstr "Failed to erase memory"

#: src/pages/MemoryPage.tsx:534
msgid "Failed to export memory"
msgstr "Failed to export memory"

#. placeholder {0}: entity.displayValue
#: src/pages/MemoryPage.tsx:502
msgid "Failed to forget {0}"
msgstr "Failed to forget {0}"

#: src/pages/MemoryPage.tsx:370
msgid "Failed to forget this topic"
msgstr "Failed to forget this topic"

#: src/components/Layout.tsx:138
msgid "Failed to generate invite link. Please ensure you have a company account."
msgstr "Failed to generate invite link. Please ensure you have a company account."

#: src/pages/MemoryPage.tsx:517
msgid "Failed to import memory"
msgstr "Failed to import memory"

#: src/pages/ApiKeysPage.tsx:32
msgid "Failed to load API keys"
msgstr "Failed to load API keys"

#: src/pages/MemoryPage.tsx:270
msgid "Failed to load audit trail"
msgstr "Failed to load audit trail"

#: src/pages/AgentsPage.tsx:354
#: src/pages/DictionaryManagementPage.tsx:79
msgid "Failed to load catalog details"
msgstr "Failed to load catalog details"

#: src/pages/AgentsPage.tsx:345
#: src/pages/DictionaryManagementPage.tsx:62
msgid "Failed to load catalogs"
msgstr "Failed to load catalogs"

#: src/pages/PrivateMcpPage.tsx:311
msgid "Failed to load connected users"
msgstr "Failed to load connected users"

#: src/pages/ConnectionsPage.tsx:234
msgid "Failed to load connections"
msgstr "Failed to load connections"

#: src/pages/UserManagementPage.tsx:88
msgid "Failed to load data"
msgstr "Failed to load data"

#: src/pages/MemoryPage.tsx:261
msgid "Failed to load people and projects"
msgstr "Failed to load people and projects"

#: src/pages/MemoryPage.tsx:227
msgid "Failed to load team memory"
msgstr "Failed to load team memory"

#: src/pages/PrivateMcpPage.tsx:275
msgid "Failed to load the Google Workspace app registration"
msgstr "Failed to load the Google Workspace app registration"

#: src/pages/PrivateMcpPage.tsx:293
msgid "Failed to load the HubSpot app registration"
msgstr "Failed to load the HubSpot app registration"

#: src/pages/PrivateMcpPage.tsx:257
msgid "Failed to load the Microsoft 365 app registration"
msgstr "Failed to load the Microsoft 365 app registration"

#: src/pages/PrivateMcpPage.tsx:241
msgid "Failed to load the Salesforce app registration"
msgstr "Failed to load the Salesforce app registration"

#: src/pages/MemoryPage.tsx:252
msgid "Failed to load the timeline"
msgstr "Failed to load the timeline"

#: src/pages/UserDetailAuditPage.tsx:232
msgid "Failed to load user audit data"
msgstr "Failed to load user audit data"

#: src/pages/MemoryPage.tsx:197
msgid "Failed to load your memory"
msgstr "Failed to load your memory"

#: src/pages/MemoryPage.tsx:243
msgid "Failed to load your profile"
msgstr "Failed to load your profile"

#: src/pages/UserManagementPage.tsx:126
msgid "Failed to make user admin"
msgstr "Failed to make user admin"

#: src/utils/licenses.ts:205
msgid "Failed to move the user to {tierLabel}"
msgstr "Failed to move the user to {tierLabel}"

#: src/pages/MemoryPage.tsx:485
msgid "Failed to refresh your profile"
msgstr "Failed to refresh your profile"

#: src/pages/MemoryPage.tsx:444
msgid "Failed to remember that"
msgstr "Failed to remember that"

#: src/pages/MemoryPage.tsx:302
msgid "Failed to remove team memory"
msgstr "Failed to remove team memory"

#: src/pages/PrivateMcpPage.tsx:365
#: src/pages/PrivateMcpPage.tsx:401
#: src/pages/PrivateMcpPage.tsx:445
#: src/pages/PrivateMcpPage.tsx:489
msgid "Failed to remove the app registration"
msgstr "Failed to remove the app registration"

#: src/pages/VerifyEmailPage.tsx:62
msgid "Failed to resend."
msgstr "Failed to resend."

#: src/pages/ResetPasswordPage.tsx:102
msgid "Failed to reset password. Please try again."
msgstr "Failed to reset password. Please try again."

#: src/pages/MemoryPage.tsx:411
msgid "Failed to restore memory"
msgstr "Failed to restore memory"

#: src/pages/ApiKeysPage.tsx:62
msgid "Failed to revoke API key"
msgstr "Failed to revoke API key"

#: src/pages/PrivateMcpPage.tsx:502
msgid "Failed to revoke the connection"
msgstr "Failed to revoke the connection"

#: src/pages/AgentsPage.tsx:226
msgid "Failed to save agent"
msgstr "Failed to save agent"

#: src/pages/AgentsPage.tsx:365
#: src/pages/DictionaryManagementPage.tsx:108
msgid "Failed to save catalog"
msgstr "Failed to save catalog"

#: src/pages/ConnectionsPage.tsx:436
msgid "Failed to save configuration"
msgstr "Failed to save configuration"

#: src/pages/PrivateMcpPage.tsx:347
#: src/pages/PrivateMcpPage.tsx:384
#: src/pages/PrivateMcpPage.tsx:427
#: src/pages/PrivateMcpPage.tsx:471
msgid "Failed to save the app registration"
msgstr "Failed to save the app registration"

#: src/pages/MemoryPage.tsx:291
msgid "Failed to share memory"
msgstr "Failed to share memory"

#: src/pages/ConnectionsPage.tsx:542
msgid "Failed to start {serviceName} OAuth"
msgstr "Failed to start {serviceName} OAuth"

#: src/pages/ConnectionsPage.tsx:407
msgid "Failed to start reconnect"
msgstr "Failed to start reconnect"

#: src/pages/ConnectionsPage.tsx:505
#~ msgid "Failed to start Salesforce OAuth"
#~ msgstr "Failed to start Salesforce OAuth"

#: src/pages/ConnectionsPage.tsx:317
msgid "Failed to start scan"
msgstr "Failed to start scan"

#: src/pages/ConnectionsPage.tsx:329
msgid "Failed to start sync"
msgstr "Failed to start sync"

#: src/pages/OnboardingPage.tsx:147
#~ msgid "Failed to start trial"
#~ msgstr "Failed to start trial"

#: src/pages/MemoryPage.tsx:347
msgid "Failed to update memory settings"
msgstr "Failed to update memory settings"

#: src/pages/SubscriptionPage.tsx:470
#: src/pages/SubscriptionPage.tsx:471
msgid "Failed to update payment method"
msgstr "Failed to update payment method"

#: src/pages/MemoryPage.tsx:391
msgid "Failed to update pin"
msgstr "Failed to update pin"

#: src/pages/MemoryPage.tsx:333
msgid "Failed to update team memory"
msgstr "Failed to update team memory"

#: src/pages/MemoryPage.tsx:472
msgid "Failed to update your profile"
msgstr "Failed to update your profile"

#: src/pages/SubscriptionPage.tsx:682
msgid "Failed to upgrade to Max. Please try again."
msgstr "Failed to upgrade to Max. Please try again."

#: src/pages/MemoryPage.tsx:117
msgid "Family"
msgstr "Family"

#: src/pages/ConnectionsPage.tsx:1166
msgid ""
"Fields to skip, e.g. Opportunity.Amount, Account.Secret_Field__c\n"
"Separate with commas or new lines"
msgstr ""
"Fields to skip, e.g. Opportunity.Amount, Account.Secret_Field__c\n"
"Separate with commas or new lines"

#: src/pages/UserDetailAuditPage.tsx:1072
msgid "FILE"
msgstr "FILE"

#: src/components/ProviderDetailModal.tsx:405
msgid "Files"
msgstr "Files"

#: src/components/ProviderDetailModal.tsx:208
msgid "Files protected"
msgstr "Files protected"

#: src/pages/ConnectionsPage.tsx:601
msgid "Files.Read.All application permission via Microsoft Graph API. Requires an Azure AD app registration."
msgstr "Files.Read.All application permission via Microsoft Graph API. Requires an Azure AD app registration."

#: src/pages/ConnectionsPage.tsx:1140
msgid "Filter out known Bots"
msgstr "Filter out known Bots"

#: src/pages/MemoryPage.tsx:116
msgid "Finance"
msgstr "Finance"

#: src/pages/InvitePage.tsx:667
#: src/pages/SignupPage.tsx:479
msgid "First"
msgstr "First"

#: src/pages/LoginPage.tsx:263
msgid "First Name"
msgstr "First Name"

#: src/pages/SignupPage.tsx:193
msgid "First name contains invalid characters"
msgstr "First name contains invalid characters"

#: src/pages/SignupPage.tsx:192
msgid "First name is required"
msgstr "First name is required"

#: src/pages/SubscriptionPage.tsx:195
#~ msgid "For teams and organizations. {maxFeatureLine}."
#~ msgstr "For teams and organizations. {maxFeatureLine}."

#: src/pages/MemoryPage.tsx:756
#: src/pages/MemoryPage.tsx:1529
msgid "Forget"
msgstr "Forget"

#. placeholder {0}: entity.displayValue
#: src/pages/MemoryPage.tsx:1307
msgid "Forget everything about {0}"
msgstr "Forget everything about {0}"

#. placeholder {0}: DOMAIN_LABEL[confirmDomain]
#. placeholder {0}: confirmEntity.displayValue
#: src/pages/MemoryPage.tsx:1527
#: src/pages/MemoryPage.tsx:1537
msgid "Forget everything about {0}?"
msgstr "Forget everything about {0}?"

#: src/pages/MemoryPage.tsx:896
#: src/pages/MemoryPage.tsx:1539
msgid "Forget this topic"
msgstr "Forget this topic"

#: src/pages/LoginPage.tsx:320
msgid "Forgot password?"
msgstr "Forgot password?"

#: src/pages/ForgotPasswordPage.tsx:113
msgid "Forgot your password?"
msgstr "Forgot your password?"

#: src/pages/MemoryPage.tsx:1008
msgid "Four short blocks PrivacyPal compiles from your memories and sends once at the start of each conversation. Edit any block; lock it to keep PrivacyPal from rewriting it."
msgstr "Four short blocks PrivacyPal compiles from your memories and sends once at the start of each conversation. Edit any block; lock it to keep PrivacyPal from rewriting it."

#: src/pages/SignupPage.tsx:616
msgid "Free"
msgstr "Free"

#: src/pages/ConnectionsPage.tsx:326
msgid "Full Business Data sync started — this may take a few minutes"
msgstr "Full Business Data sync started — this may take a few minutes"

#: src/pages/InvitePage.tsx:663
#: src/pages/SignupPage.tsx:477
msgid "Full Name"
msgstr "Full Name"

#: src/pages/SubscriptionPage.tsx:859
msgid "full price"
msgstr "full price"

#: src/pages/ConnectionsPage.tsx:1187
msgid "Full Text Search"
msgstr "Full Text Search"

#: src/pages/SubscriptionPage.tsx:791
msgid "Full usage history and team activity"
msgstr "Full usage history and team activity"

#: src/pages/DashboardPage.tsx:467
msgid "Full usage history comes with Max"
msgstr "Full usage history comes with Max"

#: src/pages/MemoryPage.tsx:121
msgid "General"
msgstr "General"

#: src/components/Layout.tsx:370
msgid "Generate an invite link to share with team members"
msgstr "Generate an invite link to share with team members"

#: src/pages/ApiKeysPage.tsx:94
msgid "Generate API keys for third-party integrations using the PrivacyPal SDK. Usage is metered by sensitive elements protected."
msgstr "Generate API keys for third-party integrations using the PrivacyPal SDK. Usage is metered by sensitive elements protected."

#: src/pages/ApiKeysPage.tsx:243
msgid "Generate Key"
msgstr "Generate Key"

#: src/pages/ApiKeysPage.tsx:215
msgid "Generate New API Key"
msgstr "Generate New API Key"

#: src/pages/ApiKeysPage.tsx:106
msgid "Generate New Key"
msgstr "Generate New Key"

#: src/pages/OnboardingPage.tsx:369
msgid "Generating Privacy Twins..."
msgstr "Generating Privacy Twins..."

#: src/pages/ApiKeysPage.tsx:243
#: src/pages/OnboardingPage.tsx:412
msgid "Generating..."
msgstr "Generating..."

#: src/pages/ConnectionsPage.tsx:879
msgid "Get Started"
msgstr "Get Started"

#: src/pages/SignupPage.tsx:409
msgid "Get Started Free"
msgstr "Get Started Free"

#: src/pages/ApiKeysPage.tsx:217
msgid "Give your key a descriptive name so you can identify it later."
msgstr "Give your key a descriptive name so you can identify it later."

#: src/pages/SignupPage.tsx:665
msgid "Go Max"
msgstr "Go Max"

#: src/pages/UserManagementPage.tsx:225
msgid "Go to Dashboard"
msgstr "Go to Dashboard"

#: src/pages/InvitePage.tsx:250
msgid "Go to Login"
msgstr "Go to Login"

#: src/pages/SubscriptionPage.tsx:1141
msgid "Go to User Management"
msgstr "Go to User Management"

#: src/pages/PrivateMcpPage.tsx:964
msgid "Google does not offer a secretless client for a hosted callback, so this connector needs one. It is encrypted before storage and never shown again, here or anywhere else."
msgstr "Google does not offer a secretless client for a hosted callback, so this connector needs one. It is encrypted before storage and never shown again, here or anywhere else."

#: src/pages/PrivateMcpPage.tsx:443
msgid "Google Workspace app registration removed"
msgstr "Google Workspace app registration removed"

#: src/pages/PrivateMcpPage.tsx:420
msgid "Google Workspace app registration saved"
msgstr "Google Workspace app registration saved"

#: src/pages/SubscriptionPage.tsx:361
msgid "Have a promo code?"
msgstr "Have a promo code?"

#: src/pages/MemoryPage.tsx:114
msgid "Health"
msgstr "Health"

#: src/pages/MemoryPage.tsx:953
msgid "Held back"
msgstr "Held back"

#: src/pages/MemoryPage.tsx:131
msgid "Held back (sensitive)"
msgstr "Held back (sensitive)"

#: src/pages/ResetPasswordPage.tsx:210
msgid "Hide"
msgstr "Hide"

#: src/pages/ResetPasswordPage.tsx:208
msgid "Hide password"
msgstr "Hide password"

#: src/pages/MemoryPage.tsx:1342
msgid "Hide why"
msgstr "Hide why"

#: src/pages/MemoryPage.tsx:107
msgid "High confidence"
msgstr "High confidence"

#: src/components/ProviderDetailModal.tsx:192
msgid "high risk"
msgstr "high risk"

#: src/pages/UserDetailAuditPage.tsx:864
msgid "HIGH RISK"
msgstr "HIGH RISK"

#: src/pages/AgentsPage.tsx:594
msgid "History"
msgstr "History"

#: src/pages/ConnectionsPage.tsx:1055
#: src/pages/PrivateMcpPage.tsx:1330
msgid "Host"
msgstr "Host"

#: src/pages/PrivateMcpPage.tsx:678
msgid "Hosted MCP server"
msgstr "Hosted MCP server"

#: src/pages/PrivateMcpPage.tsx:629
msgid "Hosted MCP server <0>(optional)</0>"
msgstr "Hosted MCP server <0>(optional)</0>"

#: src/pages/OnboardingPage.tsx:428
msgid "How do you work?"
msgstr "How do you work?"

#: src/pages/PrivateMcpPage.tsx:1214
msgid "HubSpot account ID"
msgstr "HubSpot account ID"

#: src/pages/PrivateMcpPage.tsx:1166
msgid "HubSpot account ID (optional)"
msgstr "HubSpot account ID (optional)"

#: src/pages/ConnectionsPage.tsx:978
msgid "HubSpot app Client secret"
msgstr "HubSpot app Client secret"

#: src/pages/PrivateMcpPage.tsx:487
msgid "HubSpot app registration removed"
msgstr "HubSpot app registration removed"

#: src/pages/PrivateMcpPage.tsx:464
msgid "HubSpot app registration saved"
msgstr "HubSpot app registration saved"

#: src/pages/PrivateMcpPage.tsx:1158
msgid "HubSpot's MCP server requires the client secret together with PKCE, so this connector needs one. It is encrypted before storage and never shown again, here or anywhere else."
msgstr "HubSpot's MCP server requires the client secret together with PKCE, so this connector needs one. It is encrypted before storage and never shown again, here or anywhere else."

#: src/pages/SignupPage.tsx:672
msgid "I have a trial code for my company"
msgstr "I have a trial code for my company"

#: src/pages/OnboardingPage.tsx:337
msgid "I'm ready to see it work"
msgstr "I'm ready to see it work"

#. placeholder {0}: formData.email
#: src/pages/InvitePage.tsx:572
msgid "If <0>{0}</0> can receive mail, we've sent it a 6-digit code. Enter it below to verify your address and finish accepting your invite — your account is only created after this step."
msgstr "If <0>{0}</0> can receive mail, we've sent it a 6-digit code. Enter it below to verify your address and finish accepting your invite — your account is only created after this step."

#. placeholder {0}: formData.email
#: src/pages/SignupPage.tsx:523
msgid "If <0>{0}</0> can receive mail, we've sent it a 6-digit code. Enter it below to verify your address. Your account is only created after this step."
msgstr "If <0>{0}</0> can receive mail, we've sent it a 6-digit code. Enter it below to verify your address. Your account is only created after this step."

#: src/pages/LoginPage.tsx:182
msgid "If <0>{email}</0> can receive mail, we've sent it a 6-digit code. Enter it below — your account is only created after this step. The code expires in 10 minutes."
msgstr "If <0>{email}</0> can receive mail, we've sent it a 6-digit code. Enter it below — your account is only created after this step. The code expires in 10 minutes."

#: src/pages/ForgotPasswordPage.tsx:81
msgid "If an account exists for <0>{trimmedEmail}</0>, you'll receive a password reset email shortly. The link expires in 20 minutes."
msgstr "If an account exists for <0>{trimmedEmail}</0>, you'll receive a password reset email shortly. The link expires in 20 minutes."

#: src/pages/LoginPage.tsx:139
#: src/pages/VerifyEmailPage.tsx:62
msgid "If that account exists, a new verification email has been sent."
msgstr "If that account exists, a new verification email has been sent."

#: src/pages/InvitePage.tsx:176
#: src/pages/InvitePage.tsx:179
#: src/pages/LoginPage.tsx:130
#: src/pages/SignupPage.tsx:308
#: src/pages/SignupPage.tsx:311
msgid "If that address can receive mail, we've sent a new code."
msgstr "If that address can receive mail, we've sent a new code."

#: src/pages/MemoryPage.tsx:1223
msgid "Import"
msgstr "Import"

#: src/pages/MemoryPage.tsx:514
msgid "Import started. New memories appear once they are distilled."
msgstr "Import started. New memories appear once they are distilled."

#. placeholder {0}: IMPORT_PLATFORM_NAME[imported]
#: src/pages/MemoryPage.tsx:693
msgid "imported from {0}"
msgstr "imported from {0}"

#: src/pages/MemoryPage.tsx:1223
msgid "Importing…"
msgstr "Importing…"

#: src/pages/PrivateMcpPage.tsx:1239
msgid "In HubSpot, go to Development, then MCP Connectors, and create an MCP connector with the redirect URL below. Copy its client ID and client secret here. There are no scopes to choose: HubSpot grants the connector what its MCP tools need, limited by each user's own HubSpot permissions, and every user approves it once when they connect."
msgstr "In HubSpot, go to Development, then MCP Connectors, and create an MCP connector with the redirect URL below. Copy its client ID and client secret here. There are no scopes to choose: HubSpot grants the connector what its MCP tools need, limited by each user's own HubSpot permissions, and every user approves it once when they connect."

#: src/pages/PrivateMcpPage.tsx:1044
msgid "In your own Google Cloud project, enable {GOOGLE_APIS}, set the OAuth consent screen user type to \"Internal\", and create an OAuth client of type \"Web application\" with the redirect URI below. Request the scopes <0>{GOOGLE_SCOPES}</0>. Internal apps skip Google's verification review, and their refresh tokens do not expire after seven days the way an external app still in testing does."
msgstr "In your own Google Cloud project, enable {GOOGLE_APIS}, set the OAuth consent screen user type to \"Internal\", and create an OAuth client of type \"Web application\" with the redirect URI below. Request the scopes <0>{GOOGLE_SCOPES}</0>. Internal apps skip Google's verification review, and their refresh tokens do not expire after seven days the way an external app still in testing does."

#: src/pages/ConnectionsPage.tsx:898
msgid "In your Salesforce org, create a Connected App with OAuth enabled, register the exact callback URL below, and grant the scopes shown. Then paste your My Domain URL and the app's Consumer Key/Secret. You approve access in a popup — tokens are exchanged server-side and stored encrypted."
msgstr "In your Salesforce org, create a Connected App with OAuth enabled, register the exact callback URL below, and grant the scopes shown. Then paste your My Domain URL and the app's Consumer Key/Secret. You approve access in a popup — tokens are exchanged server-side and stored encrypted."

#: src/pages/DashboardPage.tsx:376
msgid "Inactive"
msgstr "Inactive"

#: src/pages/ConnectionsPage.tsx:1139
msgid "Include private channels and direct messages in privacy scans"
msgstr "Include private channels and direct messages in privacy scans"

#: src/components/MaxUpsell.tsx:71
msgid "Included with PrivacyPal Max"
msgstr "Included with PrivacyPal Max"

#: src/pages/MemoryPage.tsx:849
msgid "Incognito"
msgstr "Incognito"

#: src/pages/SignupPage.tsx:623
#: src/pages/SubscriptionPage.tsx:169
#~ msgid "Individual"
#~ msgstr "Individual"

#: src/pages/SubscriptionPage.tsx:491
#~ msgid "Individual account: one seat, one person. Unlimited prompts and all features. $0 today; first charge after your {trialDays}-day trial."
#~ msgstr "Individual account: one seat, one person. Unlimited prompts and all features. $0 today; first charge after your {trialDays}-day trial."

#: src/pages/InvitePage.tsx:721
msgid "Initialize Privacy Agent"
msgstr "Initialize Privacy Agent"

#: src/pages/AgentsPage.tsx:959
msgid "Input Prompt to Analyze"
msgstr "Input Prompt to Analyze"

#: src/pages/UserDetailAuditPage.tsx:717
msgid "Insight:"
msgstr "Insight:"

#: src/pages/InvitePage.tsx:542
msgid "Installs in your browser. Works across major LLMs instantly."
msgstr "Installs in your browser. Works across major LLMs instantly."

#: src/pages/MemoryPage.tsx:102
msgid "Instruction"
msgstr "Instruction"

#: src/pages/ConnectionsPage.tsx:605
msgid "Integrate with NetDocuments to scan legal documents, matter files, and workspace content."
msgstr "Integrate with NetDocuments to scan legal documents, matter files, and workspace content."

#: src/pages/ConnectionsPage.tsx:601
msgid "Integrate with OneDrive for Business to monitor files shared across your Microsoft 365 tenant."
msgstr "Integrate with OneDrive for Business to monitor files shared across your Microsoft 365 tenant."

#: src/pages/ConnectionsPage.tsx:616
msgid "Integrate with your self-hosted or cloud Mattermost instance to scan channels for privacy risks."
msgstr "Integrate with your self-hosted or cloud Mattermost instance to scan channels for privacy risks."

#: src/pages/ConnectionsPage.tsx:652
msgid "Integrate with your Supabase project to scan PostgreSQL tables and storage buckets."
msgstr "Integrate with your Supabase project to scan PostgreSQL tables and storage buckets."

#: src/App.tsx:142
msgid "Intelligent agents that watch your privacy pipeline in real time and analyze audit data for anomalies."
msgstr "Intelligent agents that watch your privacy pipeline in real time and analyze audit data for anomalies."

#: src/pages/UserDetailAuditPage.tsx:707
#~ msgid "Interactions"
#~ msgstr "Interactions"

#: src/pages/LoginPage.tsx:51
msgid "Invalid authentication data received."
msgstr "Invalid authentication data received."

#: src/pages/InvitePage.tsx:44
msgid "Invalid invite link"
msgstr "Invalid invite link"

#: src/pages/InvitePage.tsx:232
msgid "Invalid Invite Link"
msgstr "Invalid Invite Link"

#: src/pages/ResetPasswordPage.tsx:149
msgid "Invalid link"
msgstr "Invalid link"

#: src/pages/InvitePage.tsx:78
msgid "Invalid or expired invite link"
msgstr "Invalid or expired invite link"

#: src/pages/OnboardingPage.tsx:120
#: src/pages/SignupPage.tsx:396
#~ msgid "Invalid promo code"
#~ msgstr "Invalid promo code"

#: src/components/Layout.tsx:492
msgid "Invite Link Generated"
msgstr "Invite Link Generated"

#: src/pages/InvitePage.tsx:476
msgid "Invite Only"
msgstr "Invite Only"

#: src/components/Layout.tsx:460
msgid "Invite Team Members"
msgstr "Invite Team Members"

#: src/App.tsx:195
msgid "IP Connections"
msgstr "IP Connections"

#: src/components/connections/ConnectionAuthError.tsx:34
#: src/components/connections/ConnectionHealthPanel.tsx:50
#: src/components/connections/ConnectionHealthPanel.tsx:58
msgid "Items indexed"
msgstr "Items indexed"

#: src/utils/relativeTime.ts:13
msgid "just now"
msgstr "just now"

#: src/pages/UserDetailAuditPage.tsx:428
msgid "Just now"
msgstr "Just now"

#: src/pages/SubscriptionPage.tsx:1049
msgid "Keep Subscription"
msgstr "Keep Subscription"

#: src/pages/SubscriptionPage.tsx:1219
msgid "Keep Trial"
msgstr "Keep Trial"

#: src/pages/ApiKeysPage.tsx:134
#: src/pages/ApiKeysPage.tsx:183
msgid "Key"
msgstr "Key"

#: src/pages/InvitePage.tsx:675
#: src/pages/SignupPage.tsx:480
msgid "Last"
msgstr "Last"

#: src/components/ProviderDetailModal.tsx:201
msgid "last {days} days"
msgstr "last {days} days"

#: src/pages/DashboardPage.tsx:615
msgid "Last {usageDays} days"
msgstr "Last {usageDays} days"

#: src/components/ProviderDetailModal.tsx:408
msgid "Last active"
msgstr "Last active"

#: src/components/connections/ConnectionAuthError.tsx:30
#: src/components/connections/ConnectionHealthPanel.tsx:45
msgid "Last good scan"
msgstr "Last good scan"

#. placeholder {0}: fmt(entity.lastMentionedAt)
#: src/pages/MemoryPage.tsx:1292
msgid "last mentioned {0}"
msgstr "last mentioned {0}"

#: src/pages/LoginPage.tsx:274
msgid "Last Name"
msgstr "Last Name"

#: src/pages/SignupPage.tsx:195
msgid "Last name contains invalid characters"
msgstr "Last name contains invalid characters"

#: src/pages/SignupPage.tsx:194
msgid "Last name is required"
msgstr "Last name is required"

#: src/components/connections/ConnectionHealthPanel.tsx:35
#: src/components/connections/ConnectionHealthPanel.tsx:45
msgid "Last scanned"
msgstr "Last scanned"

#: src/pages/PrivateMcpPage.tsx:1331
msgid "Last updated"
msgstr "Last updated"

#: src/pages/ApiKeysPage.tsx:137
msgid "Last Used"
msgstr "Last Used"

#: src/pages/InvitePage.tsx:506
msgid "LATENCY"
msgstr "LATENCY"

#: src/pages/OnboardingPage.tsx:297
msgid "Leak sealed. PrivacyPal is on the job."
msgstr "Leak sealed. PrivacyPal is on the job."

#: src/components/connections/ConnectionCard.tsx:68
msgid "Legacy credentials — OAuth recommended"
msgstr "Legacy credentials — OAuth recommended"

#: src/pages/MemoryPage.tsx:115
msgid "Legal"
msgstr "Legal"

#: src/pages/OnboardingPage.tsx:491
msgid "Let's do this"
msgstr "Let's do this"

#: src/pages/OnboardingPage.tsx:262
msgid "Let's go"
msgstr "Let's go"

#: src/pages/UserManagementPage.tsx:105
msgid "License added ({seatTier} seat)"
msgstr "License added ({seatTier} seat)"

#: src/pages/SubscriptionPage.tsx:903
msgid "Licenses"
msgstr "Licenses"

#: src/pages/ResetPasswordPage.tsx:149
#: src/pages/VerifyEmailPage.tsx:106
msgid "Link expired"
msgstr "Link expired"

#: src/components/Layout.tsx:687
msgid "Linux agent shield"
msgstr "Linux agent shield"

#: src/components/Layout.tsx:748
msgid "Linux: install.sh needs no root and installs into your home directory. Run privacypal login once, then privacypal status to confirm which agents are covered."
msgstr "Linux: install.sh needs no root and installs into your home directory. Run privacypal login once, then privacypal status to confirm which agents are covered."

#: src/components/UpgradeModal.tsx:653
msgid "Live today, cancel anytime"
msgstr "Live today, cancel anytime"

#: src/pages/MemoryPage.tsx:766
msgid "Loading evidence…"
msgstr "Loading evidence…"

#: src/pages/AgentsPage.tsx:1146
msgid "Loading history..."
msgstr "Loading history..."

#: src/pages/OnboardingPage.tsx:742
#~ msgid "Loading secure payment form..."
#~ msgstr "Loading secure payment form..."

#: src/pages/MemoryPage.tsx:1062
msgid "Lock"
msgstr "Lock"

#: src/pages/MemoryPage.tsx:1062
msgid "Locked"
msgstr "Locked"

#: src/pages/LoginPage.tsx:75
msgid "Login failed"
msgstr "Login failed"

#: src/pages/MemoryPage.tsx:109
msgid "Low confidence"
msgstr "Low confidence"

#: src/components/ProviderDetailModal.tsx:192
msgid "low risk"
msgstr "low risk"

#: src/components/Layout.tsx:745
msgid "macOS: open the DMG, drag PrivacyPal to Applications, then launch from Applications. Gatekeeper may ask you to confirm the first launch."
msgstr "macOS: open the DMG, drag PrivacyPal to Applications, then launch from Applications. Gatekeeper may ask you to confirm the first launch."

#: src/pages/UserManagementPage.tsx:370
#: src/pages/UserManagementPage.tsx:457
msgid "Make Admin"
msgstr "Make Admin"

#: src/pages/InvitePage.tsx:497
#: src/pages/SignupPage.tsx:412
msgid "Make AI Safe for Work.<0/>Instantly."
msgstr "Make AI Safe for Work.<0/>Instantly."

#: src/pages/UserManagementPage.tsx:472
msgid "Make User Administrator"
msgstr "Make User Administrator"

#: src/pages/AgentsPage.tsx:630
#: src/pages/DictionaryManagementPage.tsx:175
msgid "Manage custom catalogs for PII detection. Add terms to detect and deny lists to prevent false positives."
msgstr "Manage custom catalogs for PII detection. Add terms to detect and deny lists to prevent false positives."

#: src/pages/DashboardPage.tsx:417
msgid "Manage Subscription →"
msgstr "Manage Subscription →"

#: src/pages/SubscriptionPage.tsx:869
msgid "Manage your {tierLabel} subscription"
msgstr "Manage your {tierLabel} subscription"

#: src/pages/SubscriptionPage.tsx:868
msgid "Manage your company {tierLabel} subscription"
msgstr "Manage your company {tierLabel} subscription"

#: src/pages/SubscriptionPage.tsx:1124
msgid "Manage your company subscription"
msgstr "Manage your company subscription"

#. placeholder {0}: company.name
#: src/pages/UserManagementPage.tsx:240
msgid "Managing users for <0>{0}</0>"
msgstr "Managing users for <0>{0}</0>"

#: src/pages/DashboardPage.tsx:376
msgid "Max Plan"
msgstr "Max Plan"

#: src/components/UpgradeModal.tsx:377
msgid "MAX-XXXX-XXXX"
msgstr "MAX-XXXX-XXXX"

#: src/pages/PrivateMcpPage.tsx:1116
msgid "MCP connector"
msgstr "MCP connector"

#: src/pages/AgentsPage.tsx:1403
#: src/pages/DictionaryManagementPage.tsx:461
msgid "Medical Condition"
msgstr "Medical Condition"

#: src/pages/MemoryPage.tsx:108
msgid "Medium confidence"
msgstr "Medium confidence"

#: src/components/ProviderDetailModal.tsx:192
msgid "medium risk"
msgstr "medium risk"

#: src/pages/OnboardingPage.tsx:245
msgid "Meet your PrivacyPal."
msgstr "Meet your PrivacyPal."

#: src/pages/UserManagementPage.tsx:319
msgid "Member"
msgstr "Member"

#: src/pages/MemoryPage.tsx:641
#: src/pages/MemoryPage.tsx:950
msgid "Memories"
msgstr "Memories"

#: src/pages/MemoryPage.tsx:1384
msgid "Memories your team has shared. Values stay Privacy Twins for everyone except the person who shared them; real values never leave the sharer's vault."
msgstr "Memories your team has shared. Values stay Privacy Twins for everyone except the person who shared them; real values never leave the sharer's vault."

#: src/components/Layout.tsx:209
msgid "Memory"
msgstr "Memory"

#: src/pages/MemoryPage.tsx:399
msgid "Memory archived"
msgstr "Memory archived"

#: src/pages/MemoryPage.tsx:1318
msgid "Memory audit trail"
msgstr "Memory audit trail"

#: src/pages/MemoryPage.tsx:456
msgid "Memory corrected"
msgstr "Memory corrected"

#: src/pages/MemoryPage.tsx:378
msgid "Memory deleted"
msgstr "Memory deleted"

#: src/pages/MemoryPage.tsx:542
msgid "Memory erased and encryption keys destroyed"
msgstr "Memory erased and encryption keys destroyed"

#: src/pages/MemoryPage.tsx:532
msgid "Memory exported"
msgstr "Memory exported"

#: src/pages/MemoryPage.tsx:803
msgid "Memory is off"
msgstr "Memory is off"

#: src/pages/MemoryPage.tsx:1170
msgid "Memory is off, so nothing has been remembered."
msgstr "Memory is off, so nothing has been remembered."

#: src/pages/MemoryPage.tsx:927
msgid "Memory is off, so team memory takes effect once you turn memory on."
msgstr "Memory is off, so team memory takes effect once you turn memory on."

#: src/pages/MemoryPage.tsx:803
msgid "Memory is on"
msgstr "Memory is on"

#: src/pages/MemoryPage.tsx:389
msgid "Memory pinned"
msgstr "Memory pinned"

#: src/pages/MemoryPage.tsx:409
msgid "Memory restored"
msgstr "Memory restored"

#: src/pages/MemoryPage.tsx:345
msgid "Memory settings updated"
msgstr "Memory settings updated"

#: src/pages/MemoryPage.tsx:285
msgid "Memory shared with your team"
msgstr "Memory shared with your team"

#: src/pages/MemoryPage.tsx:791
msgid "Memory that follows you across every AI. Stored as Privacy Twins: PrivacyPal holds the shape of what you know, never your secrets."
msgstr "Memory that follows you across every AI. Stored as Privacy Twins: PrivacyPal holds the shape of what you know, never your secrets."

#: src/pages/MemoryPage.tsx:389
msgid "Memory unpinned"
msgstr "Memory unpinned"

#: src/pages/UserDetailAuditPage.tsx:1041
msgid "Metadata & Tokens"
msgstr "Metadata & Tokens"

#: src/pages/PrivateMcpPage.tsx:399
msgid "Microsoft 365 app registration removed"
msgstr "Microsoft 365 app registration removed"

#: src/pages/PrivateMcpPage.tsx:377
msgid "Microsoft 365 app registration saved"
msgstr "Microsoft 365 app registration saved"

#: src/pages/PrivateMcpPage.tsx:1027
#: src/pages/PrivateMcpPage.tsx:1222
msgid "Missing"
msgstr "Missing"

#: src/pages/VerifyEmailPage.tsx:24
msgid "Missing verification token. Please use the link from your email."
msgstr "Missing verification token. Please use the link from your email."

#: src/pages/UserDetailAuditPage.tsx:1052
msgid "Model"
msgstr "Model"

#: src/pages/AgentsPage.tsx:1086
msgid "Model:"
msgstr "Model:"

#: src/pages/ConnectionsPage.tsx:613
msgid "Monitor Slack messages across channels and direct messages for sensitive data and PII exposure."
msgstr "Monitor Slack messages across channels and direct messages for sensitive data and PII exposure."

#: src/pages/SubscriptionPage.tsx:834
msgid "month"
msgstr "month"

#: src/pages/SubscriptionPage.tsx:835
msgid "monthly"
msgstr "monthly"

#: src/components/UpgradeModal.tsx:198
#: src/pages/SubscriptionPage.tsx:187
#: src/pages/SubscriptionPage.tsx:323
#: src/pages/SubscriptionPage.tsx:402
#: src/pages/SubscriptionPage.tsx:882
msgid "Monthly"
msgstr "Monthly"

#: src/pages/SubscriptionPage.tsx:831
msgid "Monthly Bill"
msgstr "Monthly Bill"

#: src/components/ProviderDetailModal.tsx:302
msgid "Monthly prompts by tool"
msgstr "Monthly prompts by tool"

#: src/pages/PrivateMcpPage.tsx:1273
msgid "More connectors coming soon"
msgstr "More connectors coming soon"

#: src/pages/PrivateMcpPage.tsx:1259
msgid "More Private MCP connectors are coming soon"
msgstr "More Private MCP connectors are coming soon"

#: src/pages/ConnectionsPage.tsx:911
#: src/pages/PrivateMcpPage.tsx:600
#: src/pages/PrivateMcpPage.tsx:669
msgid "My Domain login URL"
msgstr "My Domain login URL"

#: src/pages/MemoryPage.tsx:401
#~ msgid "My memory"
#~ msgstr "My memory"

#: src/pages/SubscriptionPage.tsx:927
#: src/pages/UserDetailAuditPage.tsx:581
msgid "N/A"
msgstr "N/A"

#: src/pages/AgentsPage.tsx:669
#: src/pages/ApiKeysPage.tsx:133
#: src/pages/ApiKeysPage.tsx:182
#: src/pages/DictionaryManagementPage.tsx:205
msgid "Name"
msgstr "Name"

#: src/pages/InvitePage.tsx:687
msgid "name@company.com"
msgstr "name@company.com"

#: src/components/Layout.tsx:644
msgid "Native builds for Apple Silicon and Intel Macs. Pick the one that matches your chip."
msgstr "Native builds for Apple Silicon and Intel Macs. Pick the one that matches your chip."

#: src/pages/ApiKeysPage.tsx:75
msgid "Never"
msgstr "Never"

#: src/pages/SubscriptionPage.tsx:543
msgid "New Card Details"
msgstr "New Card Details"

#: src/pages/AgentsPage.tsx:647
msgid "New Catalog"
msgstr "New Catalog"

#: src/pages/MemoryPage.tsx:807
msgid "New conversations build your memory, and relevant memories are shared with the AI you are using."
msgstr "New conversations build your memory, and relevant memories are shared with the AI you are using."

#: src/pages/ResetPasswordPage.tsx:193
msgid "New password"
msgstr "New password"

#: src/pages/AgentsPage.tsx:423
#: src/pages/AgentsPage.tsx:790
msgid "New Privacy Agent"
msgstr "New Privacy Agent"

#: src/pages/SubscriptionPage.tsx:920
msgid "Next Billing Cycle"
msgstr "Next Billing Cycle"

#: src/components/connections/ConnectionHealthPanel.tsx:71
msgid "Next rebuild"
msgstr "Next rebuild"

#: src/pages/AgentsPage.tsx:742
#: src/pages/DictionaryManagementPage.tsx:301
msgid "No"
msgstr "No"

#: src/components/ProviderDetailModal.tsx:273
msgid "No {providerName} activity in the last {days} days"
msgstr "No {providerName} activity in the last {days} days"

#: src/utils/licenses.ts:197
msgid "No {tierLabel} seats available. Purchase additional {tierLabel} seats through your PrivacyPal contact."
msgstr "No {tierLabel} seats available. Purchase additional {tierLabel} seats through your PrivacyPal contact."

#: src/pages/ApiKeysPage.tsx:125
msgid "No active API keys. Generate one to get started with the SDK."
msgstr "No active API keys. Generate one to get started with the SDK."

#: src/pages/DashboardPage.tsx:686
msgid "No activity"
msgstr "No activity"

#: src/pages/MemoryPage.tsx:1322
msgid "No activity recorded yet."
msgstr "No activity recorded yet."

#: src/pages/AgentsPage.tsx:436
msgid "No agents yet. Click <0>New Privacy Agent</0> to create your first one."
msgstr "No agents yet. Click <0>New Privacy Agent</0> to create your first one."

#: src/pages/UserDetailAuditPage.tsx:919
msgid "No audit logs available"
msgstr "No audit logs available"

#: src/pages/UserDetailAuditPage.tsx:919
msgid "No audit logs match your search"
msgstr "No audit logs match your search"

#: src/components/UpgradeModal.tsx:401
msgid "No card needed"
msgstr "No card needed"

#: src/pages/AgentsPage.tsx:659
#: src/pages/DictionaryManagementPage.tsx:194
msgid "No catalogs found. Create your first catalog to get started."
msgstr "No catalogs found. Create your first catalog to get started."

#: src/components/UpgradeModal.tsx:457
msgid "No code yet?"
msgstr "No code yet?"

#: src/pages/SignupPage.tsx:600
msgid "No credit card needed for Pro. Upgrade whenever you're ready."
msgstr "No credit card needed for Pro. Upgrade whenever you're ready."

#: src/pages/MemoryPage.tsx:1238
msgid "No dated memories yet. Events and plans show up here by month."
msgstr "No dated memories yet. Events and plans show up here by month."

#: src/pages/UserDetailAuditPage.tsx:410
#: src/pages/UserDetailAuditPage.tsx:856
#: src/pages/UserDetailAuditPage.tsx:857
#: src/pages/UserDetailAuditPage.tsx:898
msgid "No encoded prompt"
msgstr "No encoded prompt"

#: src/pages/MemoryPage.tsx:768
msgid "No evidence is stored for this memory. It may have been imported or typed in by you."
msgstr "No evidence is stored for this memory. It may have been imported or typed in by you."

#: src/pages/AgentsPage.tsx:1150
msgid "No execution history found for this agent."
msgstr "No execution history found for this agent."

#: src/pages/UserDetailAuditPage.tsx:560
msgid "No file attachments detected."
msgstr "No file attachments detected."

#: src/pages/PrivateMcpPage.tsx:1033
msgid "No Google Workspace app is registered yet. Ask an administrator to add one here."
msgstr "No Google Workspace app is registered yet. Ask an administrator to add one here."

#: src/pages/PrivateMcpPage.tsx:1228
msgid "No HubSpot MCP connector is registered yet. Ask an administrator to add one here."
msgstr "No HubSpot MCP connector is registered yet. Ask an administrator to add one here."

#: src/pages/OnboardingPage.tsx:484
msgid "No lock-in"
msgstr "No lock-in"

#: src/pages/MemoryPage.tsx:1169
msgid "No memories yet. Keep using your AI apps; memories are distilled in the background."
msgstr "No memories yet. Keep using your AI apps; memories are distilled in the background."

#: src/pages/PrivateMcpPage.tsx:843
msgid "No Microsoft 365 app is registered yet. Ask an administrator to add one here."
msgstr "No Microsoft 365 app is registered yet. Ask an administrator to add one here."

#: src/pages/PrivateMcpPage.tsx:1321
msgid "No one has connected yet."
msgstr "No one has connected yet."

#: src/pages/SubscriptionPage.tsx:507
msgid "No payment method on file"
msgstr "No payment method on file"

#: src/pages/MemoryPage.tsx:1280
msgid "No people or projects yet. They appear once a few memories mention the same name."
msgstr "No people or projects yet. They appear once a few memories mention the same name."

#: src/pages/MemoryPage.tsx:1359
msgid "No per-note explanation was recorded."
msgstr "No per-note explanation was recorded."

#: src/utils/licenses.ts:196
msgid "No Pro seats available. Pro is an individual account; team seats run on Max."
msgstr "No Pro seats available. Pro is an individual account; team seats run on Max."

#: src/pages/UserDetailAuditPage.tsx:975
#~ msgid "No prompt text"
#~ msgstr "No prompt text"

#: src/pages/DashboardPage.tsx:61
msgid "No prompts"
msgstr "No prompts"

#: src/pages/PrivateMcpPage.tsx:685
msgid "No Salesforce app is registered yet. Ask an administrator to add one here."
msgstr "No Salesforce app is registered yet. Ask an administrator to add one here."

#: src/pages/ConnectionsPage.tsx:817
msgid "No sensitive data indexed yet. Click \"Scan\" on any active connection or \"Sync All\" to begin."
msgstr "No sensitive data indexed yet. Click \"Scan\" on any active connection or \"Sync All\" to begin."

#: src/pages/UserDetailAuditPage.tsx:745
msgid "No usage data available"
msgstr "No usage data available"

#: src/pages/DashboardPage.tsx:539
msgid "No usage data yet"
msgstr "No usage data yet"

#: src/pages/UserDetailAuditPage.tsx:550
msgid "No user data available for analysis."
msgstr "No user data available for analysis."

#: src/pages/UserManagementPage.tsx:277
#: src/pages/UserManagementPage.tsx:394
msgid "No users found."
msgstr "No users found."

#: src/pages/OnboardingPage.tsx:434
msgid "Non-technical"
msgstr "Non-technical"

#: src/pages/PrivateMcpPage.tsx:49
msgid "Not configured"
msgstr "Not configured"

#: src/pages/PrivateMcpPage.tsx:588
#: src/pages/PrivateMcpPage.tsx:765
#: src/pages/PrivateMcpPage.tsx:927
#: src/pages/PrivateMcpPage.tsx:1121
msgid "Not configured yet"
msgstr "Not configured yet"

#: src/pages/SubscriptionPage.tsx:1060
msgid "Not now"
msgstr "Not now"

#: src/pages/MemoryPage.tsx:1069
msgid "Not refreshed yet"
msgstr "Not refreshed yet"

#: src/pages/UserDetailAuditPage.tsx:559
msgid "Notably, {pdfCount} PDF and {csvCount} CSV files have been shared."
msgstr "Notably, {pdfCount} PDF and {csvCount} CSV files have been shared."

#: src/pages/UserDetailAuditPage.tsx:698
msgid "Note: Analytic Agent is a placeholder. Real AI analysis coming soon."
msgstr "Note: Analytic Agent is a placeholder. Real AI analysis coming soon."

#: src/pages/MemoryPage.tsx:875
msgid "Notes on these topics may be recalled only in conversations on the same topic."
msgstr "Notes on these topics may be recalled only in conversations on the same topic."

#: src/pages/MemoryPage.tsx:1047
msgid "Nothing compiled yet."
msgstr "Nothing compiled yet."

#: src/pages/MemoryPage.tsx:1167
msgid "Nothing here."
msgstr "Nothing here."

#: src/pages/MemoryPage.tsx:1402
msgid "Nothing shared yet. Use the Share button on one of your memories to give your team stable context."
msgstr "Nothing shared yet. Use the Share button on one of your memories to give your team stable context."

#: src/pages/LoginPage.tsx:50
msgid "OAuth callback error. Please try again."
msgstr "OAuth callback error. Please try again."

#: src/pages/PrivateMcpPage.tsx:922
msgid "OAuth client"
msgstr "OAuth client"

#: src/pages/PrivateMcpPage.tsx:939
#: src/pages/PrivateMcpPage.tsx:1015
msgid "OAuth client ID"
msgstr "OAuth client ID"

#: src/pages/PrivateMcpPage.tsx:952
msgid "OAuth client secret"
msgstr "OAuth client secret"

#: src/components/ProviderDetailModal.tsx:215
msgid "of {userCount} team members"
msgstr "of {userCount} team members"

#: src/pages/MemoryPage.tsx:923
msgid "Off. Team memory is opt in: turn it on to use the memories your teammates shared. Nothing of yours becomes visible until you share a memory yourself, and what teammates see is Privacy Twins, never your real values."
msgstr "Off. Team memory is opt in: turn it on to use the memories your teammates shared. Nothing of yours becomes visible until you share a memory yourself, and what teammates see is Privacy Twins, never your real values."

#: src/pages/MemoryPage.tsx:922
msgid "On. Memories your teammates shared are used alongside your own, and teammates see only the memories you explicitly shared. Everything they see is Privacy Twins; real values never leave your vault."
msgstr "On. Memories your teammates shared are used alongside your own, and teammates see only the memories you explicitly shared. Everything they see is Privacy Twins; real values never leave your vault."

#: src/pages/UserDetailAuditPage.tsx:1084
msgid "Onchain Audit Transaction"
msgstr "Onchain Audit Transaction"

#: src/pages/SubscriptionPage.tsx:174
#~ msgid "One seat, one person. Your login, your devices."
#~ msgstr "One seat, one person. Your login, your devices."

#: src/pages/PrivateMcpPage.tsx:689
#: src/pages/PrivateMcpPage.tsx:847
#: src/pages/PrivateMcpPage.tsx:1037
#: src/pages/PrivateMcpPage.tsx:1232
msgid "Only administrators can change this registration."
msgstr "Only administrators can change this registration."

#: src/pages/SubscriptionPage.tsx:417
#~ msgid "Only for a domain with a single user. Teams run on Max."
#~ msgstr "Only for a domain with a single user. Teams run on Max."

#: src/components/Layout.tsx:332
msgid "Open menu"
msgstr "Open menu"

#: src/pages/MemoryPage.tsx:104
msgid "Opinion"
msgstr "Opinion"

#. placeholder {0}: oauthOptionalScopes.join(', ')
#: src/pages/ConnectionsPage.tsx:964
msgid "Optional scopes (custom objects, custom properties, tickets): <0>{0}</0>"
msgstr "Optional scopes (custom objects, custom properties, tickets): <0>{0}</0>"

#: src/pages/LoginPage.tsx:338
msgid "OR"
msgstr "OR"

#: src/components/Layout.tsx:609
msgid "Or install via command line"
msgstr "Or install via command line"

#: src/pages/InvitePage.tsx:657
#: src/pages/SignupPage.tsx:472
msgid "Or via Email"
msgstr "Or via Email"

#: src/pages/UserDetailAuditPage.tsx:1009
msgid "Original Prompt Text"
msgstr "Original Prompt Text"

#: src/pages/UserDetailAuditPage.tsx:976
msgid "Original:"
msgstr "Original:"

#. placeholder {0}: detail.packConfidence.toFixed(2)
#: src/pages/MemoryPage.tsx:1355
msgid "pack confidence {0}"
msgstr "pack confidence {0}"

#: src/pages/AgentsPage.tsx:1090
msgid "Parse Attempts:"
msgstr "Parse Attempts:"

#: src/pages/ConnectionsPage.tsx:1133
msgid "Passthrough Authorization"
msgstr "Passthrough Authorization"

#: src/pages/ConnectionsPage.tsx:1073
#: src/pages/InvitePage.tsx:695
#: src/pages/LoginPage.tsx:300
#: src/pages/SignupPage.tsx:491
msgid "Password"
msgstr "Password"

#: src/pages/SignupPage.tsx:200
msgid "Password does not meet the requirements below"
msgstr "Password does not meet the requirements below"

#: src/pages/InvitePage.tsx:99
msgid "Password must be at least 8 characters"
msgstr "Password must be at least 8 characters"

#: src/pages/InvitePage.tsx:103
msgid "Password must include an uppercase letter, a lowercase letter, and a number"
msgstr "Password must include an uppercase letter, a lowercase letter, and a number"

#: src/pages/ResetPasswordPage.tsx:258
msgid "Password updated"
msgstr "Password updated"

#: src/pages/InvitePage.tsx:94
#: src/pages/SignupPage.tsx:203
msgid "Passwords do not match"
msgstr "Passwords do not match"

#: src/pages/ResetPasswordPage.tsx:88
#: src/pages/ResetPasswordPage.tsx:241
msgid "Passwords do not match."
msgstr "Passwords do not match."

#: src/pages/UserDetailAuditPage.tsx:793
msgid "Past {days} days"
msgstr "Past {days} days"

#: src/pages/UserDetailAuditPage.tsx:793
msgid "Past 1 year"
msgstr "Past 1 year"

#: src/pages/AgentsPage.tsx:966
msgid "Paste audit data, pipeline logs, or a summary for the agent to analyze..."
msgstr "Paste audit data, pipeline logs, or a summary for the agent to analyze..."

#: src/pages/AgentsPage.tsx:965
msgid "Paste or type the prompt you want the agent to analyze for PII handling decisions..."
msgstr "Paste or type the prompt you want the agent to analyze for PII handling decisions..."

#: src/pages/MemoryPage.tsx:1213
msgid "Paste the exported memory text here"
msgstr "Paste the exported memory text here"

#: src/pages/MemoryPage.tsx:1193
msgid "Paste the memory export from ChatGPT, Claude or Gemini. It is protected before it leaves the browser: the text is turned into Privacy Twins first, and only that twin-space version is ever stored."
msgstr "Paste the memory export from ChatGPT, Claude or Gemini. It is protected before it leaves the browser: the text is turned into Privacy Twins first, and only that twin-space version is ever stored."

#: src/pages/ConnectionsPage.tsx:603
msgid "Paste your Box application JSON config or developer token"
msgstr "Paste your Box application JSON config or developer token"

#: src/pages/ConnectionsPage.tsx:604
msgid "Paste your Dropbox app access token"
msgstr "Paste your Dropbox app access token"

#: src/pages/ConnectionsPage.tsx:600
msgid "Paste your Google Cloud service account JSON key or API key"
msgstr "Paste your Google Cloud service account JSON key or API key"

#: src/pages/ConnectionsPage.tsx:602
msgid "Paste your Notion internal integration token (secret_...)"
msgstr "Paste your Notion internal integration token (secret_...)"

#: src/pages/ConnectionsPage.tsx:613
msgid "Paste your Slack Bot User OAuth Token (xoxb-...)"
msgstr "Paste your Slack Bot User OAuth Token (xoxb-...)"

#: src/pages/ConnectionsPage.tsx:615
msgid "Paste your Telegram Bot API token from @BotFather"
msgstr "Paste your Telegram Bot API token from @BotFather"

#: src/pages/MemoryPage.tsx:851
msgid "Pause capture and recall without deleting anything."
msgstr "Pause capture and recall without deleting anything."

#: src/components/UpgradeModal.tsx:159
#: src/pages/SubscriptionPage.tsx:286
msgid "Payment failed"
msgstr "Payment failed"

#: src/pages/OnboardingPage.tsx:149
#~ msgid "Payment failed. Please try again."
#~ msgstr "Payment failed. Please try again."

#: src/pages/SubscriptionPage.tsx:680
msgid "Payment failed. Update the payment method below, then try the upgrade again."
msgstr "Payment failed. Update the payment method below, then try the upgrade again."

#: src/utils/licenses.ts:203
msgid "Payment failed. Update the payment method on the Subscription page."
msgstr "Payment failed. Update the payment method on the Subscription page."

#: src/pages/DashboardPage.tsx:300
msgid "Payment failed. Update your payment method to keep protection active."
msgstr "Payment failed. Update your payment method to keep protection active."

#: src/pages/SignupPage.tsx:672
#~ msgid "Payment Information"
#~ msgstr "Payment Information"

#: src/pages/SubscriptionPage.tsx:492
msgid "Payment Method"
msgstr "Payment Method"

#: src/pages/SubscriptionPage.tsx:466
msgid "Payment method updated successfully"
msgstr "Payment method updated successfully"

#: src/pages/SignupPage.tsx:117
#~ msgid "Payment Summary"
#~ msgstr "Payment Summary"

#: src/pages/MemoryPage.tsx:643
msgid "People & projects"
msgstr "People & projects"

#: src/pages/SubscriptionPage.tsx:121
msgid "Per seat per month. All seats bill at your band."
msgstr "Per seat per month. All seats bill at your band."

#: src/pages/SubscriptionPage.tsx:120
msgid "Per seat, billed annually. All seats bill at your band."
msgstr "Per seat, billed annually. All seats bill at your band."

#: src/pages/MemoryPage.tsx:736
msgid "Pin"
msgstr "Pin"

#: src/pages/MemoryPage.tsx:688
msgid "Pinned"
msgstr "Pinned"

#: src/pages/SubscriptionPage.tsx:920
msgid "Plan Ends"
msgstr "Plan Ends"

#: src/pages/UserDetailAuditPage.tsx:1044
msgid "Platform"
msgstr "Platform"

#: src/pages/UserDetailAuditPage.tsx:757
msgid "Platforms"
msgstr "Platforms"

#: src/pages/SignupPage.tsx:197
msgid "Please enter a valid email address"
msgstr "Please enter a valid email address"

#: src/pages/InvitePage.tsx:89
msgid "Please fill in all fields"
msgstr "Please fill in all fields"

#: src/pages/LoginPage.tsx:73
msgid "Please verify your email before signing in."
msgstr "Please verify your email before signing in."

#: src/pages/LoginPage.tsx:331
msgid "Please wait..."
msgstr "Please wait..."

#: src/pages/PrivateMcpPage.tsx:1103
msgid "Point your AI assistant at this URL instead of HubSpot's own MCP server. PrivacyPal fronts HubSpot's MCP server and translates between twins and real CRM data at the boundary. Records created and updated through it carry real values, and HubSpot's write confirmations reach you with twins in place of real values."
msgstr "Point your AI assistant at this URL instead of HubSpot's own MCP server. PrivacyPal fronts HubSpot's MCP server and translates between twins and real CRM data at the boundary. Records created and updated through it carry real values, and HubSpot's write confirmations reach you with twins in place of real values."

#: src/pages/PrivateMcpPage.tsx:911
msgid "Point your AI assistant at this URL; PrivacyPal translates between twins and real Google Workspace data at the boundary. Mail sent and files written through it carry real values."
msgstr "Point your AI assistant at this URL; PrivacyPal translates between twins and real Google Workspace data at the boundary. Mail sent and files written through it carry real values."

#: src/pages/PrivateMcpPage.tsx:749
msgid "Point your AI assistant at this URL; PrivacyPal translates between twins and real Microsoft 365 data at the boundary. Mail sent and files written through it carry real values."
msgstr "Point your AI assistant at this URL; PrivacyPal translates between twins and real Microsoft 365 data at the boundary. Mail sent and files written through it carry real values."

#: src/pages/PrivateMcpPage.tsx:572
msgid "Point your AI assistant at this URL; PrivacyPal translates between twins and real Salesforce data at the boundary."
msgstr "Point your AI assistant at this URL; PrivacyPal translates between twins and real Salesforce data at the boundary."

#: src/pages/ConnectionsPage.tsx:520
msgid "Popup blocked. Please allow popups for this site and try again."
msgstr "Popup blocked. Please allow popups for this site and try again."

#: src/pages/ConnectionsPage.tsx:1060
msgid "Port"
msgstr "Port"

#: src/pages/AgentsPage.tsx:805
msgid "Pre-defined Agents"
msgstr "Pre-defined Agents"

#: src/pages/MemoryPage.tsx:101
msgid "Preference"
msgstr "Preference"

#: src/App.tsx:141
#: src/pages/AgentsPage.tsx:404
msgid "Privacy Agents"
msgstr "Privacy Agents"

#: src/pages/OnboardingPage.tsx:395
msgid "Privacy Twin"
msgstr "Privacy Twin"

#: src/pages/UserDetailAuditPage.tsx:1017
msgid "Privacy Twin (Encoded) Prompt"
msgstr "Privacy Twin (Encoded) Prompt"

#: src/pages/UserDetailAuditPage.tsx:984
msgid "Privacy Twin (Encoded):"
msgstr "Privacy Twin (Encoded):"

#: src/pages/OnboardingPage.tsx:479
msgid "PrivacyPal doesn't sleep."
msgstr "PrivacyPal doesn't sleep."

#: src/pages/OnboardingPage.tsx:429
msgid "PrivacyPal fits into your workflow, whether you're building integrations or simply want it to run quietly in the background."
msgstr "PrivacyPal fits into your workflow, whether you're building integrations or simply want it to run quietly in the background."

#: src/components/Layout.tsx:556
msgid "PrivacyPal for desktop"
msgstr "PrivacyPal for desktop"

#: src/pages/OnboardingPage.tsx:533
msgid "PrivacyPal is live. Taking you to your dashboard…"
msgstr "PrivacyPal is live. Taking you to your dashboard…"

#: src/pages/OnboardingPage.tsx:325
msgid "PrivacyPal Layer"
msgstr "PrivacyPal Layer"

#: src/pages/SignupPage.tsx:630
#: src/pages/SubscriptionPage.tsx:768
#: src/pages/SubscriptionPage.tsx:784
msgid "PrivacyPal Max"
msgstr "PrivacyPal Max"

#: src/pages/MemoryPage.tsx:331
msgid "PrivacyPal Max is required for team memory. Ask your admin to upgrade your seat."
msgstr "PrivacyPal Max is required for team memory. Ask your admin to upgrade your seat."

#: src/components/MaxUpsell.tsx:39
#~ msgid "PrivacyPal Max is required for this feature"
#~ msgstr "PrivacyPal Max is required for this feature"

#: src/pages/MemoryPage.tsx:289
msgid "PrivacyPal Max is required to share memories"
msgstr "PrivacyPal Max is required to share memories"

#: src/pages/SignupPage.tsx:615
msgid "PrivacyPal Pro"
msgstr "PrivacyPal Pro"

#: src/pages/SubscriptionPage.tsx:768
msgid "PrivacyPal Pro, free"
msgstr "PrivacyPal Pro, free"

#: src/App.tsx:208
#: src/components/Layout.tsx:238
#: src/pages/PrivateMcpPage.tsx:517
msgid "Private MCP"
msgstr "Private MCP"

#: src/pages/SubscriptionPage.tsx:53
msgid "Private MCP, Privacy Agents, IP Connections, agent governance, Multiplayer Memory"
msgstr "Private MCP, Privacy Agents, IP Connections, agent governance, Multiplayer Memory"

#: src/pages/PrivateMcpPage.tsx:519
msgid "Private MCPs let your AI assistant work with your business systems while it only ever sees Privacy Twins. PrivacyPal translates between twins and real data at the system boundary. Each connector below is its own Private MCP."
msgstr "Private MCPs let your AI assistant work with your business systems while it only ever sees Privacy Twins. PrivacyPal translates between twins and real data at the system boundary. Each connector below is its own Private MCP."

#: src/pages/MemoryPage.tsx:789
msgid "Private Memory"
msgstr "Private Memory"

#: src/pages/DashboardPage.tsx:376
msgid "Pro (Free)"
msgstr "Pro (Free)"

#: src/utils/licenses.ts:153
msgid "Pro is an individual account (one seat, one person), so a team cannot add Pro seats; this move is refused."
msgstr "Pro is an individual account (one seat, one person), so a team cannot add Pro seats; this move is refused."

#: src/utils/licenses.ts:192
msgid "Pro is an individual account. A domain with more than one user runs on Max for every user."
msgstr "Pro is an individual account. A domain with more than one user runs on Max for every user."

#: src/pages/DashboardPage.tsx:376
msgid "Pro Plan"
msgstr "Pro Plan"

#: src/pages/SignupPage.tsx:125
#~ msgid "Pro Plan (individual)"
#~ msgstr "Pro Plan (individual)"

#: src/pages/OnboardingPage.tsx:166
#~ msgid "Pro Plan: {trialDays}-Day Trial"
#~ msgstr "Pro Plan: {trialDays}-Day Trial"

#: src/components/UpgradeModal.tsx:302
#: src/components/UpgradeModal.tsx:523
#: src/pages/SubscriptionPage.tsx:420
msgid "Processing..."
msgstr "Processing..."

#: src/pages/MemoryPage.tsx:640
msgid "Profile"
msgstr "Profile"

#: src/pages/MemoryPage.tsx:482
msgid "Profile refreshed from your memories"
msgstr "Profile refreshed from your memories"

#: src/pages/MemoryPage.tsx:469
msgid "Profile updated"
msgstr "Profile updated"

#: src/components/UpgradeModal.tsx:216
#: src/pages/SubscriptionPage.tsx:365
#: src/pages/SubscriptionPage.tsx:858
msgid "Promo Code"
msgstr "Promo Code"

#: src/pages/OnboardingPage.tsx:178
#~ msgid "Promo Code <0>(optional)</0>"
#~ msgstr "Promo Code <0>(optional)</0>"

#: src/pages/SignupPage.tsx:634
#~ msgid "Promotion Code"
#~ msgstr "Promotion Code"

#. placeholder {0}: promptIdx + 1
#: src/pages/UserDetailAuditPage.tsx:896
#: src/pages/UserDetailAuditPage.tsx:969
msgid "Prompt {0}"
msgstr "Prompt {0}"

#: src/components/ProviderDetailModal.tsx:361
#: src/components/ProviderDetailModal.tsx:363
msgid "Prompt share by tool"
msgstr "Prompt share by tool"

#: src/pages/DashboardPage.tsx:601
msgid "prompts"
msgstr "prompts"

#: src/components/ProviderDetailModal.tsx:402
#: src/pages/DashboardPage.tsx:634
msgid "Prompts"
msgstr "Prompts"

#: src/components/ProviderDetailModal.tsx:201
msgid "Prompts protected"
msgstr "Prompts protected"

#: src/components/ProviderDetailModal.tsx:276
msgid "Prompts sent through {toolNames} will appear here once protected."
msgstr "Prompts sent through {toolNames} will appear here once protected."

#: src/pages/DashboardPage.tsx:347
msgid "Prompts This Month"
msgstr "Prompts This Month"

#: src/pages/ConnectionsPage.tsx:1151
msgid ""
"Properties to skip, e.g. deals.amount, companies.secret_codename\n"
"Separate with commas or new lines"
msgstr ""
"Properties to skip, e.g. deals.amount, companies.secret_codename\n"
"Separate with commas or new lines"

#: src/components/UpgradeModal.tsx:627
msgid "Protect every AI surface: Cowork, Claude Code, Codex, Copilot, agents and the APIs, plus Connections, Private MCP, API access and full usage history."
msgstr "Protect every AI surface: Cowork, Claude Code, Codex, Copilot, agents and the APIs, plus Connections, Private MCP, API access and full usage history."

#: src/pages/DashboardPage.tsx:328
msgid "Protect everything with Max"
msgstr "Protect everything with Max"

#: src/pages/DashboardPage.tsx:554
#: src/pages/UserDetailAuditPage.tsx:1048
msgid "Protected from"
msgstr "Protected from"

#: src/pages/OnboardingPage.tsx:367
msgid "Protected output"
msgstr "Protected output"

#: src/pages/DashboardPage.tsx:429
msgid "Protected prompts per day, by AI app"
msgstr "Protected prompts per day, by AI app"

#: src/pages/OnboardingPage.tsx:384
msgid "Protected text will appear here"
msgstr "Protected text will appear here"

#: src/pages/SubscriptionPage.tsx:788
msgid "Protection on every AI surface: Cowork, Claude Code, Codex, Copilot, Grok Bot, Hermes and the OpenAI, Anthropic and xAI APIs"
msgstr "Protection on every AI surface: Cowork, Claude Code, Codex, Copilot, Grok Bot, Hermes and the OpenAI, Anthropic and xAI APIs"

#: src/components/Layout.tsx:691
msgid "Protects command-line AI agents on Ubuntu, Fedora and WSL. This is a headless CLI, not a desktop app: it covers agents such as Claude Code and Codex, and does not cover browser AI."
msgstr "Protects command-line AI agents on Ubuntu, Fedora and WSL. This is a headless CLI, not a desktop app: it covers agents such as Claude Code and Codex, and does not cover browser AI."

#: src/pages/DashboardPage.tsx:633
msgid "Provider"
msgstr "Provider"

#: src/pages/OnboardingPage.tsx:434
msgid "Proxy app & browser extension"
msgstr "Proxy app & browser extension"

#: src/utils/licenses.ts:154
msgid "Purchase additional {tierLabel} seats before moving this user; until then this move is refused."
msgstr "Purchase additional {tierLabel} seats before moving this user; until then this move is refused."

#: src/pages/MemoryPage.tsx:133
msgid "Quarantined"
msgstr "Quarantined"

#: src/pages/OnboardingPage.tsx:450
msgid "QUICK START"
msgstr "QUICK START"

#: src/pages/ConnectionsPage.tsx:603
msgid "Read access to all files and folders. Requires a Box custom app with Server Authentication (JWT)."
msgstr "Read access to all files and folders. Requires a Box custom app with Server Authentication (JWT)."

#: src/pages/ConnectionsPage.tsx:605
msgid "Read access to cabinets and workspaces. Requires API client credentials from the NetDocuments admin console."
msgstr "Read access to cabinets and workspaces. Requires API client credentials from the NetDocuments admin console."

#: src/pages/ConnectionsPage.tsx:602
msgid "Read content capability on the internal integration. Create an integration at notion.so/my-integrations."
msgstr "Read content capability on the internal integration. Create an integration at notion.so/my-integrations."

#: src/pages/ConnectionsPage.tsx:649
msgid "Read-only access (db_datareader role) to target databases. Service account with SELECT permission on relevant schemas."
msgstr "Read-only access (db_datareader role) to target databases. Service account with SELECT permission on relevant schemas."

#: src/pages/ConnectionsPage.tsx:600
msgid "Read-only access to files, folder listing, and metadata. Requires a Google Cloud service account key with Drive API enabled."
msgstr "Read-only access to files, folder listing, and metadata. Requires a Google Cloud service account key with Drive API enabled."

#: src/pages/ConnectionsPage.tsx:650
msgid "Read-only user with find permission on target databases/collections. Connection via standard MongoDB URI."
msgstr "Read-only user with find permission on target databases/collections. Connection via standard MongoDB URI."

#: src/pages/ConnectionsPage.tsx:651
msgid "Read-only user with SELECT privilege on target databases. CREATE USER with limited grants recommended."
msgstr "Read-only user with SELECT privilege on target databases. CREATE USER with limited grants recommended."

#: src/pages/OnboardingPage.tsx:505
msgid "Ready to activate."
msgstr "Ready to activate."

#: src/pages/OnboardingPage.tsx:394
msgid "Real Value"
msgstr "Real Value"

#: src/pages/AgentsPage.tsx:476
#: src/pages/AgentsPage.tsx:847
#: src/pages/AgentsPage.tsx:894
msgid "Real-time"
msgstr "Real-time"

#: src/pages/AgentsPage.tsx:950
#: src/pages/AgentsPage.tsx:1017
msgid "Real-time Agent"
msgstr "Real-time Agent"

#: src/pages/AgentsPage.tsx:855
msgid "Real-time agents execute during streaming encode/decode operations to block, augment, or configure the pipeline."
msgstr "Real-time agents execute during streaming encode/decode operations to block, augment, or configure the pipeline."

#: src/pages/OnboardingPage.tsx:325
msgid "Real-time interception & masking with Privacy Twins"
msgstr "Real-time interception & masking with Privacy Twins"

#: src/pages/SubscriptionPage.tsx:774
msgid "Real-time protection for ChatGPT, Claude, Gemini, Grok and Perplexity chats, attachments included. No card on file, nothing to cancel, free forever."
msgstr "Real-time protection for ChatGPT, Claude, Gemini, Grok and Perplexity chats, attachments included. No card on file, nothing to cancel, free forever."

#: src/pages/SignupPage.tsx:619
msgid "Real-time protection for ChatGPT, Claude, Gemini, Grok and Perplexity chats, attachments included. One person, free forever."
msgstr "Real-time protection for ChatGPT, Claude, Gemini, Grok and Perplexity chats, attachments included. One person, free forever."

#: src/pages/InvitePage.tsx:511
msgid "Real-time scrubbing"
msgstr "Real-time scrubbing"

#: src/pages/OnboardingPage.tsx:326
msgid "Receive clean, safe data only"
msgstr "Receive clean, safe data only"

#: src/components/connections/ConnectionActions.tsx:37
msgid "Reconnect"
msgstr "Reconnect"

#: src/pages/ConnectionsPage.tsx:956
msgid "Redirect URL to register"
msgstr "Redirect URL to register"

#: src/pages/SubscriptionPage.tsx:302
msgid "Redirecting to dashboard..."
msgstr "Redirecting to dashboard..."

#: src/pages/PrivateMcpPage.tsx:1307
msgid "Refresh"
msgstr "Refresh"

#: src/pages/MemoryPage.tsx:1019
msgid "Refresh now"
msgstr "Refresh now"

#: src/pages/MemoryPage.tsx:1068
msgid "Refreshed on {refreshedOn} by {refreshedBy}"
msgstr "Refreshed on {refreshedOn} by {refreshedBy}"

#: src/pages/MemoryPage.tsx:1019
msgid "Refreshing…"
msgstr "Refreshing…"

#: src/pages/PrivateMcpPage.tsx:854
msgid "Register an app in your own Microsoft Entra tenant as a public client: add the redirect URI below under the \"Mobile and desktop applications\" platform, and grant the delegated Microsoft Graph permissions <0>{M365_PERMISSIONS}</0> (admin consent if your tenant requires it). Only these public values are kept here; no secret is stored with PrivacyPal."
msgstr "Register an app in your own Microsoft Entra tenant as a public client: add the redirect URI below under the \"Mobile and desktop applications\" platform, and grant the delegated Microsoft Graph permissions <0>{M365_PERMISSIONS}</0> (admin consent if your tenant requires it). Only these public values are kept here; no secret is stored with PrivacyPal."

#: src/pages/PrivateMcpPage.tsx:695
msgid "Register an External Client App in your own Salesforce org with the OAuth scopes <0>mcp_api</0> and <1>refresh_token</1> and PKCE enabled. Only these public values are kept here; no secret is stored with PrivacyPal."
msgstr "Register an External Client App in your own Salesforce org with the OAuth scopes <0>mcp_api</0> and <1>refresh_token</1> and PKCE enabled. Only these public values are kept here; no secret is stored with PrivacyPal."

#: src/pages/PrivateMcpPage.tsx:39
msgid "Registered"
msgstr "Registered"

#. placeholder {0}: formatEpochMs(app.updatedAt)
#. placeholder {0}: formatEpochMs(googleApp.updatedAt)
#. placeholder {0}: formatEpochMs(hubspotApp.updatedAt)
#: src/pages/PrivateMcpPage.tsx:586
#: src/pages/PrivateMcpPage.tsx:763
#: src/pages/PrivateMcpPage.tsx:925
#: src/pages/PrivateMcpPage.tsx:1119
msgid "Registered. Last updated {0}"
msgstr "Registered. Last updated {0}"

#: src/pages/InvitePage.tsx:162
#: src/pages/LoginPage.tsx:116
#: src/pages/SignupPage.tsx:293
msgid "Registration failed"
msgstr "Registration failed"

#: src/pages/MemoryPage.tsx:1118
msgid "Remember"
msgstr "Remember"

#: src/pages/MemoryPage.tsx:1092
msgid "Remember something"
msgstr "Remember something"

#: src/pages/MemoryPage.tsx:440
msgid "Remembered"
msgstr "Remembered"

#: src/pages/MemoryPage.tsx:1431
#: src/pages/PrivateMcpPage.tsx:1380
#: src/pages/PrivateMcpPage.tsx:1390
#: src/pages/PrivateMcpPage.tsx:1400
#: src/pages/PrivateMcpPage.tsx:1410
msgid "Remove"
msgstr "Remove"

#: src/pages/PrivateMcpPage.tsx:1378
#: src/pages/PrivateMcpPage.tsx:1388
#: src/pages/PrivateMcpPage.tsx:1398
#: src/pages/PrivateMcpPage.tsx:1408
msgid "Remove app registration"
msgstr "Remove app registration"

#: src/pages/PrivateMcpPage.tsx:659
#: src/pages/PrivateMcpPage.tsx:823
#: src/pages/PrivateMcpPage.tsx:1005
#: src/pages/PrivateMcpPage.tsx:1200
msgid "Remove registration"
msgstr "Remove registration"

#: src/pages/PrivateMcpPage.tsx:1399
msgid "Remove the Google OAuth client for this workspace? The stored client secret is deleted with it, and users will not be able to connect their assistants to Gmail or Drive until an administrator registers a client again."
msgstr "Remove the Google OAuth client for this workspace? The stored client secret is deleted with it, and users will not be able to connect their assistants to Gmail or Drive until an administrator registers a client again."

#: src/pages/PrivateMcpPage.tsx:1409
msgid "Remove the HubSpot MCP connector for this workspace? The stored client secret is deleted with it, and users will not be able to connect their assistants to HubSpot until an administrator registers a connector again."
msgstr "Remove the HubSpot MCP connector for this workspace? The stored client secret is deleted with it, and users will not be able to connect their assistants to HubSpot until an administrator registers a connector again."

#: src/pages/PrivateMcpPage.tsx:1389
msgid "Remove the Microsoft Entra app registration for this workspace? Users will not be able to connect their assistants to Microsoft 365 until an administrator registers an app again."
msgstr "Remove the Microsoft Entra app registration for this workspace? Users will not be able to connect their assistants to Microsoft 365 until an administrator registers an app again."

#: src/pages/PrivateMcpPage.tsx:1379
msgid "Remove the Salesforce External Client App registration for this workspace? Users will not be able to connect their assistants until an administrator registers an app again."
msgstr "Remove the Salesforce External Client App registration for this workspace? Users will not be able to connect their assistants until an administrator registers an app again."

#. placeholder {0}: new Date(account.subscriptionEndDate).toLocaleDateString()
#: src/pages/DashboardPage.tsx:399
msgid "Renews {0}"
msgstr "Renews {0}"

#: src/pages/ResetPasswordPage.tsx:164
msgid "Request a new link"
msgstr "Request a new link"

#: src/pages/ResetPasswordPage.tsx:157
msgid "Request a new one below."
msgstr "Request a new one below."

#: src/pages/ApiKeysPage.tsx:135
msgid "Requests"
msgstr "Requests"

#. placeholder {0}: (oauthScopes.length ? oauthScopes : ['api', 'refresh_token']).join(', ')
#: src/pages/ConnectionsPage.tsx:907
msgid "Required OAuth scopes: <0>{0}</0>"
msgstr "Required OAuth scopes: <0>{0}</0>"

#: src/pages/ConnectionsPage.tsx:872
msgid "Required Permissions"
msgstr "Required Permissions"

#. placeholder {0}: oauthScopes.join(', ') || '…'
#: src/pages/ConnectionsPage.tsx:962
msgid "Required scopes: <0>{0}</0>"
msgstr "Required scopes: <0>{0}</0>"

#: src/components/Layout.tsx:730
msgid "Requires a Max account. Run uname -m to check your architecture."
msgstr "Requires a Max account. Run uname -m to check your architecture."

#: src/pages/InvitePage.tsx:602
#: src/pages/LoginPage.tsx:221
#: src/pages/SignupPage.tsx:556
msgid "Resend code"
msgstr "Resend code"

#: src/pages/InvitePage.tsx:602
#: src/pages/LoginPage.tsx:221
#: src/pages/SignupPage.tsx:556
msgid "Resend code ({resendCooldown}s)"
msgstr "Resend code ({resendCooldown}s)"

#: src/pages/ForgotPasswordPage.tsx:96
msgid "Resend email"
msgstr "Resend email"

#: src/pages/ForgotPasswordPage.tsx:96
msgid "Resend email ({cooldown}s)"
msgstr "Resend email ({cooldown}s)"

#: src/pages/LoginPage.tsx:249
msgid "Resend verification email to {needsVerification}"
msgstr "Resend verification email to {needsVerification}"

#: src/pages/MemoryPage.tsx:125
msgid "Response preferences"
msgstr "Response preferences"

#: src/pages/MemoryPage.tsx:741
msgid "Restore"
msgstr "Restore"

#: src/components/connections/ConnectionActions.tsx:22
msgid "Retry scan"
msgstr "Retry scan"

#: src/pages/MemoryPage.tsx:998
msgid "Review"
msgstr "Review"

#: src/pages/ApiKeysPage.tsx:161
#: src/pages/PrivateMcpPage.tsx:1357
#: src/pages/PrivateMcpPage.tsx:1420
msgid "Revoke"
msgstr "Revoke"

#: src/pages/PrivateMcpPage.tsx:1418
msgid "Revoke connection"
msgstr "Revoke connection"

#: src/pages/PrivateMcpPage.tsx:557
#~ msgid "Revoke the {revokeConnectorId} connection for {revokeWho}? Their assistant will need to reconnect through Salesforce."
#~ msgstr "Revoke the {revokeConnectorId} connection for {revokeWho}? Their assistant will need to reconnect through Salesforce."

#: src/pages/PrivateMcpPage.tsx:1419
msgid "Revoke the {revokeConnectorId} connection for {revokeWho}? Their assistant will need to reconnect."
msgstr "Revoke the {revokeConnectorId} connection for {revokeWho}? Their assistant will need to reconnect."

#: src/pages/ApiKeysPage.tsx:186
msgid "Revoked"
msgstr "Revoked"

#. placeholder {0}: revokedKeys.length
#: src/pages/ApiKeysPage.tsx:176
msgid "Revoked Keys ({0})"
msgstr "Revoked Keys ({0})"

#: src/pages/ApiKeysPage.tsx:161
msgid "Revoking..."
msgstr "Revoking..."

#: src/pages/UserManagementPage.tsx:286
msgid "Role"
msgstr "Role"

#: src/pages/AgentsPage.tsx:821
msgid "RT"
msgstr "RT"

#. placeholder {0}: runInputModal.agent.name
#: src/pages/AgentsPage.tsx:948
msgid "Run {0}"
msgstr "Run {0}"

#: src/pages/AgentsPage.tsx:493
msgid "Run against recent audit data"
msgstr "Run against recent audit data"

#: src/components/Layout.tsx:589
msgid "Run PrivacyPal on your PC with a full installer. Optimized for the Windows 11 experience."
msgstr "Run PrivacyPal on your PC with a full installer. Optimized for the Windows 11 experience."

#: src/pages/OnboardingPage.tsx:412
msgid "Run Protection"
msgstr "Run Protection"

#: src/pages/AgentsPage.tsx:1083
msgid "Runtime:"
msgstr "Runtime:"

#: src/pages/PrivateMcpPage.tsx:363
msgid "Salesforce app registration removed"
msgstr "Salesforce app registration removed"

#: src/pages/PrivateMcpPage.tsx:340
msgid "Salesforce app registration saved"
msgstr "Salesforce app registration saved"

#: src/pages/SalesforceOAuthCallbackPage.tsx:49
#~ msgid "Salesforce authentication completed."
#~ msgstr "Salesforce authentication completed."

#: src/pages/ConnectionsPage.tsx:164
#~ msgid "Salesforce authentication failed"
#~ msgstr "Salesforce authentication failed"

#: src/pages/SalesforceOAuthCallbackPage.tsx:57
#~ msgid "Salesforce authentication failed."
#~ msgstr "Salesforce authentication failed."

#: src/pages/ConnectionsPage.tsx:498
#~ msgid "Salesforce authentication was cancelled."
#~ msgstr "Salesforce authentication was cancelled."

#: src/pages/ConnectionsPage.tsx:162
#~ msgid "Salesforce connected successfully"
#~ msgstr "Salesforce connected successfully"

#: src/pages/ConnectionsPage.tsx:454
#~ msgid "Salesforce connection could not be verified"
#~ msgstr "Salesforce connection could not be verified"

#: src/pages/PrivateMcpPage.tsx:470
#~ msgid "Salesforce host"
#~ msgstr "Salesforce host"

#: src/pages/ConnectionsPage.tsx:476
#~ msgid "Salesforce OAuth start did not return an authorization URL"
#~ msgstr "Salesforce OAuth start did not return an authorization URL"

#: src/pages/MemoryPage.tsx:698
msgid "Same-topic only"
msgstr "Same-topic only"

#: src/pages/MemoryPage.tsx:1076
msgid "Save"
msgstr "Save"

#: src/pages/SubscriptionPage.tsx:185
msgid "Save {savings}%"
msgstr "Save {savings}%"

#: src/pages/ConnectionsPage.tsx:1193
msgid "Save & Connect"
msgstr "Save & Connect"

#: src/pages/AgentsPage.tsx:1453
#: src/pages/DictionaryManagementPage.tsx:552
msgid "Save Catalog"
msgstr "Save Catalog"

#: src/pages/MemoryPage.tsx:1508
msgid "Save correction"
msgstr "Save correction"

#: src/pages/PrivateMcpPage.tsx:652
#: src/pages/PrivateMcpPage.tsx:816
#: src/pages/PrivateMcpPage.tsx:998
#: src/pages/PrivateMcpPage.tsx:1193
msgid "Save registration"
msgstr "Save registration"

#: src/pages/MemoryPage.tsx:438
msgid "Saved, but held back for your review"
msgstr "Saved, but held back for your review"

#: src/pages/AgentsPage.tsx:929
#: src/pages/AgentsPage.tsx:1453
#: src/pages/DictionaryManagementPage.tsx:552
#: src/pages/PrivateMcpPage.tsx:652
#: src/pages/PrivateMcpPage.tsx:816
#: src/pages/PrivateMcpPage.tsx:998
#: src/pages/PrivateMcpPage.tsx:1193
msgid "Saving..."
msgstr "Saving..."

#: src/pages/MemoryPage.tsx:1076
msgid "Saving…"
msgstr "Saving…"

#: src/components/connections/ConnectionActions.tsx:23
msgid "Scan"
msgstr "Scan"

#: src/pages/ConnectionsPage.tsx:745
msgid "Scan connections to build your catalog"
msgstr "Scan connections to build your catalog"

#: src/components/connections/ConnectionHealthPanel.tsx:22
#: src/components/connections/ConnectionStatusBadge.tsx:34
msgid "Scan failed"
msgstr "Scan failed"

#: src/pages/ConnectionsPage.tsx:293
msgid "Scan failed: {detail}"
msgstr "Scan failed: {detail}"

#: src/pages/ConnectionsPage.tsx:603
msgid "Scan files stored in Box cloud storage across all enterprise folders and collaborations."
msgstr "Scan files stored in Box cloud storage across all enterprise folders and collaborations."

#: src/pages/ConnectionsPage.tsx:638
msgid "Scan HubSpot contacts, companies, deals and custom objects to catalog customer names, account names and deal details, so AI prompts never expose CRM records."
msgstr "Scan HubSpot contacts, companies, deals and custom objects to catalog customer names, account names and deal details, so AI prompts never expose CRM records."

#: src/components/connections/ConnectionHealthPanel.tsx:28
msgid "Scan in progress…"
msgstr "Scan in progress…"

#: src/pages/ConnectionsPage.tsx:299
msgid "Scan is still running — refresh in a moment to see results."
msgstr "Scan is still running — refresh in a moment to see results."

#: src/pages/ConnectionsPage.tsx:614
msgid "Scan Microsoft Teams channels, chats, and shared files for privacy-sensitive content."
msgstr "Scan Microsoft Teams channels, chats, and shared files for privacy-sensitive content."

#: src/pages/ConnectionsPage.tsx:650
msgid "Scan MongoDB collections for personally identifiable information and sensitive data patterns."
msgstr "Scan MongoDB collections for personally identifiable information and sensitive data patterns."

#: src/pages/ConnectionsPage.tsx:1139
msgid "Scan Private Channels"
msgstr "Scan Private Channels"

#: src/pages/ConnectionsPage.tsx:629
msgid "Scan Salesforce Contacts, Leads, Accounts, Cases, and Opportunities to catalog sensitive customer data and ensure AI prompts never expose CRM records."
msgstr "Scan Salesforce Contacts, Leads, Accounts, Cases, and Opportunities to catalog sensitive customer data and ensure AI prompts never expose CRM records."

#: src/components/connections/ConnectionStatusBadge.tsx:27
msgid "Scanning"
msgstr "Scanning"

#. placeholder {0}: conn.serviceName
#: src/pages/ConnectionsPage.tsx:312
msgid "Scanning {0} for sensitive data…"
msgstr "Scanning {0} for sensitive data…"

#: src/components/connections/ConnectionActions.tsx:21
msgid "Scanning…"
msgstr "Scanning…"

#. placeholder {0}: Number(row.score ?? 0).toFixed(2)
#: src/pages/MemoryPage.tsx:1365
msgid "score {0}"
msgstr "score {0}"

#: src/pages/OnboardingPage.tsx:433
msgid "SDK, API & CI/CD integrations"
msgstr "SDK, API & CI/CD integrations"

#: src/pages/OnboardingPage.tsx:305
msgid "Seal the leak"
msgstr "Seal the leak"

#: src/pages/MemoryPage.tsx:1155
msgid "Search memories…"
msgstr "Search memories…"

#: src/pages/UserDetailAuditPage.tsx:766
msgid "Search prompts, files, or metadata..."
msgstr "Search prompts, files, or metadata..."

#: src/pages/ConnectionsPage.tsx:863
msgid "Secure Connection"
msgstr "Secure Connection"

#: src/pages/OnboardingPage.tsx:206
msgid "See it Work"
msgstr "See it Work"

#: src/pages/ConnectionsPage.tsx:1112
msgid "Select File Types"
msgstr "Select File Types"

#: src/pages/OnboardingPage.tsx:467
msgid "Select one to continue"
msgstr "Select one to continue"

#: src/pages/UserDetailAuditPage.tsx:788
msgid "Select Time Range"
msgstr "Select Time Range"

#: src/pages/VerifyEmailPage.tsx:115
msgid "Send a new link to {email}"
msgstr "Send a new link to {email}"

#: src/pages/MemoryPage.tsx:863
msgid "Send my profile once per conversation"
msgstr "Send my profile once per conversation"

#: src/pages/ForgotPasswordPage.tsx:142
msgid "Send reset link"
msgstr "Send reset link"

#: src/pages/ForgotPasswordPage.tsx:96
#: src/pages/ForgotPasswordPage.tsx:142
#: src/pages/InvitePage.tsx:602
#: src/pages/LoginPage.tsx:221
#: src/pages/LoginPage.tsx:249
#: src/pages/SignupPage.tsx:556
#: src/pages/VerifyEmailPage.tsx:115
msgid "Sending…"
msgstr "Sending…"

#: src/components/ProviderDetailModal.tsx:406
msgid "Sensitive items"
msgstr "Sensitive items"

#: src/components/ProviderDetailModal.tsx:209
msgid "Sensitive items twinned"
msgstr "Sensitive items twinned"

#: src/pages/MemoryPage.tsx:873
msgid "Sensitive topics"
msgstr "Sensitive topics"

#: src/pages/UserDetailAuditPage.tsx:708
#~ msgid "Sensitivity Score"
#~ msgstr "Sensitivity Score"

#: src/pages/ConnectionsPage.tsx:1215
msgid "Service"
msgstr "Service"

#: src/pages/ConnectionsPage.tsx:652
msgid "Service role key or direct database connection with read-only access. Find credentials in Supabase dashboard > Settings > API."
msgstr "Service role key or direct database connection with read-only access. Find credentials in Supabase dashboard > Settings > API."

#: src/components/ProviderDetailModal.tsx:453
msgid "Session risk levels"
msgstr "Session risk levels"

#: src/components/ProviderDetailModal.tsx:202
#: src/components/ProviderDetailModal.tsx:403
msgid "Sessions"
msgstr "Sessions"

#: src/pages/ResetPasswordPage.tsx:250
msgid "Set new password"
msgstr "Set new password"

#: src/pages/PrivateMcpPage.tsx:983
msgid "Set this and only accounts in that Google Workspace can connect; a personal account is refused."
msgstr "Set this and only accounts in that Google Workspace can connect; a personal account is refused."

#: src/pages/PrivateMcpPage.tsx:1178
msgid "Set this and only that HubSpot account can be connected; a user who picks a different account is refused."
msgstr "Set this and only that HubSpot account can be connected; a user who picks a different account is refused."

#: src/pages/SubscriptionPage.tsx:1148
msgid "Set up a subscription for your company. This will allow you to add licenses for your team members. Teams run on PrivacyPal Max: the per-seat price drops automatically as your team grows."
msgstr "Set up a subscription for your company. This will allow you to add licenses for your team members. Teams run on PrivacyPal Max: the per-seat price drops automatically as your team grows."

#: src/pages/SignupPage.tsx:590
msgid "Set up my team"
msgstr "Set up my team"

#: src/pages/DashboardPage.tsx:636
#: src/pages/MemoryPage.tsx:728
msgid "Share"
msgstr "Share"

#: src/components/Layout.tsx:494
msgid "Share this link with users you want to invite to your company:"
msgstr "Share this link with users you want to invite to your company:"

#: src/pages/MemoryPage.tsx:726
msgid "Share this memory with your team as stable twins"
msgstr "Share this memory with your team as stable twins"

#: src/pages/MemoryPage.tsx:1418
msgid "Shared by you"
msgstr "Shared by you"

#: src/pages/ResetPasswordPage.tsx:210
msgid "Show"
msgstr "Show"

#: src/pages/UserDetailAuditPage.tsx:1030
msgid "Show Less"
msgstr "Show Less"

#: src/pages/UserDetailAuditPage.tsx:1030
msgid "Show More"
msgstr "Show More"

#: src/pages/ResetPasswordPage.tsx:208
msgid "Show password"
msgstr "Show password"

#. placeholder {0}: businessDataCatalog.length
#: src/pages/ConnectionsPage.tsx:809
msgid "Showing 100 of {0} entries"
msgstr "Showing 100 of {0} entries"

#: src/pages/MemoryPage.tsx:461
#~ msgid "Showing quarantined (back to active)"
#~ msgstr "Showing quarantined (back to active)"

#: src/pages/ResetPasswordPage.tsx:267
msgid "Sign in"
msgstr "Sign in"

#: src/pages/LoginPage.tsx:331
msgid "Sign In"
msgstr "Sign In"

#: src/pages/LoginPage.tsx:170
msgid "Sign in to your PrivacyPal account"
msgstr "Sign in to your PrivacyPal account"

#: src/components/Layout.tsx:402
#: src/components/Layout.tsx:480
msgid "Sign Out"
msgstr "Sign Out"

#: src/pages/InvitePage.tsx:638
#: src/pages/SignupPage.tsx:460
msgid "Sign up with Google"
msgstr "Sign up with Google"

#: src/pages/InvitePage.tsx:648
#: src/pages/SignupPage.tsx:466
msgid "Sign up with Microsoft"
msgstr "Sign up with Microsoft"

#: src/pages/OnboardingPage.tsx:324
msgid "Slack, Gmail, code editors, ChatGPT..."
msgstr "Slack, Gmail, code editors, ChatGPT..."

#: src/pages/ForgotPasswordPage.tsx:41
msgid "Something went wrong. Please try again."
msgstr "Something went wrong. Please try again."

#: src/pages/LoginPage.tsx:148
msgid "SSO login failed"
msgstr "SSO login failed"

#: src/pages/MemoryPage.tsx:126
msgid "Standing requests"
msgstr "Standing requests"

#: src/pages/SubscriptionPage.tsx:505
#~ msgid "Start {trialDays}-day trial: {tierName} {planName}"
#~ msgstr "Start {trialDays}-day trial: {tierName} {planName}"

#: src/pages/SignupPage.tsx:622
msgid "Start Free"
msgstr "Start Free"

#: src/pages/OnboardingPage.tsx:223
#~ msgid "Start My {trialDays}-Day Trial"
#~ msgstr "Start My {trialDays}-Day Trial"

#: src/pages/LoginPage.tsx:172
msgid "Start protecting your data with PrivacyPal"
msgstr "Start protecting your data with PrivacyPal"

#: src/pages/SignupPage.tsx:617
#~ msgid "Start with a {trialDays}-day free trial. No charge until your trial ends."
#~ msgstr "Start with a {trialDays}-day free trial. No charge until your trial ends."

#: src/components/UpgradeModal.tsx:650
msgid "Start with a card"
msgstr "Start with a card"

#: src/pages/OnboardingPage.tsx:700
#~ msgid "Start your {trialDays}-day trial."
#~ msgstr "Start your {trialDays}-day trial."

#: src/pages/OnboardingPage.tsx:223
#~ msgid "Starting trial..."
#~ msgstr "Starting trial..."

#: src/pages/AgentsPage.tsx:671
#: src/pages/ConnectionsPage.tsx:1217
#: src/pages/DashboardPage.tsx:637
#: src/pages/DictionaryManagementPage.tsx:207
#: src/pages/UserManagementPage.tsx:285
msgid "Status"
msgstr "Status"

#: src/pages/OnboardingPage.tsx:227
msgid "Step {step} of {TOTAL}"
msgstr "Step {step} of {TOTAL}"

#: src/pages/SignupPage.tsx:401
msgid "Step {stepNumber} of 3"
msgstr "Step {stepNumber} of 3"

#: src/pages/SignupPage.tsx:466
#~ msgid "Step {stepNumber} of 4"
#~ msgstr "Step {stepNumber} of 4"

#: src/pages/PrivateMcpPage.tsx:1027
#: src/pages/PrivateMcpPage.tsx:1222
msgid "Stored"
msgstr "Stored"

#: src/pages/MemoryPage.tsx:1122
msgid "Stored as a Privacy Twin like every other memory, and marked as written by you."
msgstr "Stored as a Privacy Twin like every other memory, and marked as written by you."

#: src/pages/PrivateMcpPage.tsx:959
#: src/pages/PrivateMcpPage.tsx:1153
msgid "Stored. Enter a new secret only to replace it."
msgstr "Stored. Enter a new secret only to replace it."

#: src/pages/SubscriptionPage.tsx:420
msgid "Subscribe now: {tierName} {planName}"
msgstr "Subscribe now: {tierName} {planName}"

#: src/pages/SubscriptionPage.tsx:329
msgid "Subscribe to PrivacyPal Max"
msgstr "Subscribe to PrivacyPal Max"

#: src/components/Layout.tsx:181
#: src/pages/SubscriptionPage.tsx:760
#: src/pages/SubscriptionPage.tsx:865
#: src/pages/SubscriptionPage.tsx:1179
msgid "Subscription"
msgstr "Subscription"

#: src/pages/SubscriptionPage.tsx:301
msgid "Subscription Activated!"
msgstr "Subscription Activated!"

#: src/pages/DashboardPage.tsx:613
msgid "Supported AI Apps"
msgstr "Supported AI Apps"

#: src/components/Layout.tsx:380
msgid "Switch to dark mode"
msgstr "Switch to dark mode"

#: src/components/Layout.tsx:380
msgid "Switch to light mode"
msgstr "Switch to light mode"

#: src/pages/ConnectionsPage.tsx:759
msgid "Sync All"
msgstr "Sync All"

#: src/pages/ConnectionsPage.tsx:757
msgid "Syncing…"
msgstr "Syncing…"

#: src/pages/ConnectionsPage.tsx:616
msgid "System Admin personal access token or bot account with read access to channels and posts."
msgstr "System Admin personal access token or bot account with read access to channels and posts."

#: src/pages/AgentsPage.tsx:555
#: src/pages/AgentsPage.tsx:902
msgid "System Prompt"
msgstr "System Prompt"

#: src/pages/DashboardPage.tsx:284
msgid "Team Activity Stream"
msgstr "Team Activity Stream"

#: src/pages/DashboardPage.tsx:581
msgid "Team AI Activity"
msgstr "Team AI Activity"

#: src/pages/MemoryPage.tsx:645
msgid "Team memory"
msgstr "Team memory"

#: src/pages/MemoryPage.tsx:916
msgid "Team memory (Multiplayer)"
msgstr "Team memory (Multiplayer)"

#: src/pages/MemoryPage.tsx:1391
msgid "Team memory is off for you, so none of these are used in your prompts. Turn it on in the settings above."
msgstr "Team memory is off for you, so none of these are used in your prompts. Turn it on in the settings above."

#: src/pages/MemoryPage.tsx:323
msgid "Team memory is off. Your memory is personal again."
msgstr "Team memory is off. Your memory is personal again."

#: src/pages/MemoryPage.tsx:322
msgid "Team memory is on. Only the memories you share are visible to teammates."
msgstr "Team memory is on. Only the memories you share are visible to teammates."

#: src/pages/MemoryPage.tsx:300
msgid "Team memory removed"
msgstr "Team memory removed"

#: src/pages/SubscriptionPage.tsx:790
msgid "Team seats, central provisioning and volume pricing"
msgstr "Team seats, central provisioning and volume pricing"

#: src/pages/ConnectionsPage.tsx:604
msgid "team_data.member access via Dropbox Business API. Requires a scoped app on the Dropbox App Console."
msgstr "team_data.member access via Dropbox Business API. Requires a scoped app on the Dropbox App Console."

#: src/components/UpgradeModal.tsx:460
msgid "Tell us how many people you need covered and we will issue a company-wide trial code on the call. No card, no auto-renewal."
msgstr "Tell us how many people you need covered and we will issue a company-wide trial code on the call. No card, no auto-renewal."

#: src/pages/PrivateMcpPage.tsx:783
msgid "Tenant GUID, or a verified domain such as contoso.onmicrosoft.com"
msgstr "Tenant GUID, or a verified domain such as contoso.onmicrosoft.com"

#: src/pages/AgentsPage.tsx:672
#: src/pages/AgentsPage.tsx:1414
#: src/pages/DictionaryManagementPage.tsx:208
#: src/pages/DictionaryManagementPage.tsx:474
msgid "Terms"
msgstr "Terms"

#. placeholder {0}: selectedDictionary.terms.length
#: src/pages/AgentsPage.tsx:745
#: src/pages/DictionaryManagementPage.tsx:305
msgid "Terms ({0})"
msgstr "Terms ({0})"

#: src/pages/AgentsPage.tsx:493
msgid "Test agent with sample prompt"
msgstr "Test agent with sample prompt"

#: src/pages/AgentsPage.tsx:1054
msgid "Testing against input..."
msgstr "Testing against input..."

#: src/pages/SubscriptionPage.tsx:1111
msgid "Thank you for trying PrivacyPal! Enter your payment method below to continue protecting your data."
msgstr "Thank you for trying PrivacyPal! Enter your payment method below to continue protecting your data."

#: src/pages/InvitePage.tsx:134
#: src/pages/LoginPage.tsx:108
#: src/pages/SignupPage.tsx:242
msgid "That code is invalid or has expired."
msgstr "That code is invalid or has expired."

#: src/pages/PrivateMcpPage.tsx:114
msgid "That does not look like a Directory (tenant) ID. Use the tenant GUID from the app registration overview, a verified domain such as contoso.onmicrosoft.com, or organizations."
msgstr "That does not look like a Directory (tenant) ID. Use the tenant GUID from the app registration overview, a verified domain such as contoso.onmicrosoft.com, or organizations."

#: src/pages/PrivateMcpPage.tsx:125
msgid "That does not look like a Google OAuth client ID. Copy the full value ending in .apps.googleusercontent.com from your Google Cloud credentials page."
msgstr "That does not look like a Google OAuth client ID. Copy the full value ending in .apps.googleusercontent.com from your Google Cloud credentials page."

#: src/pages/PrivateMcpPage.tsx:127
msgid "That does not look like a Google OAuth client secret. Copy the value shown next to the client ID in Google Cloud."
msgstr "That does not look like a Google OAuth client secret. Copy the value shown next to the client ID in Google Cloud."

#: src/pages/PrivateMcpPage.tsx:142
msgid "That does not look like a HubSpot client secret. Copy the value shown on the connector's details page."
msgstr "That does not look like a HubSpot client secret. Copy the value shown on the connector's details page."

#: src/pages/PrivateMcpPage.tsx:140
msgid "That does not look like a HubSpot MCP connector client ID. Copy it from the connector's details page in HubSpot."
msgstr "That does not look like a HubSpot MCP connector client ID. Copy it from the connector's details page in HubSpot."

#: src/pages/PrivateMcpPage.tsx:101
msgid "That does not look like a Salesforce My Domain login URL. Use the form https://yourcompany.my.salesforce.com."
msgstr "That does not look like a Salesforce My Domain login URL. Use the form https://yourcompany.my.salesforce.com."

#: src/pages/PrivateMcpPage.tsx:116
msgid "That does not look like an Application (client) ID. Copy the GUID from the app registration overview in Microsoft Entra."
msgstr "That does not look like an Application (client) ID. Copy the GUID from the app registration overview in Microsoft Entra."

#: src/pages/PrivateMcpPage.tsx:103
msgid "That does not look like an External Client App consumer key. Copy it from the app's OAuth settings in Salesforce."
msgstr "That does not look like an External Client App consumer key. Copy it from the app's OAuth settings in Salesforce."

#: src/pages/PrivateMcpPage.tsx:105
msgid "That is not a valid hosted MCP server slug. Use the platform/name form, for example platform/sobject-all."
msgstr "That is not a valid hosted MCP server slug. Use the platform/name form, for example platform/sobject-all."

#: src/pages/AuthCallbackPage.tsx:151
#: src/pages/SignupPage.tsx:547
msgid "The code expires in 10 minutes. Check your spam folder if you don't see it."
msgstr "The code expires in 10 minutes. Check your spam folder if you don't see it."

#: src/pages/InvitePage.tsx:500
#: src/pages/SignupPage.tsx:415
msgid "The first-ever Privacy Agent designed specifically for the Generative AI era. Stop the manual redaction. Stop the data leaks. Get 100% accurate results without the risk."
msgstr "The first-ever Privacy Agent designed specifically for the Generative AI era. Stop the manual redaction. Stop the data leaks. Get 100% accurate results without the risk."

#: src/pages/MemoryPage.tsx:1487
msgid "The old version is kept as history and marked superseded; nothing is silently rewritten."
msgstr "The old version is kept as history and marked superseded; nothing is silently rewritten."

#: src/pages/PrivateMcpPage.tsx:131
#: src/pages/PrivateMcpPage.tsx:146
msgid "The Private MCP credential vault is not configured on the server yet, so the client secret cannot be stored. Contact PrivacyPal support."
msgstr "The Private MCP credential vault is not configured on the server yet, so the client secret cannot be stored. Contact PrivacyPal support."

#: src/pages/PrivateMcpPage.tsx:1313
msgid "The Private MCP vault key is not configured on the server; connections cannot be stored."
msgstr "The Private MCP vault key is not configured on the server; connections cannot be stored."

#: src/pages/OnboardingPage.tsx:247
msgid "Think of me as a dedicated member of your team: one who works around the clock to make sure your sensitive data never ends up where it shouldn't. Ready to get started?"
msgstr "Think of me as a dedicated member of your team: one who works around the clock to make sure your sensitive data never ends up where it shouldn't. Ready to get started?"

#: src/pages/UserManagementPage.tsx:184
msgid "This adds a license for this user, billed at your domain's tier ({domainTier}: teams with more than one user always run on Max). Your payment method is charged for the new seat. Continue?"
msgstr "This adds a license for this user, billed at your domain's tier ({domainTier}: teams with more than one user always run on Max). Your payment method is charged for the new seat. Continue?"

#: src/pages/UserManagementPage.tsx:182
msgid "This assigns this user a prepaid seat at your domain's tier ({domainTier}). If no {domainTier} seat is free, the request is refused. Continue?"
msgstr "This assigns this user a prepaid seat at your domain's tier ({domainTier}). If no {domainTier} seat is free, the request is refused. Continue?"

#. placeholder {0}: valid.trialDays
#: src/components/UpgradeModal.tsx:438
msgid "This code runs Max as a normal subscription for {0} days before it bills. Your card is collected now and nothing is charged until then."
msgstr "This code runs Max as a normal subscription for {0} days before it bills. Your card is collected now and nothing is charged until then."

#: src/components/UpgradeModal.tsx:440
msgid "This code runs Max as a normal subscription, so your card is collected now."
msgstr "This code runs Max as a normal subscription, so your card is collected now."

#: src/pages/MemoryPage.tsx:1518
msgid "This destroys your memory encryption keys and deletes every stored memory. Exported and synced copies become permanently unreadable. This cannot be undone."
msgstr "This destroys your memory encryption keys and deletes every stored memory. Exported and synced copies become permanently unreadable. This cannot be undone."

#. placeholder {0}: new Date(subscriptionDetails.discount.end).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })
#: src/pages/SubscriptionPage.tsx:985
msgid "This discount expires on {0}. After that, your rate will return to ${baseRateLabel} / {intervalName}."
msgstr "This discount expires on {0}. After that, your rate will return to ${baseRateLabel} / {intervalName}."

#: src/utils/licenses.ts:164
msgid "This domain has no prepaid {tierLabel} seats.{overClaimed} {noSeatLine}"
msgstr "This domain has no prepaid {tierLabel} seats.{overClaimed} {noSeatLine}"

#: src/pages/PrivateMcpPage.tsx:624
#: src/pages/PrivateMcpPage.tsx:801
msgid "This is a public client identifier, not a secret."
msgstr "This is a public client identifier, not a secret."

#: src/pages/UserManagementPage.tsx:171
msgid "This moves one seat from Max to Pro. A prorated credit is applied to your next invoice. Continue?"
msgstr "This moves one seat from Max to Pro. A prorated credit is applied to your next invoice. Continue?"

#: src/pages/UserManagementPage.tsx:169
msgid "This moves one seat from Pro to Max. The prorated difference for the rest of the current billing period is charged to your payment method immediately. Continue?"
msgstr "This moves one seat from Pro to Max. The prorated difference for the rest of the current billing period is charged to your payment method immediately. Continue?"

#: src/utils/licenses.ts:169
msgid "This moves the user to a prepaid {tierLabel} seat. Your company has {free} of {licensed} {tierLabel} seats free, so no charge applies. Continue?"
msgstr "This moves the user to a prepaid {tierLabel} seat. Your company has {free} of {licensed} {tierLabel} seats free, so no charge applies. Continue?"

#: src/pages/ResetPasswordPage.tsx:153
msgid "This password reset link has expired — links are valid for 20 minutes."
msgstr "This password reset link has expired — links are valid for 20 minutes."

#: src/pages/ResetPasswordPage.tsx:155
msgid "This password reset link is invalid or has already been used."
msgstr "This password reset link is invalid or has already been used."

#: src/utils/licenses.ts:200
msgid "This seat cannot be moved to {tierLabel} automatically: the subscription has no seat to move from. Contact PrivacyPal support to reconcile the subscription."
msgstr "This seat cannot be moved to {tierLabel} automatically: the subscription has no seat to move from. Contact PrivacyPal support to reconcile the subscription."

#: src/pages/PrivateMcpPage.tsx:510
#: src/pages/UserDetailAuditPage.tsx:555
msgid "this user"
msgstr "this user"

#: src/pages/UserManagementPage.tsx:472
msgid "This user will have full administrative access. Continue?"
msgstr "This user will have full administrative access. Continue?"

#: src/pages/UserManagementPage.tsx:473
msgid "This user will lose administrative access and become a regular member. Continue?"
msgstr "This user will lose administrative access and become a regular member. Continue?"

#: src/pages/VerifyEmailPage.tsx:44
msgid "This verification link has expired."
msgstr "This verification link has expired."

#: src/pages/MemoryPage.tsx:642
msgid "Timeline"
msgstr "Timeline"

#: src/pages/UserDetailAuditPage.tsx:953
msgid "Timestamp: {detailTimestamp}"
msgstr "Timestamp: {detailTimestamp}"

#: src/pages/AuthCallbackPage.tsx:117
msgid "To keep your account secure, we need to confirm you own <0>{pendingEmail}</0>. If that address can receive mail, we've sent it a 6-digit code — enter it below to finish signing in."
msgstr "To keep your account secure, we need to confirm you own <0>{pendingEmail}</0>. If that address can receive mail, we've sent it a 6-digit code — enter it below to finish signing in."

#: src/components/ProviderDetailModal.tsx:204
#: src/components/ProviderDetailModal.tsx:404
#: src/pages/DashboardPage.tsx:635
msgid "Tokens"
msgstr "Tokens"

#: src/pages/DashboardPage.tsx:362
msgid "Tokens ({effectiveUsageDays}d)"
msgstr "Tokens ({effectiveUsageDays}d)"

#: src/pages/DashboardPage.tsx:311
#~ msgid "Tokens ({usageDays}d)"
#~ msgstr "Tokens ({usageDays}d)"

#: src/pages/DashboardPage.tsx:362
msgid "Tokens (24h)"
msgstr "Tokens (24h)"

#: src/components/ProviderDetailModal.tsx:401
msgid "Tool"
msgstr "Tool"

#: src/components/ProviderDetailModal.tsx:393
msgid "Tool statistics"
msgstr "Tool statistics"

#: src/components/ProviderDetailModal.tsx:471
msgid "Top models"
msgstr "Top models"

#: src/pages/DashboardPage.tsx:77
msgid "Total"
msgstr "Total"

#: src/pages/ApiKeysPage.tsx:185
msgid "Total Elements"
msgstr "Total Elements"

#: src/pages/DashboardPage.tsx:336
#: src/pages/UserDetailAuditPage.tsx:753
msgid "Total Prompts"
msgstr "Total Prompts"

#: src/pages/ApiKeysPage.tsx:184
msgid "Total Requests"
msgstr "Total Requests"

#: src/pages/UserDetailAuditPage.tsx:1087
msgid "Transaction Hash:"
msgstr "Transaction Hash:"

#: src/pages/MemoryPage.tsx:119
msgid "Travel"
msgstr "Travel"

#: src/pages/DashboardPage.tsx:376
#: src/pages/UserDetailAuditPage.tsx:639
#: src/pages/UserManagementPage.tsx:300
#: src/pages/UserManagementPage.tsx:407
msgid "Trial"
msgstr "Trial"

#: src/pages/OnboardingPage.tsx:722
#~ msgid "Trial activated. Let's bring PrivacyPal online."
#~ msgstr "Trial activated. Let's bring PrivacyPal online."

#: src/components/UpgradeModal.tsx:369
msgid "Trial Code"
msgstr "Trial Code"

#. placeholder {0}: codes.trialCode
#: src/pages/SignupPage.tsx:445
msgid "Trial code <0>{0}</0> is attached. We apply it the moment your account is created."
msgstr "Trial code <0>{0}</0> is attached. We apply it the moment your account is created."

#: src/components/UpgradeModal.tsx:250
msgid "Trial code <0>{attachedTrialCode}</0> needs a card, so it runs as a normal Max subscription."
msgstr "Trial code <0>{attachedTrialCode}</0> needs a card, so it runs as a normal Max subscription."

#: src/components/UpgradeModal.tsx:250
#~ msgid "Trial code <0>{attachedTrialCode}</0> needs a card, so it runs as a normal Max subscription. Keep the code: sales can see it on your account."
#~ msgstr "Trial code <0>{attachedTrialCode}</0> needs a card, so it runs as a normal Max subscription. Keep the code: sales can see it on your account."

#: src/components/UpgradeModal.tsx:653
msgid "Trial code or a 15 minute call"
msgstr "Trial code or a 15 minute call"

#: src/pages/ConnectionsPage.tsx:1229
msgid "Try Again"
msgstr "Try Again"

#: src/components/MaxUpsell.tsx:94
msgid "Try Max company-wide"
msgstr "Try Max company-wide"

#: src/pages/MemoryPage.tsx:808
msgid "Turn memory on to carry context between ChatGPT, Claude, Gemini, Copilot, and your agents."
msgstr "Turn memory on to carry context between ChatGPT, Claude, Gemini, Copilot, and your agents."

#: src/pages/MemoryPage.tsx:820
msgid "Turn off memory"
msgstr "Turn off memory"

#: src/pages/MemoryPage.tsx:941
msgid "Turn off team memory"
msgstr "Turn off team memory"

#: src/pages/MemoryPage.tsx:820
msgid "Turn on memory"
msgstr "Turn on memory"

#: src/pages/MemoryPage.tsx:941
msgid "Turn on team memory"
msgstr "Turn on team memory"

#: src/pages/MemoryPage.tsx:952
msgid "Turns captured"
msgstr "Turns captured"

#. placeholder {0}: formatEpochMs(googleApp.updatedAt)
#: src/pages/PrivateMcpPage.tsx:893
msgid "Twin-translating Gmail and Drive access · last updated {0}"
msgstr "Twin-translating Gmail and Drive access · last updated {0}"

#. placeholder {0}: formatEpochMs(hubspotApp.updatedAt)
#: src/pages/PrivateMcpPage.tsx:1085
msgid "Twin-translating HubSpot CRM access · last updated {0}"
msgstr "Twin-translating HubSpot CRM access · last updated {0}"

#. placeholder {0}: formatEpochMs(m365App.updatedAt)
#: src/pages/PrivateMcpPage.tsx:731
msgid "Twin-translating Microsoft 365 access · last updated {0}"
msgstr "Twin-translating Microsoft 365 access · last updated {0}"

#. placeholder {0}: formatEpochMs(app.updatedAt)
#: src/pages/PrivateMcpPage.tsx:554
msgid "Twin-translating Salesforce access · last updated {0}"
msgstr "Twin-translating Salesforce access · last updated {0}"

#: src/pages/AgentsPage.tsx:839
#: src/pages/OnboardingPage.tsx:396
msgid "Type"
msgstr "Type"

#: src/pages/OnboardingPage.tsx:349
msgid "Type anything containing sensitive data below. PrivacyPal replaces each piece of real PII with a realistic Privacy Twin: indistinguishable to the AI, meaningless to an attacker."
msgstr "Type anything containing sensitive data below. PrivacyPal replaces each piece of real PII with a realistic Privacy Twin: indistinguishable to the AI, meaningless to an attacker."

#: src/pages/MemoryPage.tsx:1247
msgid "Undated"
msgstr "Undated"

#: src/pages/PrivateMcpPage.tsx:154
#: src/pages/PrivateMcpPage.tsx:156
#: src/pages/PrivateMcpPage.tsx:1347
#: src/pages/UserDetailAuditPage.tsx:451
msgid "unknown"
msgstr "unknown"

#: src/pages/AgentsPage.tsx:1221
msgid "Unknown"
msgstr "Unknown"

#: src/pages/ConnectionsPage.tsx:292
msgid "unknown error"
msgstr "unknown error"

#: src/pages/MemoryPage.tsx:736
msgid "Unpin"
msgstr "Unpin"

#: src/pages/OnboardingPage.tsx:292
msgid "Unprotected AI: your data exposed"
msgstr "Unprotected AI: your data exposed"

#: src/pages/AgentsPage.tsx:929
msgid "Update Agent"
msgstr "Update Agent"

#: src/pages/DashboardPage.tsx:307
msgid "Update payment method"
msgstr "Update payment method"

#: src/pages/SubscriptionPage.tsx:525
#: src/pages/SubscriptionPage.tsx:554
msgid "Update Payment Method"
msgstr "Update Payment Method"

#: src/pages/PrivateMcpPage.tsx:652
#: src/pages/PrivateMcpPage.tsx:816
#: src/pages/PrivateMcpPage.tsx:998
#: src/pages/PrivateMcpPage.tsx:1193
msgid "Update registration"
msgstr "Update registration"

#. placeholder {0}: new Date(agent.updated_at).toLocaleDateString()
#: src/pages/AgentsPage.tsx:529
msgid "Updated {0}"
msgstr "Updated {0}"

#: src/pages/SubscriptionPage.tsx:554
msgid "Updating..."
msgstr "Updating..."

#: src/pages/ResetPasswordPage.tsx:250
msgid "Updating…"
msgstr "Updating…"

#: src/components/Layout.tsx:288
#: src/components/MaxUpsell.tsx:87
#: src/pages/SubscriptionPage.tsx:798
#: src/pages/SubscriptionPage.tsx:1023
#: src/pages/SubscriptionPage.tsx:1059
#: src/pages/UserManagementPage.tsx:364
#: src/pages/UserManagementPage.tsx:451
#: src/pages/UserManagementPage.tsx:478
msgid "Upgrade to Max"
msgstr "Upgrade to Max"

#: src/pages/DashboardPage.tsx:409
msgid "Upgrade to Max →"
msgstr "Upgrade to Max →"

#: src/components/UpgradeModal.tsx:302
#: src/components/UpgradeModal.tsx:523
msgid "Upgrade to Max now"
msgstr "Upgrade to Max now"

#: src/components/UpgradeModal.tsx:620
#: src/pages/SubscriptionPage.tsx:1057
msgid "Upgrade to PrivacyPal Max"
msgstr "Upgrade to PrivacyPal Max"

#: src/pages/DashboardPage.tsx:356
#~ msgid "Upgrade to Pro →"
#~ msgstr "Upgrade to Pro →"

#: src/pages/UserManagementPage.tsx:476
msgid "Upgrade User to Max"
msgstr "Upgrade User to Max"

#: src/pages/SubscriptionPage.tsx:1023
msgid "Upgrading..."
msgstr "Upgrading..."

#: src/pages/ConnectionsPage.tsx:996
msgid "Use an access token"
msgstr "Use an access token"

#. placeholder {0}: promo.code
#. placeholder {1}: promo.percentOff
#. placeholder {2}: promo.durationMonths
#: src/components/MaxUpsell.tsx:75
msgid "Use code <0>{0}</0> for {1}% off your first {2} months."
msgstr "Use code <0>{0}</0> for {1}% off your first {2} months."

#: src/pages/AgentsPage.tsx:1442
msgid "Use deny list to prevent false positives."
msgstr "Use deny list to prevent false positives."

#: src/pages/DictionaryManagementPage.tsx:523
msgid "Use deny list to prevent false positives. For example, add \"Cancer\" to prevent the name \"Cancer\" from being detected as a medical condition."
msgstr "Use deny list to prevent false positives. For example, add \"Cancer\" to prevent the name \"Cancer\" from being detected as a medical condition."

#: src/pages/MemoryPage.tsx:835
msgid "Use memory in prompts"
msgstr "Use memory in prompts"

#: src/pages/ConnectionsPage.tsx:1170
msgid "Use the <0>Object.FieldApiName</0> format. Leave blank to scan all relevant fields."
msgstr "Use the <0>Object.FieldApiName</0> format. Leave blank to scan all relevant fields."

#: src/pages/ConnectionsPage.tsx:1155
msgid "Use the <0>objectType.property</0> format with internal property names. Leave blank to scan all relevant properties."
msgstr "Use the <0>objectType.property</0> format with internal property names. Leave blank to scan all relevant properties."

#: src/pages/ConnectionsPage.tsx:1133
msgid "Use the connecting user's own permissions when accessing files"
msgstr "Use the connecting user's own permissions when accessing files"

#: src/pages/ConnectionsPage.tsx:951
msgid "Use your own HubSpot app"
msgstr "Use your own HubSpot app"

#: src/pages/ConnectionsPage.tsx:896
msgid "Use your own Salesforce Connected App"
msgstr "Use your own Salesforce Connected App"

#. placeholder {0}: fact.recallCount
#: src/pages/MemoryPage.tsx:709
msgid "used {0}×"
msgstr "used {0}×"

#: src/pages/PrivateMcpPage.tsx:1328
#: src/pages/UserManagementPage.tsx:284
msgid "User"
msgstr "User"

#: src/pages/UserManagementPage.tsx:328
msgid "User actions"
msgstr "User actions"

#: src/pages/UserManagementPage.tsx:191
msgid "User demoted to member successfully"
msgstr "User demoted to member successfully"

#: src/pages/UserManagementPage.tsx:122
msgid "User made administrator successfully"
msgstr "User made administrator successfully"

#: src/components/Layout.tsx:259
#: src/pages/UserManagementPage.tsx:237
msgid "User Management"
msgstr "User Management"

#: src/pages/UserManagementPage.tsx:145
msgid "User moved to Pro"
msgstr "User moved to Pro"

#: src/pages/UserDetailAuditPage.tsx:573
msgid "User Not Found"
msgstr "User Not Found"

#: src/pages/UserManagementPage.tsx:145
msgid "User upgraded to Max"
msgstr "User upgraded to Max"

#: src/pages/ConnectionsPage.tsx:1069
msgid "Username"
msgstr "Username"

#: src/components/ProviderDetailModal.tsx:407
msgid "Users"
msgstr "Users"

#: src/pages/InvitePage.tsx:200
msgid "Validating invite link..."
msgstr "Validating invite link..."

#: src/pages/AuthCallbackPage.tsx:107
#: src/pages/InvitePage.tsx:165
#: src/pages/LoginPage.tsx:119
#: src/pages/SignupPage.tsx:297
#: src/pages/VerifyEmailPage.tsx:135
msgid "Verification failed"
msgstr "Verification failed"

#: src/pages/VerifyEmailPage.tsx:47
msgid "Verification failed."
msgstr "Verification failed."

#: src/pages/AuthCallbackPage.tsx:104
msgid "Verification session expired. Please sign in again."
msgstr "Verification session expired. Please sign in again."

#: src/pages/InvitePage.tsx:592
msgid "Verify & accept invite"
msgstr "Verify & accept invite"

#: src/pages/AuthCallbackPage.tsx:147
msgid "Verify & continue"
msgstr "Verify & continue"

#: src/pages/LoginPage.tsx:212
#: src/pages/SignupPage.tsx:543
msgid "Verify & create account"
msgstr "Verify & create account"

#: src/pages/AuthCallbackPage.tsx:115
#: src/pages/InvitePage.tsx:570
#: src/pages/LoginPage.tsx:180
#: src/pages/SignupPage.tsx:521
msgid "Verify your email"
msgstr "Verify your email"

#: src/pages/VerifyEmailPage.tsx:91
msgid "Verifying your email…"
msgstr "Verifying your email…"

#: src/pages/AuthCallbackPage.tsx:147
#: src/pages/InvitePage.tsx:592
#: src/pages/LoginPage.tsx:212
#: src/pages/SignupPage.tsx:543
msgid "Verifying…"
msgstr "Verifying…"

#: src/pages/UserManagementPage.tsx:431
msgid "View Audit"
msgstr "View Audit"

#: src/pages/MemoryPage.tsx:1465
msgid "View audit trail"
msgstr "View audit trail"

#: src/pages/UserDetailAuditPage.tsx:1095
msgid "View on Peaq Subscan"
msgstr "View on Peaq Subscan"

#: src/pages/UserManagementPage.tsx:348
msgid "View User Audit"
msgstr "View User Audit"

#: src/pages/ConnectionsPage.tsx:1092
msgid "Waiting for HubSpot…"
msgstr "Waiting for HubSpot…"

#: src/pages/ConnectionsPage.tsx:1088
msgid "Waiting for Salesforce…"
msgstr "Waiting for Salesforce…"

#: src/pages/OnboardingPage.tsx:347
msgid "Watch PrivacyPal work."
msgstr "Watch PrivacyPal work."

#: src/components/UpgradeModal.tsx:243
msgid "We could not apply that code, so this is the list price."
msgstr "We could not apply that code, so this is the list price."

#: src/pages/SignupPage.tsx:608
msgid "We could not apply that trial code. Your account is set up on the free plan."
msgstr "We could not apply that trial code. Your account is set up on the free plan."

#: src/components/UpgradeModal.tsx:393
msgid "We could not check that code just now. Try again in a moment."
msgstr "We could not check that code just now. Try again in a moment."

#: src/pages/SubscriptionPage.tsx:341
msgid "We couldn't complete your subscription"
msgstr "We couldn't complete your subscription"

#: src/pages/ConnectionsPage.tsx:549
#: src/pages/OnboardingPage.tsx:206
msgid "Welcome"
msgstr "Welcome"

#: src/pages/LoginPage.tsx:166
msgid "Welcome Back"
msgstr "Welcome Back"

#: src/pages/SubscriptionPage.tsx:675
msgid "Welcome to PrivacyPal Max"
msgstr "Welcome to PrivacyPal Max"

#: src/components/UpgradeModal.tsx:155
#: src/components/UpgradeModal.tsx:491
msgid "Welcome to PrivacyPal Max. Every surface is now protected."
msgstr "Welcome to PrivacyPal Max. Every surface is now protected."

#: src/pages/OnboardingPage.tsx:250
msgid "What should I call you? (We'll use your first name if you skip this.)"
msgstr "What should I call you? (We'll use your first name if you skip this.)"

#: src/pages/PrivateMcpPage.tsx:1294
msgid "Who has connected their assistant through this Private MCP. Metadata only; tokens never leave the vault."
msgstr "Who has connected their assistant through this Private MCP. Metadata only; tokens never leave the vault."

#: src/pages/MemoryPage.tsx:771
msgid "Why PrivacyPal remembers this"
msgstr "Why PrivacyPal remembers this"

#: src/pages/MemoryPage.tsx:1342
msgid "Why these?"
msgstr "Why these?"

#: src/components/Layout.tsx:742
msgid "Windows: run the installer as a user with permission to install applications; SmartScreen may ask you to confirm the publisher."
msgstr "Windows: run the installer as a user with permission to install applications; SmartScreen may ask you to confirm the publisher."

#: src/pages/MemoryPage.tsx:112
msgid "Work"
msgstr "Work"

#: src/pages/InvitePage.tsx:684
#: src/pages/SignupPage.tsx:486
msgid "Work Email"
msgstr "Work Email"

#: src/pages/MemoryPage.tsx:124
msgid "Working context"
msgstr "Working context"

#: src/pages/PrivateMcpPage.tsx:1019
msgid "Workspace domain"
msgstr "Workspace domain"

#: src/pages/PrivateMcpPage.tsx:972
msgid "Workspace domain (optional)"
msgstr "Workspace domain (optional)"

#: src/pages/SubscriptionPage.tsx:834
msgid "year"
msgstr "year"

#: src/pages/AgentsPage.tsx:742
#: src/pages/DictionaryManagementPage.tsx:301
msgid "Yes"
msgstr "Yes"

#: src/utils/relativeTime.ts:16
msgid "yesterday"
msgstr "yesterday"

#: src/pages/UserDetailAuditPage.tsx:431
msgid "Yesterday"
msgstr "Yesterday"

#: src/pages/MemoryPage.tsx:1030
msgid "you"
msgstr "you"

#: src/pages/OnboardingPage.tsx:703
#~ msgid "You already have an active subscription. Continue to complete your setup."
#~ msgstr "You already have an active subscription. Continue to complete your setup."

#: src/pages/OnboardingPage.tsx:513
msgid "You are on PrivacyPal Pro, free forever: ChatGPT, Claude, Gemini, Grok and Perplexity chats protected. Agent surfaces and team features come with Max, whenever you want them."
msgstr "You are on PrivacyPal Pro, free forever: ChatGPT, Claude, Gemini, Grok and Perplexity chats protected. Agent surfaces and team features come with Max, whenever you want them."

#: src/pages/DashboardPage.tsx:320
msgid "You are on Pro, free."
msgstr "You are on Pro, free."

#: src/pages/SalesforceOAuthCallbackPage.tsx:65
msgid "You can close this window and try again."
msgstr "You can close this window and try again."

#: src/pages/SalesforceOAuthCallbackPage.tsx:56
msgid "You can close this window."
msgstr "You can close this window."

#: src/pages/SubscriptionPage.tsx:729
msgid "You don't have access to subscription management. Only administrators can manage subscriptions."
msgstr "You don't have access to subscription management. Only administrators can manage subscriptions."

#: src/pages/UserManagementPage.tsx:220
msgid "You must be an administrator to access this page."
msgstr "You must be an administrator to access this page."

#: src/pages/OnboardingPage.tsx:531
msgid "You're a Privacy Engineer."
msgstr "You're a Privacy Engineer."

#: src/pages/OnboardingPage.tsx:206
msgid "You're In"
msgstr "You're In"

#: src/pages/SignupPage.tsx:598
msgid "You're in. Choose how you start."
msgstr "You're in. Choose how you start."

#: src/pages/SubscriptionPage.tsx:1188
msgid "You're on a free trial"
msgstr "You're on a free trial"

#. placeholder {0}: subscriptionDetails.discount.coupon.percent_off
#: src/pages/SubscriptionPage.tsx:979
msgid "You're saving {0}% off your subscription"
msgstr "You're saving {0}% off your subscription"

#. placeholder {0}: discountDollars.toFixed(2)
#: src/pages/SubscriptionPage.tsx:981
msgid "You're saving ${0} per {intervalName}"
msgstr "You're saving ${0} per {intervalName}"

#: src/pages/VerifyEmailPage.tsx:99
msgid "You're signed in. Redirecting…"
msgstr "You're signed in. Redirecting…"

#: src/components/UpgradeModal.tsx:417
msgid "Your account already exists, so we activate this one for you. Book a 15 minute call and we will switch it on while you are on it."
msgstr "Your account already exists, so we activate this one for you. Book a 15 minute call and we will switch it on while you are on it."

#: src/components/ProviderDetailModal.tsx:105
#: src/pages/DashboardPage.tsx:624
msgid "your activity"
msgstr "your activity"

#: src/pages/DashboardPage.tsx:581
msgid "Your AI Activity"
msgstr "Your AI Activity"

#: src/pages/OnboardingPage.tsx:324
msgid "Your Apps"
msgstr "Your Apps"

#: src/pages/OnboardingPage.tsx:214
#~ msgid "Your card is encrypted. You will not be charged until your {trialDays}-day trial ends."
#~ msgstr "Your card is encrypted. You will not be charged until your {trialDays}-day trial ends."

#: src/components/UpgradeModal.tsx:497
msgid "Your card was declined. Update your payment method on the Subscription page and try again."
msgstr "Your card was declined. Update your payment method on the Subscription page and try again."

#: src/pages/SignupPage.tsx:151
#~ msgid "Your card will be verified but not charged until your {trialDays}-day trial ends."
#~ msgstr "Your card will be verified but not charged until your {trialDays}-day trial ends."

#: src/pages/SignupPage.tsx:674
#~ msgid "Your card will be verified but not charged until your trial ends."
#~ msgstr "Your card will be verified but not charged until your trial ends."

#: src/pages/SubscriptionPage.tsx:1135
msgid "Your company has an active subscription. You can manage users and licenses from the User Management page."
msgstr "Your company has an active subscription. You can manage users and licenses from the User Management page."

#: src/pages/ConnectionsPage.tsx:1081
msgid "Your credentials are encrypted using AES-256 before storage and are never exposed in logs or API responses."
msgstr "Your credentials are encrypted using AES-256 before storage and are never exposed in logs or API responses."

#: src/pages/MemoryPage.tsx:1445
msgid "Your data"
msgstr "Your data"

#: src/pages/OnboardingPage.tsx:273
msgid "Your data is leaking, silently."
msgstr "Your data is leaking, silently."

#: src/components/UpgradeModal.tsx:509
msgid "Your existing subscription moves to Max using the card on file. The difference is prorated and charged immediately."
msgstr "Your existing subscription moves to Max using the card on file. The difference is prorated and charged immediately."

#: src/pages/MemoryPage.tsx:865
msgid "Your four profile blocks open each new conversation. Relevant notes are added only when they match what you type."
msgstr "Your four profile blocks open each new conversation. Relevant notes are added only when they match what you type."

#: src/pages/ConnectionsPage.tsx:944
msgid "Your HubSpot app (OAuth)"
msgstr "Your HubSpot app (OAuth)"

#: src/pages/OnboardingPage.tsx:354
msgid "Your input"
msgstr "Your input"

#: src/pages/ConnectionsPage.tsx:1213
msgid "Your integration is active and ready. PrivacyPal will begin scanning data according to your configuration."
msgstr "Your integration is active and ready. PrivacyPal will begin scanning data according to your configuration."

#: src/pages/SubscriptionPage.tsx:773
msgid "Your Max access is managed by PrivacyPal. There is nothing to pay here."
msgstr "Your Max access is managed by PrivacyPal. There is nothing to pay here."

#: src/pages/SignupPage.tsx:573
msgid "Your Max trial is live."
msgstr "Your Max trial is live."

#: src/pages/OnboardingPage.tsx:254
msgid "Your name"
msgstr "Your name"

#: src/pages/ConnectionsPage.tsx:639
#~ msgid "Your own HubSpot app (OAuth 2.0, recommended) with the callback URL shown in the wizard and read access to contacts, companies and deals, or a static access token from an app created in your HubSpot account with the same read scopes."
#~ msgstr "Your own HubSpot app (OAuth 2.0, recommended) with the callback URL shown in the wizard and read access to contacts, companies and deals, or a static access token from an app created in your HubSpot account with the same read scopes."

#: src/pages/ConnectionsPage.tsx:639
msgid "Your own HubSpot app (OAuth 2.0, recommended) with the callback URL shown in the wizard and read access to contacts, companies and deals, or an access token from a service key or legacy private app in your HubSpot account with the same read scopes."
msgstr "Your own HubSpot app (OAuth 2.0, recommended) with the callback URL shown in the wizard and read access to contacts, companies and deals, or an access token from a service key or legacy private app in your HubSpot account with the same read scopes."

#: src/pages/ConnectionsPage.tsx:630
msgid "Your own Salesforce Connected App (OAuth 2.0 Authorization Code + Refresh Token). Enable OAuth, register the callback URL shown in the wizard, and grant the api and refresh_token scopes with read access to Contact, Lead, Account, Case, Opportunity."
msgstr "Your own Salesforce Connected App (OAuth 2.0 Authorization Code + Refresh Token). Enable OAuth, register the callback URL shown in the wizard, and grant the api and refresh_token scopes with read access to Contact, Lead, Account, Case, Opportunity."

#: src/pages/OnboardingPage.tsx:208
msgid "Your Pal"
msgstr "Your Pal"

#: src/pages/ResetPasswordPage.tsx:98
msgid "Your password has been updated."
msgstr "Your password has been updated."

#: src/pages/SubscriptionPage.tsx:761
msgid "Your plan and upgrade options"
msgstr "Your plan and upgrade options"

#: src/pages/OnboardingPage.tsx:509
msgid "Your Privacy Agent is configured and waiting. Hit activate to go live."
msgstr "Your Privacy Agent is configured and waiting. Hit activate to go live."

#: src/pages/OnboardingPage.tsx:460
msgid "Your PrivacyPal desktop app is already configured. Once you complete setup, it will silently route all AI traffic through your personal protection layer."
msgstr "Your PrivacyPal desktop app is already configured. Once you complete setup, it will silently route all AI traffic through your personal protection layer."

#: src/pages/LoginPage.tsx:46
msgid "Your session has expired. Please sign in again to continue."
msgstr "Your session has expired. Please sign in again to continue."

#: src/pages/SubscriptionPage.tsx:702
msgid "Your subscription has been cancelled. You will have access until the end of your current billing period."
msgstr "Your subscription has been cancelled. You will have access until the end of your current billing period."

#: src/pages/OnboardingPage.tsx:700
#~ msgid "Your subscription is active"
#~ msgstr "Your subscription is active"

#: src/pages/OnboardingPage.tsx:714
#~ msgid "Your subscription is active. Let's bring PrivacyPal online."
#~ msgstr "Your subscription is active. Let's bring PrivacyPal online."

#: src/pages/SubscriptionPage.tsx:1058
msgid "Your subscription switches to PrivacyPal Max on your current {intervalWord} interval. The prorated difference for the rest of the current billing period is charged to your payment method immediately."
msgstr "Your subscription switches to PrivacyPal Max on your current {intervalWord} interval. The prorated difference for the rest of the current billing period is charged to your payment method immediately."

#: src/pages/SubscriptionPage.tsx:701
msgid "Your trial has been cancelled. You won't be charged."
msgstr "Your trial has been cancelled. You won't be charged."

#: src/pages/SubscriptionPage.tsx:1109
msgid "Your Trial Has Ended"
msgstr "Your Trial Has Ended"

#: src/pages/OnboardingPage.tsx:484
msgid "Zero data leaks"
msgstr "Zero data leaks"
